/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * Represents fractional signed decimal numeric values. To avoid floating-point
   * number precision problems, it's encoded as a string.
   */
  BigDecimal: { input: any; output: any; }
  /**
   * Represents non-fractional signed whole numeric values. Since the value may
   * exceed the size of a 32-bit integer, it's encoded as a string.
   */
  BigInt: { input: any; output: any; }
  /** Represents an email address, encoded as a String */
  EmailAddress: { input: any; output: any; }
  /** ID that returns an Integer for legacy numeric IDs (<= MAX_LEGACY_ID) and a String for new big IDs */
  HybridId: { input: any; output: any; }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: any; output: any; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any; }
  /** Represents untyped JSON */
  JSON: { input: any; output: any; }
  /** Represents a password, encoded as a String */
  Password: { input: any; output: any; }
  /** Represents a phone number, encoded as a String */
  PhoneNumberDigits: { input: any; output: any; }
  /** 6 character, upper-case alpha numeric Rewards code */
  RewardsCode: { input: any; output: any; }
  /** Formatted Time object */
  Time: { input: any; output: any; }
  /** Represents a UUID, encoded as a String */
  UUID: { input: any; output: any; }
};

export type AcceptMobileOrderingOrder = {
  id: Scalars['ID']['input'];
  version: Scalars['ID']['input'];
};

export type AccountBuildingInput = {
  accountId: Scalars['ID']['input'];
  buildingId: Scalars['String']['input'];
};

export enum AccountDeliveryMemberFilter {
  ALL = 'ALL',
  HAVE_NOT_ORDERED = 'HAVE_NOT_ORDERED',
  ORDERED = 'ORDERED'
}

export enum AccountDeliveryMemberSortField {
  EMAIL_ASC = 'EMAIL_ASC',
  EMAIL_DESC = 'EMAIL_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  STATUS_ASC = 'STATUS_ASC',
  STATUS_DESC = 'STATUS_DESC'
}

export enum AccountDeliveryOrderStatus {
  CANCELED = 'CANCELED',
  NO_ORDER = 'NO_ORDER',
  ORDERED = 'ORDERED'
}

/** Arguments to update an account member's permissions */
export type AccountPermission = {
  active: Scalars['Boolean']['input'];
  name: AccountRolePermission;
};

export enum AccountRoleEnum {
  ADMINISTRATOR = 'ADMINISTRATOR',
  CAFE_CASHIER = 'CAFE_CASHIER',
  MEMBER = 'MEMBER'
}

export enum AccountRolePermission {
  BILLING_ADMIN = 'BILLING_ADMIN',
  CATERING_ADMIN = 'CATERING_ADMIN',
  DELIVERY_ADMIN = 'DELIVERY_ADMIN',
  INVOICE_DETAILED_REPORT = 'INVOICE_DETAILED_REPORT',
  INVOICE_SUMMARY_REPORT = 'INVOICE_SUMMARY_REPORT',
  PANTRY_REPORTING = 'PANTRY_REPORTING',
  SUBSIDY_ADMIN = 'SUBSIDY_ADMIN'
}

/** Attributes for creating or updating an AccountingSiteOwner */
export type AccountingSiteOwnerInput = {
  effectiveEnd?: InputMaybe<Scalars['ISO8601Date']['input']>;
  effectiveStart?: InputMaybe<Scalars['ISO8601Date']['input']>;
  roleTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Arguments to activate a popup event */
export type ActivatePopupEvent = {
  id: Scalars['ID']['input'];
};

export type AddRewardsPoints = {
  points: Scalars['Int']['input'];
  requestToken: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type AddressInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export enum ApiVersion {
  MOBILE_ORDERING = 'MOBILE_ORDERING',
  POS_ORDER = 'POS_ORDER',
  POS_ORDER_LEGACY = 'POS_ORDER_LEGACY',
  SCAN_TO_PAY = 'SCAN_TO_PAY'
}

/** Attributes for creating or updating an AppVersionPolicy */
export type AppVersionPolicyInput = {
  forceVersions?: InputMaybe<Array<Scalars['String']['input']>>;
  minVersion?: InputMaybe<Scalars['String']['input']>;
  nextMinVersion?: InputMaybe<Scalars['String']['input']>;
  nextMinVersionDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  platform: Scalars['String']['input'];
};

/** Enum for different applications */
export enum ApplicationEnum {
  FOODA_FOR_BUSINESS = 'FOODA_FOR_BUSINESS',
  FOODA_FOR_RESTAURANTS = 'FOODA_FOR_RESTAURANTS',
  POINT_OF_SALE = 'POINT_OF_SALE',
  SNAPPEA = 'SNAPPEA'
}

export type AssignAccountPaymentCardToProduct = {
  /** Account payment method id of the card */
  id: Scalars['ID']['input'];
  product: ProductEnum;
  unassign?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AttachOrderRequestUser = {
  requestId: Scalars['UUID']['input'];
  userIdentifier: UserIdentifier;
};

export type AvailabilityDateInput = {
  available: Scalars['Boolean']['input'];
  date: Scalars['ISO8601Date']['input'];
};

export enum AvailabilityStatusEnum {
  /** Availability not yet submitted and is required */
  ACTION_REQUIRED = 'ACTION_REQUIRED',
  /** Monthly submission not required for product */
  NOT_REQUIRED = 'NOT_REQUIRED',
  /** Availability submitted for the target month */
  SUBMITTED = 'SUBMITTED'
}

export enum BannerPlatform {
  EMAIL = 'EMAIL',
  MOBILE = 'MOBILE',
  WEB = 'WEB'
}

export type BarcodeInput = {
  barcodeType: BarcodeTypes;
  barcodeValue?: InputMaybe<Scalars['String']['input']>;
};

export enum BarcodeTypes {
  FOODA_BARCODE_NUMBER = 'FOODA_BARCODE_NUMBER',
  PLU = 'PLU',
  UPC = 'UPC'
}

/** A Cafe Event Menu Tile Input */
export type CafeEventMenuTileInput = {
  popupEventLocationId: Scalars['Int']['input'];
  position: Scalars['Int']['input'];
  recordedCategoryId?: InputMaybe<Scalars['Int']['input']>;
  targetId?: InputMaybe<Scalars['BigInt']['input']>;
  targetType: CafeEventMenuTileTypeEnum;
};

export enum CafeEventMenuTileTypeEnum {
  POPUPPOPUPEVENTLOCATION = 'POPUPPOPUPEVENTLOCATION',
  POPUP_EVENT_MENU_GROUP = 'POPUP_EVENT_MENU_GROUP',
  POPUP_EVENT_MENU_ITEM = 'POPUP_EVENT_MENU_ITEM',
  POPUP_EVENT_VENDOR = 'POPUP_EVENT_VENDOR',
  SALES_OPTIMIZER_TO_FILL = 'SALES_OPTIMIZER_TO_FILL',
  SALE_OPTIMIZER_TO_FILL = 'SALE_OPTIMIZER_TO_FILL'
}

export type CafeScheduleMenuTile = {
  id?: InputMaybe<Scalars['Int']['input']>;
  position: Scalars['Int']['input'];
  recordedCategoryId?: InputMaybe<Scalars['Int']['input']>;
  stationId: Scalars['Int']['input'];
  type: MenuTileTypeEnum;
};

export type CalculateEventSubsidies = {
  codes: Array<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  product: SubsidyRuleProduct;
  totalCents: Scalars['Int']['input'];
};

export type CalculateMobileOrderingCart = {
  couponCode?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  eventVendorId: Scalars['ID']['input'];
  items: Array<MobileOrderingCartItem>;
  /** Subsidy code for a cart. Please send 'none' if no subsidy is applied, otherwise a default one will be applied */
  subsidyCode?: InputMaybe<Scalars['String']['input']>;
};

export type CalculateScanToPayCart = {
  couponCode?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  items: Array<ScanToPayInputCartItem>;
  /** Subsidy code for a cart. Please send 'none' if no subsidy is applied, otherwise a default one will be applied */
  subsidyCode?: InputMaybe<Scalars['String']['input']>;
};

export enum CampaignCategory {
  FEEDBACK = 'FEEDBACK',
  REWARDS = 'REWARDS'
}

export enum CampaignStrategy {
  DOUBLE = 'DOUBLE',
  VARIANT_1 = 'VARIANT_1',
  VARIANT_2 = 'VARIANT_2'
}

export type CancelDeliveryOrder = {
  cancelationRequestor?: InputMaybe<OrderCancelationRequestorEnum>;
  requestId: Scalars['ID']['input'];
};

export type CancelMobileOrderingOrder = {
  id: Scalars['ID']['input'];
  version: Scalars['ID']['input'];
};

export type CanceledPaymentGatewayInfo = {
  paymentGateway: PaymentGateway;
  response: UnpaidPaymentResponse;
};

export enum CardIssuer {
  AMERICAN_EXPRESS = 'AMERICAN_EXPRESS',
  APPLE_PAY_AMERICAN_EXPRESS = 'APPLE_PAY_AMERICAN_EXPRESS',
  APPLE_PAY_DISCOVER = 'APPLE_PAY_DISCOVER',
  APPLE_PAY_MASTERCARD = 'APPLE_PAY_MASTERCARD',
  APPLE_PAY_VISA = 'APPLE_PAY_VISA',
  APPLE_PAY_VISA_DISCOVER = 'APPLE_PAY_VISA_DISCOVER',
  DISCOVER = 'DISCOVER',
  GOOGLE_PAY_AMERICAN_EXPRESS = 'GOOGLE_PAY_AMERICAN_EXPRESS',
  GOOGLE_PAY_DISCOVER = 'GOOGLE_PAY_DISCOVER',
  GOOGLE_PAY_MASTERCARD = 'GOOGLE_PAY_MASTERCARD',
  GOOGLE_PAY_VISA = 'GOOGLE_PAY_VISA',
  GOOGLE_PAY_VISA_MAESTRO = 'GOOGLE_PAY_VISA_MAESTRO',
  JCB = 'JCB',
  MAESTRO = 'MAESTRO',
  MASTERCARD = 'MASTERCARD',
  PAYPAL = 'PAYPAL',
  UNIONPAY = 'UNIONPAY',
  UNKNOWN = 'UNKNOWN',
  VISA = 'VISA'
}

export enum CateringPackagingDetails {
  FAMILY_STYLE = 'FAMILY_STYLE',
  INDIVIDUALLY_PACKAGED = 'INDIVIDUALLY_PACKAGED'
}

export type ClearChatHistory = {
  conversationId?: InputMaybe<Scalars['String']['input']>;
};

export type CloudinaryResponseAttributes = {
  bytes: Scalars['Int']['input'];
  createdAt: Scalars['String']['input'];
  etag: Scalars['String']['input'];
  format: Scalars['String']['input'];
  height: Scalars['Int']['input'];
  originalFilename: Scalars['String']['input'];
  path: Scalars['String']['input'];
  placeholder: Scalars['Boolean']['input'];
  publicId: Scalars['String']['input'];
  resourceType: Scalars['String']['input'];
  secureUrl: Scalars['String']['input'];
  signature: Scalars['String']['input'];
  tags: Array<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
  version: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

/** Arguments to confirm a site directions token */
export type ConfirmSiteDirectionsToken = {
  digest: Scalars['String']['input'];
};

/** A complete Transcend preference snapshot from airgap.getConsent() after confirmed is true. */
export type ConsentPreferenceEventInput = {
  airgapVersion?: InputMaybe<Scalars['String']['input']>;
  consentGivenAt: Scalars['ISO8601DateTime']['input'];
  experienceSlug?: InputMaybe<Scalars['String']['input']>;
  legalRegimes: Array<Scalars['String']['input']>;
  /** Complete Transcend purpose preferences. */
  preferences: Array<ConsentPurposePreferenceInput>;
  privacySignals: Array<Scalars['String']['input']>;
};

export enum ConsentPreferenceValue {
  ALLOWED = 'ALLOWED',
  AUTO = 'AUTO',
  DENIED = 'DENIED'
}

export type ConsentPurposePreferenceInput = {
  purpose: Scalars['String']['input'];
  value: ConsentPreferenceValue;
};

export enum ConsumerDataRequestProcessingTimeEnum {
  DELAYED = 'DELAYED',
  NOW = 'NOW'
}

export enum ConsumerDataRequestStatusEnum {
  FULFILLED = 'FULFILLED',
  REFUSED = 'REFUSED',
  UNFULFILLED = 'UNFULFILLED'
}

export enum ConsumerDataRequestTypeEnum {
  EXPORT = 'EXPORT',
  REMOVAL = 'REMOVAL'
}

export type CreateAccountPaymentCard = {
  accountId: Scalars['ID']['input'];
  address?: InputMaybe<CreateCardAddressInput>;
  cardholderName?: InputMaybe<Scalars['String']['input']>;
  expiration?: InputMaybe<Scalars['String']['input']>;
  paymentMethodNonce: Scalars['String']['input'];
  processor?: InputMaybe<PaymentGateway>;
};

export type CreateAuthenticationDomain = {
  accountsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  authenticationProviderId: Scalars['ID']['input'];
  connectionId?: InputMaybe<Scalars['String']['input']>;
  domainName: Scalars['String']['input'];
  effectiveDate: Scalars['ISO8601DateTime']['input'];
  listOfUsers?: InputMaybe<Array<Scalars['String']['input']>>;
  mobileSessionExpiration?: InputMaybe<Scalars['Int']['input']>;
  mobileSessionTimeout?: InputMaybe<Scalars['Int']['input']>;
  organization: Scalars['String']['input'];
  organizationName: Scalars['String']['input'];
  scimEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  testMode?: InputMaybe<Scalars['Boolean']['input']>;
  useLoginHint?: InputMaybe<Scalars['Boolean']['input']>;
  webSessionExpiration?: InputMaybe<Scalars['Int']['input']>;
  webSessionTimeout?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateBanner = {
  content: Scalars['String']['input'];
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<BannerPlatform>;
  style: CreateStyle;
  title: Scalars['String']['input'];
};

export type CreateBiometricsToken = {
  password: Scalars['String']['input'];
};

export type CreateCafeEventSchedule = {
  accountId: Scalars['ID']['input'];
  attributes: CreateCafeEventScheduleAttributes;
};

export type CreateCafeEventScheduleAttributes = {
  cafeLocationId: Scalars['ID']['input'];
  emailListId?: InputMaybe<Scalars['String']['input']>;
  eventEndTime: Scalars['Time']['input'];
  eventEndTimeOffsetInDays: Scalars['Int']['input'];
  eventScheduleOwnerId?: InputMaybe<Scalars['ID']['input']>;
  eventStartTime: Scalars['Time']['input'];
  finalEmail?: InputMaybe<EmailConfigurationInput>;
  fixedPricePerConsumerCents?: InputMaybe<Scalars['Int']['input']>;
  introductionEmail?: InputMaybe<EmailConfigurationInput>;
  minSalesGuaranteeCents?: InputMaybe<Scalars['Int']['input']>;
  pauseEndDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  pauseStartDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  scheduleEndDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  scheduleFrequency: ScheduleFrequencyInput;
  scheduleStartDate: Scalars['ISO8601DateTime']['input'];
};

export type CreateCafeEventScheduleStation = {
  attributes: CreateCafeEventScheduleStationAttributes;
  cafeEventScheduleId: Scalars['ID']['input'];
};

export type CreateCafeEventScheduleStationAttributes = {
  endTime: Scalars['Time']['input'];
  endTimeOffsetInDays: Scalars['Int']['input'];
  mealPeriod?: InputMaybe<MealPeriodEnum>;
  menuTemplateId?: InputMaybe<Scalars['ID']['input']>;
  pickupOrderingWindows?: InputMaybe<Array<PickupOrderingWindowInput>>;
  positionOnCafeMenu: Scalars['Int']['input'];
  prepFor?: InputMaybe<Scalars['Int']['input']>;
  setupTimeMinutes: Scalars['Int']['input'];
  startTime: Scalars['Time']['input'];
  stationId: Scalars['ID']['input'];
  stationType: StationTypes;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateCafeEventStation = {
  cafeEventId: Scalars['ID']['input'];
  cafeEventStationAttributes: CreateCafeEventStationAttributes;
};

export type CreateCafeEventStationAttributes = {
  endTime: Scalars['ISO8601DateTime']['input'];
  mealPeriod?: InputMaybe<MealPeriodEnum>;
  menuTemplateId: Scalars['ID']['input'];
  positionOnCafeMenu: Scalars['Int']['input'];
  prepFor: Scalars['Int']['input'];
  setupTimeMinutes: Scalars['Int']['input'];
  startTime: Scalars['ISO8601DateTime']['input'];
  stationId: Scalars['ID']['input'];
  stationType: StationTypes;
  vendorId: Scalars['ID']['input'];
};

export type CreateCafeLocation = {
  accountId: Scalars['ID']['input'];
  attributes: CreateCafeLocationAttributes;
};

export type CreateCafeLocationAttributes = {
  accessibleToPublic?: InputMaybe<Scalars['Boolean']['input']>;
  audienceSize?: InputMaybe<Scalars['Int']['input']>;
  buildingId: Scalars['Int']['input'];
  contactId?: InputMaybe<Scalars['Int']['input']>;
  hideFromScheduling?: InputMaybe<Scalars['Boolean']['input']>;
  hideFromSearch?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type CreateCafeStation = {
  cafeLocationId: Scalars['ID']['input'];
  cafeStationAttributes: CreateCafeStationAttributes;
};

export type CreateCafeStationAttributes = {
  hideFromScheduling?: InputMaybe<Scalars['Boolean']['input']>;
  menuType?: InputMaybe<Menu>;
  mobileOrderCapacityPercentage?: InputMaybe<Scalars['Int']['input']>;
  mobileOrderingDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  mobileOrderingExtended?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type CreateCampaign = {
  bannerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  category: CampaignCategory;
  endsAt: Scalars['ISO8601DateTime']['input'];
  startsAt: Scalars['ISO8601DateTime']['input'];
  strategy?: InputMaybe<CampaignStrategy>;
  threadId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateCampaignUsers = {
  campaignId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

export type CreateCard = {
  address: CreateCardAddressInput;
  cardToken: Scalars['String']['input'];
  cardholderName?: InputMaybe<Scalars['String']['input']>;
  expiration?: InputMaybe<Scalars['String']['input']>;
  makeDefault?: InputMaybe<Scalars['Boolean']['input']>;
  makeDefaultDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  processor: PaymentGateway;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCardAddressInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipCode: Scalars['String']['input'];
};

export type CreateCateringInventoryItem = {
  attributes: CreateCateringInventoryItemAttributes;
  vendorId: Scalars['ID']['input'];
};

export type CreateCateringInventoryItemAttributes = {
  cogs?: InputMaybe<Scalars['BigDecimal']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dietaryRestrictions?: InputMaybe<Array<InventoryItemDietaryRestrictions>>;
  eligibleForAddOns?: InputMaybe<Scalars['Boolean']['input']>;
  externalTags?: InputMaybe<Array<InventoryItemExternalTags>>;
  feedsMax?: InputMaybe<Scalars['Int']['input']>;
  feedsMin?: InputMaybe<Scalars['Int']['input']>;
  foodaSku?: InputMaybe<Scalars['String']['input']>;
  internalTags?: InputMaybe<Array<InventoryItemInternalTags>>;
  mealType?: InputMaybe<InventoryItemMealType>;
  minSelfServiceQuantity?: InputMaybe<Scalars['Int']['input']>;
  nameForVendor: Scalars['String']['input'];
  namePublic: Scalars['String']['input'];
  packagingDetails?: InputMaybe<CateringPackagingDetails>;
  premiumCogs?: InputMaybe<Scalars['BigDecimal']['input']>;
  premiumSellPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  retailPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  sellPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  taxCategoryId?: InputMaybe<Scalars['Int']['input']>;
  useAsInventoryItemOption?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateCateringUserAccount = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  accountName?: InputMaybe<Scalars['String']['input']>;
  address1?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isRecaptchaV2?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locationName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  passwordConfirmation?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  recaptchaToken: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateConsumerDataRequest = {
  action: ConsumerDataRequestTypeEnum;
  processingTime?: InputMaybe<ConsumerDataRequestProcessingTimeEnum>;
};

export type CreateCrossDock = {
  address: AddressInput;
  dropOffInstruction?: InputMaybe<Scalars['String']['input']>;
  marketIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  merchantId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  pickupInstruction?: InputMaybe<Scalars['String']['input']>;
  status: CrossDockStatus;
};

export type CreateDeliveryInventoryItem = {
  attributes: CreateDeliveryInventoryItemAttributes;
  vendorId: Scalars['ID']['input'];
};

export type CreateDeliveryInventoryItemAttributes = {
  capacityExempt?: InputMaybe<Scalars['Boolean']['input']>;
  cogs: Scalars['BigDecimal']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  dietaryRestrictions?: InputMaybe<Array<InventoryItemDietaryRestrictions>>;
  disallowWriteIn?: InputMaybe<Scalars['Boolean']['input']>;
  eligibleForAddOns?: InputMaybe<Scalars['Boolean']['input']>;
  externalTags?: InputMaybe<Array<InventoryItemExternalTags>>;
  foodaSku?: InputMaybe<Scalars['String']['input']>;
  internalTags?: InputMaybe<Array<InventoryItemInternalTags>>;
  mealType?: InputMaybe<InventoryItemMealType>;
  nameForVendor: Scalars['String']['input'];
  namePublic: Scalars['String']['input'];
  premiumSellPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  prepLine?: InputMaybe<Scalars['Int']['input']>;
  sellPrice: Scalars['BigDecimal']['input'];
  showOnMenu?: InputMaybe<Scalars['Boolean']['input']>;
  signatureItem?: InputMaybe<Scalars['Boolean']['input']>;
  taxCategoryId?: InputMaybe<Scalars['Int']['input']>;
  temperatureClassification?: InputMaybe<InventoryItemTemperatureClassification>;
  useAsInventoryItemOption?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateDeliveryVendorMarketCapacity = {
  capacity: Scalars['Int']['input'];
  marketManifestTimeId: Scalars['ID']['input'];
  vendorConstraintId: Scalars['ID']['input'];
};

export type CreateFeedbackResponse = {
  comments?: InputMaybe<Scalars['String']['input']>;
  feedbackRequestId: Scalars['ID']['input'];
  rating: Scalars['Int']['input'];
  reviews?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Onboard a pull-funding bank account from a client-side bank-account token (btok_...) */
export type CreateFoodaCardBankAccount = {
  accountHolderEmail?: InputMaybe<Scalars['String']['input']>;
  accountHolderName: Scalars['String']['input'];
  bankAccountToken: Scalars['String']['input'];
  mandateAcceptedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  stripeAccountId: Scalars['ID']['input'];
};

/** Manually create a top-up (pull funds) for a connected account's Issuing balance */
export type CreateFoodaCardTopup = {
  amountCents: Scalars['Int']['input'];
  bankAccountId?: InputMaybe<Scalars['ID']['input']>;
  stripeAccountId: Scalars['ID']['input'];
};

export type CreateGuestPasses = {
  accountId: Scalars['ID']['input'];
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  printablePassCount?: InputMaybe<Scalars['Int']['input']>;
  subsidyRuleAttributes: SubsidyRuleAttributes;
};

/** Create Limits Group */
export type CreateLimitsGroup = {
  maxDailyCostCents?: InputMaybe<Scalars['Int']['input']>;
  maxMonthlyCostCents?: InputMaybe<Scalars['Int']['input']>;
  maxSessionCostCents?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type CreateMarket = {
  accountingMarketName?: InputMaybe<Scalars['String']['input']>;
  active: Scalars['Boolean']['input'];
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  checkAverage?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  defaultAccountantId: Scalars['ID']['input'];
  defaultCrossDockId?: InputMaybe<Scalars['ID']['input']>;
  defaultOperationEmail?: InputMaybe<Scalars['String']['input']>;
  defaultTaxRate?: InputMaybe<Scalars['Float']['input']>;
  defaultTaxRemitter?: InputMaybe<TaxRemitter>;
  deliverySupportPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  directorId?: InputMaybe<Scalars['ID']['input']>;
  displayCommission: Scalars['Boolean']['input'];
  healthDepartmentJurisdictions?: InputMaybe<Array<HealthDepartmentJurisdictionInput>>;
  marketCohortName?: InputMaybe<Scalars['String']['input']>;
  marketManifestTime?: InputMaybe<MarketManifestTimeInput>;
  name: Scalars['String']['input'];
  noDefaultCrossDock?: InputMaybe<Scalars['Boolean']['input']>;
  officeDefaultEmail?: InputMaybe<Scalars['String']['input']>;
  officeDefaultFax?: InputMaybe<Scalars['String']['input']>;
  officeDefaultPhone?: InputMaybe<Scalars['String']['input']>;
  officeDefaultSms?: InputMaybe<Scalars['String']['input']>;
  popupSupportPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
  zipCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateMenuTemplateCategoryGroupAttributes = {
  name: Scalars['String']['input'];
  selectedInventoryItems: Array<MenuTemplateInventoryItemAttributes>;
};

export type CreateMobileOrderingOrderRequest = {
  coupon?: InputMaybe<MobileOrderingOrderRequestCoupon>;
  eventVendorId: Scalars['ID']['input'];
  idempotencyKey: Scalars['UUID']['input'];
  items: Array<MobileOrderingOrderRequestItem>;
  payment?: InputMaybe<MobileOrderingPayment>;
  pickupTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  subsidy?: InputMaybe<MobileOrderingOrderRequestSubsidy>;
};

/** Create a new model version */
export type CreateModelVersionInput = {
  changeNotes: Scalars['String']['input'];
  /** Configuration fields to override (e.g., {'prompt_instructions': 'new prompt'} for LLM models) */
  configurationOverrides?: InputMaybe<Scalars['JSON']['input']>;
  /** Optional new model name/alias */
  name?: InputMaybe<Scalars['String']['input']>;
  sourceModelId: Scalars['ID']['input'];
  /** Either 'major' or 'minor' */
  versionType: Scalars['String']['input'];
};

export type CreateOrderRequest = {
  clientCreatedAt: Scalars['ISO8601DateTime']['input'];
  /** DEPRECATED: use userIdentifier for phone input */
  customerPhoneNumber?: InputMaybe<Scalars['PhoneNumberDigits']['input']>;
  discounts?: InputMaybe<Array<OrderDiscount>>;
  eventId: Scalars['ID']['input'];
  isSelfCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  items: Array<OrderItem>;
  paymentGatewayInfo?: InputMaybe<PaymentGatewayInfo>;
  paymentMethod: OrderRequestPaymentMethod;
  /** DEPRECATED: End of support in 2023 */
  paypalInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  /** DEPRECATED: End of support in 2023 */
  paypalResponse?: InputMaybe<PaypalResponse>;
  receiptRequest?: InputMaybe<OrderReceiptRequest>;
  requestId: Scalars['UUID']['input'];
  terminalId?: InputMaybe<Scalars['String']['input']>;
  transactedOnline: Scalars['Boolean']['input'];
  userIdentifier?: InputMaybe<UserIdentifier>;
};

export type CreatePhysicalSecurityResponse = {
  device: DeviceAttributes;
  responses: Array<PhysicalSecurityResponse>;
};

export type CreatePopupInventoryItem = {
  attributes: CreatePopupInventoryItemAttributes;
  taxRuleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vendorId: Scalars['ID']['input'];
};

export type CreatePopupInventoryItemAttributes = {
  availableInPersonOnly?: InputMaybe<Scalars['Boolean']['input']>;
  barcodeIdentifier?: InputMaybe<BarcodeInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  dietaryRestrictions?: InputMaybe<Array<InventoryItemDietaryRestrictions>>;
  disallowWriteIn?: InputMaybe<Scalars['Boolean']['input']>;
  externalTags?: InputMaybe<Array<InventoryItemExternalTags>>;
  foodaSku?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  mealType?: InputMaybe<InventoryItemMealType>;
  nameForVendor: Scalars['String']['input'];
  namePublic: Scalars['String']['input'];
  preTaxPrice: Scalars['BigDecimal']['input'];
  priceType: PriceTypeEnum;
  showOnMenu?: InputMaybe<Scalars['Boolean']['input']>;
  showOnPos?: InputMaybe<Scalars['Boolean']['input']>;
  taxCategoryId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreatePopupMenuTemplate = {
  popupMenuTemplateAttributes: PopupMenuTemplateAttributes;
  vendorId: Scalars['ID']['input'];
};

export type CreatePopupMenuTemplateCategoryGroup = {
  menuTemplateCategoryGroupAttributes: CreateMenuTemplateCategoryGroupAttributes;
  menuTemplateId: Scalars['ID']['input'];
};

export type CreatePopupMenuTemplateSelectionGroup = {
  defaultSelectionInventoryItemId?: InputMaybe<Scalars['ID']['input']>;
  maxSelections: Scalars['Int']['input'];
  minSelections: Scalars['Int']['input'];
  nameForVendor: Scalars['String']['input'];
  namePublic: Scalars['String']['input'];
  parentItemId: Scalars['ID']['input'];
  selectedInventoryItems: Array<MenuTemplateSelectionGroupItemAttributes>;
};

/** Create Report Configuration input */
export type CreateReportConfigurationInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  headline: Scalars['String']['input'];
  iconName: Scalars['String']['input'];
  menuTitle: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  reportType: ReportConfigurationTypeEnum;
  requiredRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  subtitle: Scalars['String']['input'];
  tableauDesktopUrl: Scalars['String']['input'];
  tableauMobileUrl: Scalars['String']['input'];
  terms: Array<TermsWithDescriptionInput>;
};

export type CreateSelectEventVendor = {
  selectEventId: Scalars['ID']['input'];
  selectEventVendorAttributes: CreateSelectEventVendorAttributes;
};

export type CreateSelectEventVendorAttributes = {
  crossDockId?: InputMaybe<Scalars['ID']['input']>;
  deliveryVendorId: Scalars['ID']['input'];
  menuTemplateId: Scalars['ID']['input'];
  prepFor?: InputMaybe<Scalars['Int']['input']>;
  status: Scalars['String']['input'];
  vendorId: Scalars['ID']['input'];
};

export type CreateSession = {
  biometricsToken?: InputMaybe<Scalars['String']['input']>;
  device?: InputMaybe<DeviceAttributes>;
  getBiometricsToken?: InputMaybe<Scalars['Boolean']['input']>;
  nonce?: InputMaybe<Scalars['String']['input']>;
  omniauthRequest?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  posOperator?: InputMaybe<Scalars['Boolean']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSignedUploadLink = {
  documentType: UploadLinkDocument;
};

export type CreateStyle = {
  bodyTextColor: Scalars['String']['input'];
  borderColor: Scalars['String']['input'];
  fillColor: Scalars['String']['input'];
  titleTextColor: Scalars['String']['input'];
};

export type CreateSubsidyRule = {
  accountId: Scalars['ID']['input'];
  autoApply: Scalars['Boolean']['input'];
  coverageDescriptionOverride?: InputMaybe<Scalars['String']['input']>;
  dailyMaxCents?: InputMaybe<Scalars['Int']['input']>;
  daysAvailable: Array<Day>;
  displayPreSubsidyPrice: Scalars['Boolean']['input'];
  endsAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  eventMaxCents?: InputMaybe<Scalars['Int']['input']>;
  externalTags?: InputMaybe<Array<InventoryItemExternalTags>>;
  foodaCardStripeAccountId?: InputMaybe<Scalars['ID']['input']>;
  hasFoodaCardProgram?: InputMaybe<Scalars['Boolean']['input']>;
  locationRestriction?: InputMaybe<SubsidyLocationRestrictionEnum>;
  mealTypes?: InputMaybe<Array<InventoryItemMealType>>;
  minOrderCents: Scalars['Int']['input'];
  monthlyMaxCents?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  noQr: Scalars['Boolean']['input'];
  percentageCap: Scalars['BigDecimal']['input'];
  /** Item-level only: when true, min_order_cents and event_max_cents are interpreted as pre-tax. */
  preTaxEmployeeContribution?: InputMaybe<Scalars['Boolean']['input']>;
  product: SubsidyRuleProduct;
  /**
   * Max $ per user for the whole program (declining balance). Order-level QR
   * programs only: not allowed with no_qr or auto_apply.
   */
  programMaxCents?: InputMaybe<Scalars['Int']['input']>;
  redemptionsPerDay?: InputMaybe<Scalars['Int']['input']>;
  ruleType: SubsidyRuleTypeEnum;
  /**
   * Order-level QR member programs only: when true, members added to or joining
   * this program get an active subsidy without confirming their email first.
   */
  skipEmailVerification?: InputMaybe<Scalars['Boolean']['input']>;
  specificAccountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  startsAt: Scalars['ISO8601DateTime']['input'];
  subsidyType: SubsidyTypeEnum;
  supportedMealPeriods?: InputMaybe<Array<MealPeriodEnum>>;
  timeZone: SubsidyTimezone;
  validEverywhere: Scalars['Boolean']['input'];
  weeklyMaxCents?: InputMaybe<Scalars['Int']['input']>;
  weeklyRecurrence: Scalars['Int']['input'];
};

/** Create Tax Category */
export type CreateTaxCategory = {
  categoryType: TaxCategoryTypeEnum;
  code: Scalars['String']['input'];
  isSync?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTempUser = {
  consentPhoneVerification?: InputMaybe<Scalars['Boolean']['input']>;
  consentSmsPromotions?: InputMaybe<Scalars['Boolean']['input']>;
  device?: InputMaybe<DeviceAttributes>;
  email: Scalars['EmailAddress']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['Password']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  recaptchaToken: Scalars['String']['input'];
  referralCode?: InputMaybe<Scalars['String']['input']>;
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
  shortMessageServiceContactId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateTenderMethodInput = {
  /** Account IDs that can use this tender method */
  accountIds: Array<Scalars['ID']['input']>;
  /** Days of the week when tender method is available (defaults to weekdays) */
  daysAvailable: Array<Day>;
  /** End date for the tender method */
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** External system identifier */
  externalId: Scalars['String']['input'];
  /** Name of the tender method program */
  name: Scalars['String']['input'];
  /** Product type this tender method applies to */
  productType: ProductEnum;
  /** Start date for the tender method */
  startDate: Scalars['ISO8601DateTime']['input'];
  /** Timezone for the tender method schedule (defaults to Central) */
  timezone: Timezone;
};

export type CreateUser = {
  device?: InputMaybe<DeviceAttributes>;
  email: Scalars['EmailAddress']['input'];
  firstName: Scalars['String']['input'];
  isRecaptchaV2?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  omniauthRequest?: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['Password']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  recaptchaToken: Scalars['String']['input'];
  referrals?: InputMaybe<ReferralAttributes>;
  shortMessageServiceContactId?: InputMaybe<Scalars['ID']['input']>;
};

export enum CreateUserErrorCodeEnum {
  /** Error code 409 */
  DUPLICATE_EMAIL = 'DUPLICATE_EMAIL',
  /** Error code 422 */
  REFERRAL_CODE = 'REFERRAL_CODE',
  /** Error code 400 */
  USER_FACTORY = 'USER_FACTORY'
}

export type CreateUserNote = {
  note: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type CreateVerificationRequest = {
  tempUserId?: InputMaybe<Scalars['ID']['input']>;
  verificationMethod: UserVerificationMethod;
};

export enum CrossDockStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

/** Cross Sell recommendation request */
export type CrossSellRequestInput = {
  /** Array of menu items for cross-sell recommendations */
  items: Array<RecommendationItemInput>;
};

export enum CuisineNames {
  AFRICAN = 'AFRICAN',
  AMERICAN = 'AMERICAN',
  ARGENTINE = 'ARGENTINE',
  ASIAN = 'ASIAN',
  AUSTRALIAN = 'AUSTRALIAN',
  BAKERY = 'BAKERY',
  BARBECUE = 'BARBECUE',
  BBQ = 'BBQ',
  BRAZILIAN = 'BRAZILIAN',
  BREAKFAST = 'BREAKFAST',
  BURGERS = 'BURGERS',
  BURMESE = 'BURMESE',
  CAJUN = 'CAJUN',
  CAMBODIAN = 'CAMBODIAN',
  CARIBBEAN = 'CARIBBEAN',
  CHICKEN_SANDWICHES = 'CHICKEN_SANDWICHES',
  CHINESE = 'CHINESE',
  COFFEE_AND_TEA = 'COFFEE_AND_TEA',
  COMFORT = 'COMFORT',
  CUBAN = 'CUBAN',
  DELI = 'DELI',
  DESSERT = 'DESSERT',
  EASTERN_EUROPEAN = 'EASTERN_EUROPEAN',
  EGYPTIAN = 'EGYPTIAN',
  ENGLISH = 'ENGLISH',
  ETHIOPIAN = 'ETHIOPIAN',
  FAST_FOOD = 'FAST_FOOD',
  FRENCH = 'FRENCH',
  FRIED_CHICKEN = 'FRIED_CHICKEN',
  GERMAN = 'GERMAN',
  GREEK = 'GREEK',
  GRILL = 'GRILL',
  HALAL = 'HALAL',
  HAWAIIAN = 'HAWAIIAN',
  HEALTHY = 'HEALTHY',
  HOT_DOGS = 'HOT_DOGS',
  ICE_CREAM = 'ICE_CREAM',
  INDIAN = 'INDIAN',
  INDONESIAN = 'INDONESIAN',
  IRISH = 'IRISH',
  ISRAELI = 'ISRAELI',
  ITALIAN = 'ITALIAN',
  JAMAICAN = 'JAMAICAN',
  JAPANESE = 'JAPANESE',
  KOREAN = 'KOREAN',
  LATIN_AMERICAN = 'LATIN_AMERICAN',
  LEBANESE = 'LEBANESE',
  MEDITERRANEAN = 'MEDITERRANEAN',
  MEXICAN = 'MEXICAN',
  MICRO_MARKET = 'MICRO_MARKET',
  MIDDLE_EASTERN = 'MIDDLE_EASTERN',
  MOROCCAN = 'MOROCCAN',
  OFFICE_COFFEE_SOLUTION = 'OFFICE_COFFEE_SOLUTION',
  PANTRY = 'PANTRY',
  PASTA = 'PASTA',
  PERUVIAN = 'PERUVIAN',
  PHILIPPINE = 'PHILIPPINE',
  PIZZA = 'PIZZA',
  POKE = 'POKE',
  POLISH = 'POLISH',
  PUB_FOOD = 'PUB_FOOD',
  RAMEN = 'RAMEN',
  SALADS = 'SALADS',
  SANDWICHES = 'SANDWICHES',
  SEAFOOD = 'SEAFOOD',
  SMOOTHIES_AND_JUICES = 'SMOOTHIES_AND_JUICES',
  SOUL_FOOD = 'SOUL_FOOD',
  SOUP = 'SOUP',
  SOUTHERN = 'SOUTHERN',
  SPANISH = 'SPANISH',
  STEAKHOUSES = 'STEAKHOUSES',
  SUBS = 'SUBS',
  SUSHI = 'SUSHI',
  TEX_MEX = 'TEX_MEX',
  THAI = 'THAI',
  TURKISH = 'TURKISH',
  UKRAINIAN = 'UKRAINIAN',
  VEGAN = 'VEGAN',
  VEGETARIAN = 'VEGETARIAN',
  VENDING = 'VENDING',
  VIETNAMESE = 'VIETNAMESE',
  WINGS = 'WINGS'
}

export type CustomInvoiceInput = {
  amountCents: Scalars['Int']['input'];
  externalId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  generatedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  invoiceDate: Scalars['ISO8601Date']['input'];
  outstandingBalanceCents?: InputMaybe<Scalars['Int']['input']>;
  parties: Array<CustomInvoicePartyInput>;
  persistedKey: Scalars['String']['input'];
  products: Array<ProductEnum>;
  replacesConsolidatedInvoiceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sentAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  sentToEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export enum CustomInvoiceMemberTypeEnum {
  ACCOUNT = 'ACCOUNT',
  ACCOUNT_PARENT = 'ACCOUNT_PARENT',
  LOCATION = 'LOCATION'
}

export type CustomInvoicePartyInput = {
  partyId: Scalars['Int']['input'];
  partyType: Scalars['String']['input'];
};

export type CustomInvoiceSettingsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  members: Array<CustomInvoiceSettingsMemberInput>;
  name: Scalars['String']['input'];
  products: Array<ProductEnum>;
  splitAttributes?: InputMaybe<Array<CustomInvoiceSplitAttributeInput>>;
};

export type CustomInvoiceSettingsMemberInput = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  memberType: CustomInvoiceMemberTypeEnum;
  parentCompanyId?: InputMaybe<Scalars['ID']['input']>;
};

export enum CustomInvoiceSplitAttributeCountQualityEnum {
  EXACT = 'EXACT',
  UNAVAILABLE = 'UNAVAILABLE',
  UPPER_BOUND = 'UPPER_BOUND'
}

export type CustomInvoiceSplitAttributeInput = {
  type: CustomInvoiceSplitAttributeTypeEnum;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum CustomInvoiceSplitAttributeTypeEnum {
  CATERING_EVENT_NAME = 'CATERING_EVENT_NAME',
  CLIENT_DEFINED_SERVICE = 'CLIENT_DEFINED_SERVICE',
  DAY_OF_SERVICE = 'DAY_OF_SERVICE',
  DEPARTMENT_PO = 'DEPARTMENT_PO',
  LOCATION = 'LOCATION',
  PRODUCT = 'PRODUCT',
  SUBSIDY_PROGRAM = 'SUBSIDY_PROGRAM'
}

export enum CustomerOrderPaymentMethodEnum {
  CARD = 'CARD',
  CASH = 'CASH',
  DISCOUNT = 'DISCOUNT'
}

export enum DateRecurrence {
  DAILY_FREQUENCY = 'DAILY_FREQUENCY',
  MONTHLY_BY_DAY_OF_MONTH_FREQUENCY = 'MONTHLY_BY_DAY_OF_MONTH_FREQUENCY',
  MONTHLY_BY_DAY_OF_WEEK_FREQUENCY = 'MONTHLY_BY_DAY_OF_WEEK_FREQUENCY',
  WEEKLY_FREQUENCY = 'WEEKLY_FREQUENCY',
  YEARLY_FREQUENCY = 'YEARLY_FREQUENCY'
}

export enum Day {
  FRIDAY = 'FRIDAY',
  MONDAY = 'MONDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
  THURSDAY = 'THURSDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY'
}

export type DeclineMobileOrderingOrder = {
  id: Scalars['ID']['input'];
  version: Scalars['ID']['input'];
};

export type DeleteAccountPaymentCard = {
  /** Account payment method id of the card */
  id: Scalars['ID']['input'];
};

export type DeleteCafeEventSchedule = {
  id: Scalars['ID']['input'];
};

export type DeleteCafeEventScheduleStation = {
  id: Scalars['ID']['input'];
};

export type DeleteCampaignUsers = {
  campaignId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

/** Arguments to delete a card */
export type DeleteCard = {
  cardId: Scalars['ID']['input'];
};

export type DeleteCateringInventoryItem = {
  /** ID of the Catering Inventory Item */
  id: Scalars['ID']['input'];
};

export type DeleteDeliveryInventoryItem = {
  /** ID of the Delivery Inventory Item */
  id: Scalars['ID']['input'];
};

export type DeletePopupInventoryItem = {
  /** ID of the Popup Inventory Item */
  id: Scalars['ID']['input'];
};

export type DeletePopupMenuTemplateCategoryGroup = {
  id: Scalars['ID']['input'];
};

export type DeletePopupMenuTemplateSelectionGroup = {
  selectionGroupId: Scalars['ID']['input'];
};

/** Delete Report Configuration input */
export type DeleteReportConfigurationInput = {
  /** ID of the Report Configuration */
  id: Scalars['ID']['input'];
};

export type DeleteSelectEventVendor = {
  selectEventVendorId: Scalars['ID']['input'];
};

/** Arguments to delete a session */
export type DeleteSession = {
  password?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

/** Arguments to delete a subsidy rule */
export type DeleteSubsidyRule = {
  id: Scalars['ID']['input'];
};

/** Party that carries the cost of a delivery order refund */
export enum DeliveryRefundPartyAtFaultEnum {
  /** The courier that delivered the order */
  DELIVERY_VENDOR = 'DELIVERY_VENDOR',
  /** Fooda */
  FOODA = 'FOODA',
  /** The restaurant that sold the item */
  VENDOR = 'VENDOR'
}

/** Reason recorded against a delivery order refund */
export enum DeliveryRefundReasonEnum {
  CUSTOMIZATION_NOT_FOLLOWED = 'CUSTOMIZATION_NOT_FOLLOWED',
  FOOD_QUALITY = 'FOOD_QUALITY',
  LATE_ORDER = 'LATE_ORDER',
  MISSING_ITEMS = 'MISSING_ITEMS',
  WRONG_ITEM = 'WRONG_ITEM'
}

/** Whether a delivery order in order history is still on its way */
export enum DeliveryTimingState {
  /** Every restaurant on the order has arrived, or the delivery confirmation wait has passed */
  DELIVERED = 'DELIVERED',
  /** A restaurant on the order has not arrived yet and the delivery confirmation wait has not passed */
  DELIVERING = 'DELIVERING'
}

export type DeviceAttributes = {
  deviceId: Scalars['String']['input'];
  deviceName: Scalars['String']['input'];
  devicePlatform: Scalars['String']['input'];
  osVersion: Scalars['String']['input'];
};

export enum DiscountLineItemTypeEnum {
  CASHIER_DISCOUNT = 'CASHIER_DISCOUNT',
  COUPON = 'COUPON',
  DELIVERY_FEE_SUBSIDY = 'DELIVERY_FEE_SUBSIDY',
  DELIVERY_TAX_SUBSIDY = 'DELIVERY_TAX_SUBSIDY',
  INVALID_COUPON = 'INVALID_COUPON',
  INVALID_SUBSIDY = 'INVALID_SUBSIDY',
  INVALID_TENDER_METHOD = 'INVALID_TENDER_METHOD',
  INVALID_VOUCHER = 'INVALID_VOUCHER',
  ITEM_SUBSIDY = 'ITEM_SUBSIDY',
  PROMOTION = 'PROMOTION',
  REWARD_REDEMPTION = 'REWARD_REDEMPTION',
  SUBSIDY = 'SUBSIDY',
  TENDER_METHOD = 'TENDER_METHOD',
  VOUCHER = 'VOUCHER',
  VOUCHER_CHANGE = 'VOUCHER_CHANGE'
}

export enum DiscountRefundLineItemTypeEnum {
  CASHIER_DISCOUNT_REFUND = 'CASHIER_DISCOUNT_REFUND',
  COUPON_REFUND = 'COUPON_REFUND',
  DELIVERY_FEE_SUBSIDY_REFUND = 'DELIVERY_FEE_SUBSIDY_REFUND',
  DELIVERY_TAX_SUBSIDY_REFUND = 'DELIVERY_TAX_SUBSIDY_REFUND',
  INVALID_COUPON_REFUND = 'INVALID_COUPON_REFUND',
  INVALID_SUBSIDY_REFUND = 'INVALID_SUBSIDY_REFUND',
  INVALID_TENDER_METHOD_REFUND = 'INVALID_TENDER_METHOD_REFUND',
  INVALID_VOUCHER_REFUND = 'INVALID_VOUCHER_REFUND',
  ITEM_SUBSIDY_REFUND = 'ITEM_SUBSIDY_REFUND',
  REWARD_REDEMPTION_REFUND = 'REWARD_REDEMPTION_REFUND',
  SUBSIDY_REFUND = 'SUBSIDY_REFUND',
  TENDER_METHOD_REFUND = 'TENDER_METHOD_REFUND',
  VOUCHER_REFUND = 'VOUCHER_REFUND'
}

export enum DomainEnum {
  /** AccountingSite Domain */
  ACCOUNTING_SITE = 'ACCOUNTING_SITE',
  /** AccountingSiteOwnership Domain */
  ACCOUNTING_SITE_OWNERSHIP = 'ACCOUNTING_SITE_OWNERSHIP',
  /** AccountingSiteRoleType Domain */
  ACCOUNTING_SITE_ROLE_TYPE = 'ACCOUNTING_SITE_ROLE_TYPE',
  /** AccountingSiteType Domain */
  ACCOUNTING_SITE_TYPE = 'ACCOUNTING_SITE_TYPE',
  /** AccountAccountingSite Domain */
  ACCOUNT_ACCOUNTING_SITE = 'ACCOUNT_ACCOUNTING_SITE',
  /** AccountCateringActivePaymentMethod Domain */
  ACCOUNT_CATERING_ACTIVE_PAYMENT_METHOD = 'ACCOUNT_CATERING_ACTIVE_PAYMENT_METHOD',
  /** AccountCateringAdmin Domain */
  ACCOUNT_CATERING_ADMIN = 'ACCOUNT_CATERING_ADMIN',
  /** AccountCateringBillingConfigEmailSend Domain */
  ACCOUNT_CATERING_BILLING_CONFIG_EMAIL_SEND = 'ACCOUNT_CATERING_BILLING_CONFIG_EMAIL_SEND',
  /** AccountCateringBillingConfigPreferences Domain */
  ACCOUNT_CATERING_BILLING_CONFIG_PREFERENCES = 'ACCOUNT_CATERING_BILLING_CONFIG_PREFERENCES',
  /** AccountCateringFinanceBillingConfig Domain */
  ACCOUNT_CATERING_FINANCE_BILLING_CONFIG = 'ACCOUNT_CATERING_FINANCE_BILLING_CONFIG',
  /** AccountCateringInvoiceNote Domain */
  ACCOUNT_CATERING_INVOICE_NOTE = 'ACCOUNT_CATERING_INVOICE_NOTE',
  /** AccountCollectionEmail Domain */
  ACCOUNT_COLLECTION_EMAIL = 'ACCOUNT_COLLECTION_EMAIL',
  /** AccountCommissions Domain */
  ACCOUNT_COMMISSIONS = 'ACCOUNT_COMMISSIONS',
  /** AccountConnectedAccounts Domain */
  ACCOUNT_CONNECTED_ACCOUNTS = 'ACCOUNT_CONNECTED_ACCOUNTS',
  /** AccountConsolidateEmailsbyProduct Domain */
  ACCOUNT_CONSOLIDATE_EMAILSBY_PRODUCT = 'ACCOUNT_CONSOLIDATE_EMAILSBY_PRODUCT',
  /** AccountConstraint Domain */
  ACCOUNT_CONSTRAINT = 'ACCOUNT_CONSTRAINT',
  /** AccountCreditStatus Domain */
  ACCOUNT_CREDIT_STATUS = 'ACCOUNT_CREDIT_STATUS',
  /** AccountCustomInvoice Domain */
  ACCOUNT_CUSTOM_INVOICE = 'ACCOUNT_CUSTOM_INVOICE',
  /** AccountCustomInvoiceSettings Domain */
  ACCOUNT_CUSTOM_INVOICE_SETTINGS = 'ACCOUNT_CUSTOM_INVOICE_SETTINGS',
  /** AccountDataProcessingRole Domain */
  ACCOUNT_DATA_PROCESSING_ROLE = 'ACCOUNT_DATA_PROCESSING_ROLE',
  /** AccountDeliveryActivePaymentMethod Domain */
  ACCOUNT_DELIVERY_ACTIVE_PAYMENT_METHOD = 'ACCOUNT_DELIVERY_ACTIVE_PAYMENT_METHOD',
  /** AccountDeliveryAdmin Domain */
  ACCOUNT_DELIVERY_ADMIN = 'ACCOUNT_DELIVERY_ADMIN',
  /** AccountDeliveryBillingConfigEmailSend Domain */
  ACCOUNT_DELIVERY_BILLING_CONFIG_EMAIL_SEND = 'ACCOUNT_DELIVERY_BILLING_CONFIG_EMAIL_SEND',
  /** AccountDeliveryBillingConfigPreferences Domain */
  ACCOUNT_DELIVERY_BILLING_CONFIG_PREFERENCES = 'ACCOUNT_DELIVERY_BILLING_CONFIG_PREFERENCES',
  /** AccountDeliveryFinanceBillingConfig Domain */
  ACCOUNT_DELIVERY_FINANCE_BILLING_CONFIG = 'ACCOUNT_DELIVERY_FINANCE_BILLING_CONFIG',
  /** AccountDeliveryInvoiceNote Domain */
  ACCOUNT_DELIVERY_INVOICE_NOTE = 'ACCOUNT_DELIVERY_INVOICE_NOTE',
  /** AccountDeliveryPromos Domain */
  ACCOUNT_DELIVERY_PROMOS = 'ACCOUNT_DELIVERY_PROMOS',
  /** AccountDomainAssociation Domain */
  ACCOUNT_DOMAIN_ASSOCIATION = 'ACCOUNT_DOMAIN_ASSOCIATION',
  /** AccountEventSchedulesCafe Domain */
  ACCOUNT_EVENT_SCHEDULES_CAFE = 'ACCOUNT_EVENT_SCHEDULES_CAFE',
  /** AccountFinancePayment Domain */
  ACCOUNT_FINANCE_PAYMENT = 'ACCOUNT_FINANCE_PAYMENT',
  /** AccountGuestPassCreation Domain */
  ACCOUNT_GUEST_PASS_CREATION = 'ACCOUNT_GUEST_PASS_CREATION',
  /** AccountInvoicesPreview Domain */
  ACCOUNT_INVOICES_PREVIEW = 'ACCOUNT_INVOICES_PREVIEW',
  /** AccountInvoiceDetailedReport Domain */
  ACCOUNT_INVOICE_DETAILED_REPORT = 'ACCOUNT_INVOICE_DETAILED_REPORT',
  /** AccountInvoiceSummaryReport Domain */
  ACCOUNT_INVOICE_SUMMARY_REPORT = 'ACCOUNT_INVOICE_SUMMARY_REPORT',
  /** AccountLocationsCafe Domain */
  ACCOUNT_LOCATIONS_CAFE = 'ACCOUNT_LOCATIONS_CAFE',
  /** AccountManager Domain */
  ACCOUNT_MANAGER = 'ACCOUNT_MANAGER',
  /** AccountMembershipBillingAdmin Domain */
  ACCOUNT_MEMBERSHIP_BILLING_ADMIN = 'ACCOUNT_MEMBERSHIP_BILLING_ADMIN',
  /** AccountMembershipEnrollment Domain */
  ACCOUNT_MEMBERSHIP_ENROLLMENT = 'ACCOUNT_MEMBERSHIP_ENROLLMENT',
  /** AccountMinSalesGuarantee Domain */
  ACCOUNT_MIN_SALES_GUARANTEE = 'ACCOUNT_MIN_SALES_GUARANTEE',
  /** AccountMobileOrderingFlag Domain */
  ACCOUNT_MOBILE_ORDERING_FLAG = 'ACCOUNT_MOBILE_ORDERING_FLAG',
  /** AccountNames Domain */
  ACCOUNT_NAMES = 'ACCOUNT_NAMES',
  /** AccountPantryReporting Domain */
  ACCOUNT_PANTRY_REPORTING = 'ACCOUNT_PANTRY_REPORTING',
  /** AccountParent Domain */
  ACCOUNT_PARENT = 'ACCOUNT_PARENT',
  /** AccountPaymentMethods Domain */
  ACCOUNT_PAYMENT_METHODS = 'ACCOUNT_PAYMENT_METHODS',
  /** AccountPopupActivePaymentMethod Domain */
  ACCOUNT_POPUP_ACTIVE_PAYMENT_METHOD = 'ACCOUNT_POPUP_ACTIVE_PAYMENT_METHOD',
  /** AccountPopupBillingConfigEmailSend Domain */
  ACCOUNT_POPUP_BILLING_CONFIG_EMAIL_SEND = 'ACCOUNT_POPUP_BILLING_CONFIG_EMAIL_SEND',
  /** AccountPopupBillingConfigPreferences Domain */
  ACCOUNT_POPUP_BILLING_CONFIG_PREFERENCES = 'ACCOUNT_POPUP_BILLING_CONFIG_PREFERENCES',
  /** AccountPopupFinanceBilling Domain */
  ACCOUNT_POPUP_FINANCE_BILLING = 'ACCOUNT_POPUP_FINANCE_BILLING',
  /** AccountPopupFinanceBillingConfig Domain */
  ACCOUNT_POPUP_FINANCE_BILLING_CONFIG = 'ACCOUNT_POPUP_FINANCE_BILLING_CONFIG',
  /** AccountPopupFinanceConfig Domain */
  ACCOUNT_POPUP_FINANCE_CONFIG = 'ACCOUNT_POPUP_FINANCE_CONFIG',
  /** AccountPopupInvoiceNote Domain */
  ACCOUNT_POPUP_INVOICE_NOTE = 'ACCOUNT_POPUP_INVOICE_NOTE',
  /** AccountProductStatusAccounting Domain */
  ACCOUNT_PRODUCT_STATUS_ACCOUNTING = 'ACCOUNT_PRODUCT_STATUS_ACCOUNTING',
  /** AccountProductStatusCompliance Domain */
  ACCOUNT_PRODUCT_STATUS_COMPLIANCE = 'ACCOUNT_PRODUCT_STATUS_COMPLIANCE',
  /** AccountPurchaseVouchers Domain */
  ACCOUNT_PURCHASE_VOUCHERS = 'ACCOUNT_PURCHASE_VOUCHERS',
  /** AccountReportEmbedded Domain */
  ACCOUNT_REPORT_EMBEDDED = 'ACCOUNT_REPORT_EMBEDDED',
  /** AccountSalesCommitment Domain */
  ACCOUNT_SALES_COMMITMENT = 'ACCOUNT_SALES_COMMITMENT',
  /** AccountSalesReferrer Domain */
  ACCOUNT_SALES_REFERRER = 'ACCOUNT_SALES_REFERRER',
  /** AccountSalesRep Domain */
  ACCOUNT_SALES_REP = 'ACCOUNT_SALES_REP',
  /** AccountSalesTaxOverride Domain */
  ACCOUNT_SALES_TAX_OVERRIDE = 'ACCOUNT_SALES_TAX_OVERRIDE',
  /** AccountSubsidy Domain */
  ACCOUNT_SUBSIDY = 'ACCOUNT_SUBSIDY',
  /** AccountSubsidyManager Domain */
  ACCOUNT_SUBSIDY_MANAGER = 'ACCOUNT_SUBSIDY_MANAGER',
  /** AccountTaxExempt Domain */
  ACCOUNT_TAX_EXEMPT = 'ACCOUNT_TAX_EXEMPT',
  /** AccountTenderMethods Domain */
  ACCOUNT_TENDER_METHODS = 'ACCOUNT_TENDER_METHODS',
  /** AccountWeekAheadEmail Domain */
  ACCOUNT_WEEK_AHEAD_EMAIL = 'ACCOUNT_WEEK_AHEAD_EMAIL',
  /** AchDocument Domain */
  ACH_DOCUMENT = 'ACH_DOCUMENT',
  /** AgentPrincipalDefaults Domain */
  AGENT_PRINCIPAL_DEFAULTS = 'AGENT_PRINCIPAL_DEFAULTS',
  /** AIAssistant Domain */
  AI_ASSISTANT = 'AI_ASSISTANT',
  /** AppSnappea Domain */
  APP_SNAPPEA = 'APP_SNAPPEA',
  /** BuildingJurisdiction Domain */
  BUILDING_JURISDICTION = 'BUILDING_JURISDICTION',
  /** CateringEventUnlock Domain */
  CATERING_EVENT_UNLOCK = 'CATERING_EVENT_UNLOCK',
  /** CouponAccount Domain */
  COUPON_ACCOUNT = 'COUPON_ACCOUNT',
  /** CouponLaunch Domain */
  COUPON_LAUNCH = 'COUPON_LAUNCH',
  /** CouponPaper Domain */
  COUPON_PAPER = 'COUPON_PAPER',
  /** CouponReferral Domain */
  COUPON_REFERRAL = 'COUPON_REFERRAL',
  /** CouponReward Domain */
  COUPON_REWARD = 'COUPON_REWARD',
  /** CouponUser Domain */
  COUPON_USER = 'COUPON_USER',
  /** DeliveryOrderRefund Domain */
  DELIVERY_ORDER_REFUND = 'DELIVERY_ORDER_REFUND',
  /** DeliverySchedulingAccountConstraint Domain */
  DELIVERY_SCHEDULING_ACCOUNT_CONSTRAINT = 'DELIVERY_SCHEDULING_ACCOUNT_CONSTRAINT',
  /** EventOrder Domain */
  EVENT_ORDER = 'EVENT_ORDER',
  /** EventPayment Domain */
  EVENT_PAYMENT = 'EVENT_PAYMENT',
  /** GlobalSettings Domain */
  GLOBAL_SETTINGS = 'GLOBAL_SETTINGS',
  /** MarketConfig Domain */
  MARKET_CONFIG = 'MARKET_CONFIG',
  /** MarketJurisdiction Domain */
  MARKET_JURISDICTION = 'MARKET_JURISDICTION',
  /** MCPServiceAccount Domain */
  MCP_SERVICE_ACCOUNT = 'MCP_SERVICE_ACCOUNT',
  /** PartnerCollectionEmail Domain */
  PARTNER_COLLECTION_EMAIL = 'PARTNER_COLLECTION_EMAIL',
  /** PartnerConfig Domain */
  PARTNER_CONFIG = 'PARTNER_CONFIG',
  /** PartnerInvoicesPreview Domain */
  PARTNER_INVOICES_PREVIEW = 'PARTNER_INVOICES_PREVIEW',
  /** PaymentAccessToken Domain */
  PAYMENT_ACCESS_TOKEN = 'PAYMENT_ACCESS_TOKEN',
  /** PopupEventTaxRemittedBy Domain */
  POPUP_EVENT_TAX_REMITTED_BY = 'POPUP_EVENT_TAX_REMITTED_BY',
  /** PopupOrderRefund Domain */
  POPUP_ORDER_REFUND = 'POPUP_ORDER_REFUND',
  /** RecommendationsSystemConfiguration Domain */
  RECOMMENDATIONS_SYSTEM_CONFIGURATION = 'RECOMMENDATIONS_SYSTEM_CONFIGURATION',
  /** ReportsConfigurations Domain */
  REPORTS_CONFIGURATIONS = 'REPORTS_CONFIGURATIONS',
  /** ShadowFalsePositivePermanent Domain */
  SHADOW_FALSE_POSITIVE_PERMANENT = 'SHADOW_FALSE_POSITIVE_PERMANENT',
  /** ShadowFalsePositiveTemporary Domain */
  SHADOW_FALSE_POSITIVE_TEMPORARY = 'SHADOW_FALSE_POSITIVE_TEMPORARY',
  /** ShadowScoring Domain */
  SHADOW_SCORING = 'SHADOW_SCORING',
  /** TaxRule Domain */
  TAX_RULE = 'TAX_RULE',
  /** UserAuthenticationSettings Domain */
  USER_AUTHENTICATION_SETTINGS = 'USER_AUTHENTICATION_SETTINGS',
  /** UserCardsGatewayLinks Domain */
  USER_CARDS_GATEWAY_LINKS = 'USER_CARDS_GATEWAY_LINKS',
  /** UserDeactivate Domain */
  USER_DEACTIVATE = 'USER_DEACTIVATE',
  /** UserForceVerifyEmail Domain */
  USER_FORCE_VERIFY_EMAIL = 'USER_FORCE_VERIFY_EMAIL',
  /** UserPasswordReset Domain */
  USER_PASSWORD_RESET = 'USER_PASSWORD_RESET',
  /** UserPermissions Domain */
  USER_PERMISSIONS = 'USER_PERMISSIONS',
  /** UserPhoneNumber Domain */
  USER_PHONE_NUMBER = 'USER_PHONE_NUMBER',
  /** UserProfileRoles Domain */
  USER_PROFILE_ROLES = 'USER_PROFILE_ROLES',
  /** UserRewardPoints Domain */
  USER_REWARD_POINTS = 'USER_REWARD_POINTS',
  /** UserSnappeaRole Domain */
  USER_SNAPPEA_ROLE = 'USER_SNAPPEA_ROLE',
  /** UserVerificationEmail Domain */
  USER_VERIFICATION_EMAIL = 'USER_VERIFICATION_EMAIL',
  /** VendorAvailability Domain */
  VENDOR_AVAILABILITY = 'VENDOR_AVAILABILITY',
  /** VendorCateringCommissionRate Domain */
  VENDOR_CATERING_COMMISSION_RATE = 'VENDOR_CATERING_COMMISSION_RATE',
  /** VendorCollectionEmail Domain */
  VENDOR_COLLECTION_EMAIL = 'VENDOR_COLLECTION_EMAIL',
  /** VendorDashboard Domain */
  VENDOR_DASHBOARD = 'VENDOR_DASHBOARD',
  /** VendorDeliveryCommissionRate Domain */
  VENDOR_DELIVERY_COMMISSION_RATE = 'VENDOR_DELIVERY_COMMISSION_RATE',
  /** VendorEvents Domain */
  VENDOR_EVENTS = 'VENDOR_EVENTS',
  /** VendorFoodTruckAvailable Domain */
  VENDOR_FOOD_TRUCK_AVAILABLE = 'VENDOR_FOOD_TRUCK_AVAILABLE',
  /** VendorInvoicesPreview Domain */
  VENDOR_INVOICES_PREVIEW = 'VENDOR_INVOICES_PREVIEW',
  /** VendorNames Domain */
  VENDOR_NAMES = 'VENDOR_NAMES',
  /** VendorOwedBalanceTreatment Domain */
  VENDOR_OWED_BALANCE_TREATMENT = 'VENDOR_OWED_BALANCE_TREATMENT',
  /** VendorPantryManager Domain */
  VENDOR_PANTRY_MANAGER = 'VENDOR_PANTRY_MANAGER',
  /** VendorParent Domain */
  VENDOR_PARENT = 'VENDOR_PARENT',
  /** VendorPopupFinanceBilling Domain */
  VENDOR_POPUP_FINANCE_BILLING = 'VENDOR_POPUP_FINANCE_BILLING',
  /** VendorPopupFinanceConfig Domain */
  VENDOR_POPUP_FINANCE_CONFIG = 'VENDOR_POPUP_FINANCE_CONFIG',
  /** VendorPopupOrder Domain */
  VENDOR_POPUP_ORDER = 'VENDOR_POPUP_ORDER',
  /** VendorProductsPopup Domain */
  VENDOR_PRODUCTS_POPUP = 'VENDOR_PRODUCTS_POPUP',
  /** VendorProductStatusAccounting Domain */
  VENDOR_PRODUCT_STATUS_ACCOUNTING = 'VENDOR_PRODUCT_STATUS_ACCOUNTING',
  /** VendorProductStatusCompliance Domain */
  VENDOR_PRODUCT_STATUS_COMPLIANCE = 'VENDOR_PRODUCT_STATUS_COMPLIANCE',
  /** VendorSalesRep Domain */
  VENDOR_SALES_REP = 'VENDOR_SALES_REP',
  /** VendorSchedulingExclusion Domain */
  VENDOR_SCHEDULING_EXCLUSION = 'VENDOR_SCHEDULING_EXCLUSION',
  /** VendorTrialSchedule Domain */
  VENDOR_TRIAL_SCHEDULE = 'VENDOR_TRIAL_SCHEDULE'
}

export type EmailCategoryPreferenceInput = {
  categoryKey: Scalars['String']['input'];
  subscribed: Scalars['Boolean']['input'];
};

export type EmailConfigurationInput = {
  sendDayOffset?: InputMaybe<Scalars['Int']['input']>;
  sendTime?: InputMaybe<Scalars['String']['input']>;
};

/** Arguments to update a vendor employee permissions */
export type EmployeePermission = {
  active: Scalars['Boolean']['input'];
  name: VendorEmployeePermission;
};

export type EndedEarlyInput = {
  relevant: Scalars['Boolean']['input'];
  value: Scalars['ISO8601DateTime']['input'];
};

/** Arguments to add a user to an account */
export type EnrollUserInAccount = {
  accountId: Scalars['ID']['input'];
  permissions?: InputMaybe<Array<AccountRolePermission>>;
  role?: InputMaybe<AccountRoleEnum>;
  userId: Scalars['ID']['input'];
};

/** Arguments to add a user to a vendor */
export type EnrollUserInVendor = {
  employeePermissions: Array<VendorEmployeePermission>;
  siteDirectionsNotifications: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
  vendorId: Scalars['ID']['input'];
};

export type EntreeSoldOutInput = {
  relevant: Scalars['Boolean']['input'];
  value: Scalars['ID']['input'];
};

export enum EventProduct {
  CAFE = 'CAFE',
  CATERING = 'CATERING',
  DELIVERY = 'DELIVERY',
  POPUP = 'POPUP'
}

export enum EventStatus {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  COMPLETE = 'COMPLETE',
  FINAL = 'FINAL',
  IN_PROGRESS = 'IN_PROGRESS',
  PROPOSED = 'PROPOSED',
  SCHEDULED = 'SCHEDULED'
}

export enum ExperienceRating {
  AWFUL = 'AWFUL',
  GOOD = 'GOOD',
  GREAT = 'GREAT',
  OKAY = 'OKAY'
}

export enum FeeLineItemTypeEnum {
  CANCELLATION_FEE = 'CANCELLATION_FEE',
  CLIENT_FEE = 'CLIENT_FEE',
  COMMISSION = 'COMMISSION',
  DELIVERY_FEE = 'DELIVERY_FEE',
  EVENT_FEE = 'EVENT_FEE',
  FEE_TAX = 'FEE_TAX',
  GRATUITY = 'GRATUITY',
  OTHER_FEE = 'OTHER_FEE',
  PARTNER_COMMISSION = 'PARTNER_COMMISSION',
  PAYMENT_PROCESSING_FEE = 'PAYMENT_PROCESSING_FEE',
  PAYMENT_PROCESSING_MANUAL_FEE = 'PAYMENT_PROCESSING_MANUAL_FEE',
  PAYMENT_PROCESSING_SWIPE_FEE = 'PAYMENT_PROCESSING_SWIPE_FEE',
  PAYMENT_PROCESSING_TOKEN_FEE = 'PAYMENT_PROCESSING_TOKEN_FEE',
  SITE_MANAGEMENT_FEE = 'SITE_MANAGEMENT_FEE'
}

export enum FeedbackFactor {
  CHECKOUT_PROCESS = 'CHECKOUT_PROCESS',
  ITEM_AVAILABILITY = 'ITEM_AVAILABILITY',
  STAFF_FRIENDLINESS = 'STAFF_FRIENDLINESS',
  WAIT_TIME = 'WAIT_TIME'
}

export enum FeedbackReviewOptionCategory {
  EVENT = 'EVENT',
  ITEM = 'ITEM'
}

export enum FeedbackReviewOptionDisposition {
  NEGATIVE = 'NEGATIVE',
  POSITIVE = 'POSITIVE'
}

/** Flavour Me recommendation request */
export type FlavourMeRequestInput = {
  /** Array of event vendor IDs */
  eventVendorIds: Array<Scalars['ID']['input']>;
};

/** Verification status of a pull-funding bank account */
export enum FoodaCardBankAccountStatus {
  PENDING_VERIFICATION = 'PENDING_VERIFICATION',
  REMOVED = 'REMOVED',
  VERIFICATION_FAILED = 'VERIFICATION_FAILED',
  VERIFIED = 'VERIFIED'
}

/** Status for FoodaCard Membership */
export enum FoodaCardMembershipStatusEnum {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  PENDING_REQUIREMENTS = 'PENDING_REQUIREMENTS'
}

/** Nested FoodaCard program attributes for use within UpdateSubsidyRule */
export type FoodaCardProgramAttributes = {
  allowedHourRanges?: InputMaybe<Array<HourRangeInput>>;
  allowedMerchantCategoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedMerchantNames?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedZipCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  blockedMerchantNames?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<FoodaCardProgramStatusEnum>;
};

/** Status for FoodaCard Program */
export enum FoodaCardProgramStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export type GetAccountDeliveryEventMembersInput = {
  accountId: Scalars['ID']['input'];
  eventId: Scalars['ID']['input'];
  status?: InputMaybe<AccountDeliveryMemberFilter>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  userSearchText?: InputMaybe<Scalars['String']['input']>;
};

export type GetBillingPolicy = {
  partyId: Scalars['ID']['input'];
  partyType: Scalars['String']['input'];
};

export type GetCafeEventForLocation = {
  cafeLocationId: Scalars['ID']['input'];
  time?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export type GetCafeEventMenuInput = {
  cafeEventId: Scalars['ID']['input'];
};

export type GetCafeEventsForAccount = {
  accountId: Scalars['ID']['input'];
  endTime: Scalars['ISO8601DateTime']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  startTime: Scalars['ISO8601DateTime']['input'];
};

export type GetCampaignUsers = {
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetCateringInventoryItem = {
  id: Scalars['ID']['input'];
};

export type GetCateringInventoryItemsForVendor = {
  searchInfo?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
};

/** Arguments to list consumer_data_requests */
export type GetConsumerDataRequests = {
  email?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ConsumerDataRequestStatusEnum>;
  type?: InputMaybe<ConsumerDataRequestTypeEnum>;
};

export type GetDeliveryInventoryItem = {
  id: Scalars['ID']['input'];
};

export type GetDeliveryInventoryItemsForVendor = {
  searchInfo?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type GetDeliverySchedulingConstraint = {
  markets: Array<Scalars['String']['input']>;
};

/** Arguments to get all delivery menu templates of a vendor */
export type GetDeliveryVendorMenuTemplates = {
  expirationDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type GetEventInput = {
  eventId: Scalars['ID']['input'];
  productType: EventProduct;
};

export type GetEventSubsidies = {
  eventId: Scalars['ID']['input'];
  product: SubsidyRuleProduct;
};

export type GetEventVendorsInput = {
  /** Array of event vendor IDs sharing one product type */
  eventVendorIds: Array<Scalars['ID']['input']>;
  productType: EventProduct;
};

export type GetFeatureFlag = {
  name: Scalars['String']['input'];
};

export type GetFeedbackRequests = {
  requestId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

/** Arguments to get top items */
export type GetFinancialInfoForVendorAtLocation = {
  locationId: Scalars['ID']['input'];
  product?: InputMaybe<ProductEnum>;
  vendorId: Scalars['ID']['input'];
};

export type GetGFSForVendors = {
  product?: InputMaybe<ProductEnum>;
  vendors: Array<Scalars['ID']['input']>;
};

/** Get Grouped User Cards Input */
export type GetGroupedUserCardsQueryInput = {
  /** Page */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Page Size */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  /** Sort Field */
  sortField?: InputMaybe<Scalars['String']['input']>;
  /** Sort Order */
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  /** User ID */
  userId: Scalars['ID']['input'];
};

export type GetMarket = {
  id: Scalars['ID']['input'];
};

export type GetMobileOrderingOrderDetails = {
  ids: Array<Scalars['ID']['input']>;
};

export type GetMobileOrderingOrderRequest = {
  id: Scalars['ID']['input'];
};

export type GetMobileOrderingOrders = {
  /** DEPRECATED: use eventVendorId */
  eventId?: InputMaybe<Scalars['ID']['input']>;
  eventVendorId?: InputMaybe<Scalars['ID']['input']>;
  /** DEPRECATED: use eventVendorId */
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetOrderDetails = {
  requestId: Scalars['ID']['input'];
  userContext?: InputMaybe<UserContext>;
};

export type GetPhysicalSecurityQuestions = {
  device: DeviceAttributes;
};

export type GetPopupEventVendorMenu = {
  eventVendorId: Scalars['ID']['input'];
};

export type GetPopupFeedbackForVendors = {
  after: Scalars['ISO8601DateTime']['input'];
  before: Scalars['ISO8601DateTime']['input'];
  vendorIds: Array<Scalars['ID']['input']>;
};

export type GetPopupInventoryItem = {
  popupInventoryItemId: Scalars['ID']['input'];
};

export type GetPopupInventoryItemsForVendor = {
  mealTypes?: InputMaybe<Array<InventoryItemMealType>>;
  searchInfo?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type GetPopupMenuTemplate = {
  menuTemplateId: Scalars['ID']['input'];
};

export type GetPopupMenuTemplateInventoryItem = {
  id: Scalars['ID']['input'];
};

export type GetPopupOrdersListForEventVendors = {
  apiVersions?: InputMaybe<Array<ApiVersion>>;
  eventVendorIds: Array<Scalars['ID']['input']>;
};

/** Get recommendations */
export type GetRecommendationsInput = {
  /** Cross Sell recommendation request data */
  crossSellRequest?: InputMaybe<CrossSellRequestInput>;
  /** Identifier of the recommendation entry point configured in SnapPea */
  entrypointCode: Scalars['String']['input'];
  /** Flavour Me recommendation request data */
  flavourMeRequest?: InputMaybe<FlavourMeRequestInput>;
  /** Existing session UUID to continue (optional) */
  sessionUuid?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the target entity (Event, Item, etc.) */
  targetId: Scalars['ID']['input'];
  /** Type of target entity (Event, SelectEvent, PopupEvent, etc.) */
  targetType: Scalars['String']['input'];
  /** Up Sell recommendation request data */
  upSellRequest?: InputMaybe<UpSellRequestInput>;
};

/** Get Report Configuration input */
export type GetReportsConfigurationsQueryInput = {
  application?: InputMaybe<ApplicationEnum>;
  /** Menu titles of Reports Configurations */
  menuTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  reportsTypes?: InputMaybe<Array<ReportConfigurationTypeEnum>>;
};

/** Arguments to get resident vendors for account */
export type GetResidentVendorsForAccount = {
  accountId: Scalars['ID']['input'];
};

export type GetShadowInput = {
  shadowId: Scalars['ID']['input'];
};

/** Arguments to get a site directions token */
export type GetSiteDirectionsTokenForUser = {
  popupEventVendorId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Arguments to get subsidy members */
export type GetSubsidyMembers = {
  accountId: Scalars['ID']['input'];
  programIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  state?: InputMaybe<SubsidyMemberState>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  userSearchText?: InputMaybe<Scalars['String']['input']>;
};

export type GetTaxCategoryVersionsRequest = {
  taxCategoryId: Scalars['Int']['input'];
};

export type GetTaxRatesInput = {
  addressId: Scalars['ID']['input'];
  taxCategoryIds: Array<Scalars['ID']['input']>;
  timestamp?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export type GetTaxRulesForVendor = {
  vendorId: Scalars['ID']['input'];
};

export type GetTenderMethods = {
  /** Filter by account ID */
  accountId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by availability on a specific date */
  availableOnDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Filter by product type */
  productType?: InputMaybe<ProductEnum>;
  /** Filter by state (active/inactive) */
  state?: InputMaybe<TenderMethodStateEnum>;
};

export type GetTodoTasksForVendors = {
  /** This is deprecated. Please, use expiresAfter argument */
  dueAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  expiresAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  todoTaskStates?: InputMaybe<Array<StateEnum>>;
  vendorIds: Array<Scalars['ID']['input']>;
};

export type GetUserSubsidies = {
  product: SubsidyRuleProduct;
  states?: InputMaybe<Array<SubsidyRuleState>>;
};

export type GetUsersInput = {
  roleScope: UserRoleScope;
};

export type GetVendorAvailabilityInput = {
  month: Scalars['Int']['input'];
  productType: ProductEnum;
  vendorId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};

export type GetVendorMenuTemplate = {
  /** Menu template id. */
  id: Scalars['ID']['input'];
};

export type GetVendorMenuTemplates = {
  /** Match templates with ANY of these meal periods. Omit for all. */
  mealPeriods?: InputMaybe<Array<MealPeriodEnum>>;
  /** Filter to these product types. Omit for all. */
  productTypes?: InputMaybe<Array<ProductEnum>>;
  /** Filter to these statuses. Restricted server-side to Published/Approved/Pending Approval. */
  states?: InputMaybe<Array<MenuTemplateStateEnum>>;
  vendorId: Scalars['ID']['input'];
};

export enum GroupingEnum {
  /** Event Grouping */
  Event = 'Event',
  /** Onboarding Grouping */
  Onboarding = 'Onboarding',
  /** Schedule Grouping */
  Schedule = 'Schedule'
}

export enum GuestPassDistribution {
  EMAIL = 'EMAIL',
  PRINT = 'PRINT'
}

export type HealthDepartmentJurisdictionInput = {
  _destroy: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

/** Hour range for time-based restrictions. Times in HH:MM format (00:00 to 23:59) */
export type HourRangeInput = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

export enum InventoryItemDietaryRestrictions {
  CONTAINS_NUTS = 'CONTAINS_NUTS',
  DAIRY_FREE = 'DAIRY_FREE',
  GLUTEN_FREE = 'GLUTEN_FREE',
  HALAL = 'HALAL',
  HEART_HEALTHY = 'HEART_HEALTHY',
  KOSHER = 'KOSHER',
  SOY_FREE = 'SOY_FREE',
  VEGAN = 'VEGAN',
  VEGETARIAN = 'VEGETARIAN'
}

export enum InventoryItemExternalTags {
  BACON = 'BACON',
  BAGELS = 'BAGELS',
  BAKERY = 'BAKERY',
  BEANS = 'BEANS',
  BEEF = 'BEEF',
  BEVERAGES = 'BEVERAGES',
  BOXED_LUNCH = 'BOXED_LUNCH',
  BREAD = 'BREAD',
  BREAKFAST = 'BREAKFAST',
  BURRITOS = 'BURRITOS',
  CHEESE = 'CHEESE',
  CHICKEN = 'CHICKEN',
  CHILI = 'CHILI',
  CHIPS = 'CHIPS',
  COFFEE_AND_TEA = 'COFFEE_AND_TEA',
  COMFORT_FOOD = 'COMFORT_FOOD',
  CREPES = 'CREPES',
  DESSERT_AND_SWEETS = 'DESSERT_AND_SWEETS',
  DIM_SUM = 'DIM_SUM',
  DIPS_AND_SPREADS = 'DIPS_AND_SPREADS',
  DUMPLINGS = 'DUMPLINGS',
  EGGS = 'EGGS',
  EMPANADA = 'EMPANADA',
  FALAFEL = 'FALAFEL',
  FLATBREAD = 'FLATBREAD',
  FRESH_FRUITS = 'FRESH_FRUITS',
  FRIES = 'FRIES',
  GRILLED = 'GRILLED',
  GYRO = 'GYRO',
  HAMBURGERS = 'HAMBURGERS',
  HEALTHY = 'HEALTHY',
  HOT_DOGS = 'HOT_DOGS',
  ICE_CREAM = 'ICE_CREAM',
  ITALIAN_MEATS = 'ITALIAN_MEATS',
  LAMB = 'LAMB',
  LEGUMES = 'LEGUMES',
  LUNCH = 'LUNCH',
  NOODLES = 'NOODLES',
  ORGANIC = 'ORGANIC',
  PANINI = 'PANINI',
  PASTA = 'PASTA',
  PITAS = 'PITAS',
  PIZZA = 'PIZZA',
  PORK = 'PORK',
  POTATO = 'POTATO',
  POULTRY = 'POULTRY',
  PREMIUM = 'PREMIUM',
  QUALCOMM_FRESH_FOOD = 'QUALCOMM_FRESH_FOOD',
  RIBS = 'RIBS',
  RICE_AND_GRAINS = 'RICE_AND_GRAINS',
  SALADS = 'SALADS',
  SANDWICHES = 'SANDWICHES',
  SAUSAGE = 'SAUSAGE',
  SEAFOOD = 'SEAFOOD',
  SKEWERS = 'SKEWERS',
  SMOOTHIES_AND_JUICES = 'SMOOTHIES_AND_JUICES',
  SOFT_DRINKS = 'SOFT_DRINKS',
  SOUPS_AND_STEWS = 'SOUPS_AND_STEWS',
  SPICY = 'SPICY',
  STEAK = 'STEAK',
  SUBS = 'SUBS',
  SUSHI = 'SUSHI',
  TACO = 'TACO',
  TAPAS = 'TAPAS',
  TURKEY = 'TURKEY',
  VEGETABLES = 'VEGETABLES',
  WINGS = 'WINGS',
  WRAPS = 'WRAPS'
}

export enum InventoryItemInternalTags {
  BACON = 'BACON',
  BAGELS = 'BAGELS',
  BAKERY = 'BAKERY',
  BEANS = 'BEANS',
  BEEF = 'BEEF',
  BEVERAGES = 'BEVERAGES',
  BOXED_LUNCH = 'BOXED_LUNCH',
  BREAD = 'BREAD',
  BREAKFAST = 'BREAKFAST',
  BURRITOS = 'BURRITOS',
  CHEESE = 'CHEESE',
  CHICKEN = 'CHICKEN',
  CHILI = 'CHILI',
  CHIPS = 'CHIPS',
  COFFEE_AND_TEA = 'COFFEE_AND_TEA',
  COMFORT_FOOD = 'COMFORT_FOOD',
  CREPES = 'CREPES',
  DESSERT_AND_SWEETS = 'DESSERT_AND_SWEETS',
  DIM_SUM = 'DIM_SUM',
  DIPS_AND_SPREADS = 'DIPS_AND_SPREADS',
  DUMPLINGS = 'DUMPLINGS',
  EGGS = 'EGGS',
  EMPANADA = 'EMPANADA',
  FALAFEL = 'FALAFEL',
  FLATBREAD = 'FLATBREAD',
  FRESH_FRUITS = 'FRESH_FRUITS',
  FRIES = 'FRIES',
  GRILLED = 'GRILLED',
  GYRO = 'GYRO',
  HAMBURGERS = 'HAMBURGERS',
  HEALTHY = 'HEALTHY',
  HOT_DOGS = 'HOT_DOGS',
  ICE_CREAM = 'ICE_CREAM',
  ITALIAN_MEATS = 'ITALIAN_MEATS',
  LAMB = 'LAMB',
  LEGUMES = 'LEGUMES',
  LUNCH = 'LUNCH',
  NOODLES = 'NOODLES',
  ORGANIC = 'ORGANIC',
  PANINI = 'PANINI',
  PASTA = 'PASTA',
  PITAS = 'PITAS',
  PIZZA = 'PIZZA',
  PORK = 'PORK',
  POTATO = 'POTATO',
  POULTRY = 'POULTRY',
  PREMIUM = 'PREMIUM',
  QUALCOMM_FRESH_FOOD = 'QUALCOMM_FRESH_FOOD',
  RIBS = 'RIBS',
  RICE_AND_GRAINS = 'RICE_AND_GRAINS',
  SALADS = 'SALADS',
  SANDWICHES = 'SANDWICHES',
  SAUSAGE = 'SAUSAGE',
  SEAFOOD = 'SEAFOOD',
  SKEWERS = 'SKEWERS',
  SMOOTHIES_AND_JUICES = 'SMOOTHIES_AND_JUICES',
  SOFT_DRINKS = 'SOFT_DRINKS',
  SOUPS_AND_STEWS = 'SOUPS_AND_STEWS',
  SPICY = 'SPICY',
  STEAK = 'STEAK',
  SUBS = 'SUBS',
  SUSHI = 'SUSHI',
  TACO = 'TACO',
  TAPAS = 'TAPAS',
  TURKEY = 'TURKEY',
  VEGETABLES = 'VEGETABLES',
  WINGS = 'WINGS',
  WRAPS = 'WRAPS'
}

export enum InventoryItemMealType {
  APPETIZERS = 'APPETIZERS',
  BEVERAGES = 'BEVERAGES',
  COMBINATIONS = 'COMBINATIONS',
  DESSERTS = 'DESSERTS',
  ENTREES = 'ENTREES',
  RENTAL_ITEMS = 'RENTAL_ITEMS',
  RETAIL = 'RETAIL',
  RETAIL_BAKERY = 'RETAIL_BAKERY',
  RETAIL_BEVERAGES = 'RETAIL_BEVERAGES',
  RETAIL_GNG = 'RETAIL_GNG',
  RETAIL_REFRIGERATED_SNACKS = 'RETAIL_REFRIGERATED_SNACKS',
  RETAIL_SNACKS = 'RETAIL_SNACKS',
  SALADS = 'SALADS',
  SIDES = 'SIDES'
}

export enum InventoryItemTemperatureClassification {
  COLD = 'COLD',
  HOT = 'HOT',
  OFF = 'OFF'
}

export type MakePopupMenuItemAvailable = {
  id: Scalars['ID']['input'];
};

export type MakePopupMenuItemUnavailable = {
  id: Scalars['ID']['input'];
};

export type MarkOrderRequestCanceled = {
  paymentGatewayInfo?: InputMaybe<CanceledPaymentGatewayInfo>;
  requestId: Scalars['UUID']['input'];
};

export type MarkOrderRequestsAborted = {
  requestIds: Array<Scalars['ID']['input']>;
};

export type MarkReadyForPickupMobileOrderingOrder = {
  id: Scalars['ID']['input'];
  version: Scalars['ID']['input'];
};

export type MarkShadowFalsePositiveInput = {
  mode: ShadowFalsePositiveModeEnum;
  shadowId: Scalars['ID']['input'];
};

export type MarketManifestTimeInput = {
  breakfast?: InputMaybe<Array<Scalars['String']['input']>>;
  dinner?: InputMaybe<Array<Scalars['String']['input']>>;
  lunch?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum MarketScope {
  ALL_ACCOUNTING_MARKET_NAMES = 'ALL_ACCOUNTING_MARKET_NAMES',
  ALL_COHORT_NAMES = 'ALL_COHORT_NAMES',
  ALL_NAMES = 'ALL_NAMES'
}

/** Marketing segment provider */
export enum MarketingSegmentProviderEnum {
  /** Mo Engage provider */
  MO_ENGAGE = 'MO_ENGAGE'
}

/** Marketing segment state */
export enum MarketingSegmentStateEnum {
  /** Segment is active */
  ACTIVE = 'ACTIVE',
  /** Segment is archived */
  ARCHIVED = 'ARCHIVED'
}

/** Marketing segment type */
export enum MarketingSegmentTypeEnum {
  /** Account segment */
  ACCOUNT = 'ACCOUNT'
}

export enum MealPeriodEnum {
  APPETIZERS = 'APPETIZERS',
  BREAKFAST = 'BREAKFAST',
  DINNER = 'DINNER',
  LUNCH = 'LUNCH'
}

export type MealPeriodsInput = {
  appetizers: Scalars['Boolean']['input'];
  breakfast: Scalars['Boolean']['input'];
  dinner: Scalars['Boolean']['input'];
  lunch: Scalars['Boolean']['input'];
};

export enum Menu {
  CHANNEL_PARTNERSHIP = 'CHANNEL_PARTNERSHIP',
  FOOD_HALL = 'FOOD_HALL',
  POPUP = 'POPUP',
  PRE_PAID_POPUP = 'PRE_PAID_POPUP'
}

export type MenuItemSubsidy = {
  /** Redeemed amount in cents */
  amountCents: Scalars['Int']['input'];
  versionId: Scalars['UUID']['input'];
};

export type MenuTemplateInventoryItemAttributes = {
  inventoryItemId: Scalars['ID']['input'];
  preTaxPrice: Scalars['BigDecimal']['input'];
};

export type MenuTemplateSelectionGroupItemAttributes = {
  inventoryItemId: Scalars['ID']['input'];
  namePublic: Scalars['String']['input'];
  preTaxPrice: Scalars['BigDecimal']['input'];
};

export enum MenuTemplateStateEnum {
  APPROVED = 'APPROVED',
  DRAFT = 'DRAFT',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  PUBLISHED = 'PUBLISHED'
}

export enum MenuTileTypeEnum {
  MENU_TEMPLATE = 'MENU_TEMPLATE',
  MENU_TEMPLATE_CATEGORY = 'MENU_TEMPLATE_CATEGORY',
  MENU_TEMPLATE_INVENTORY_ITEM = 'MENU_TEMPLATE_INVENTORY_ITEM',
  SALES_OPTIMIZER_TO_FILL = 'SALES_OPTIMIZER_TO_FILL',
  SALE_OPTIMIZER_TO_FILL = 'SALE_OPTIMIZER_TO_FILL'
}

export type MobileOrderingCartItem = {
  id: Scalars['ID']['input'];
  options?: InputMaybe<Array<MobileOrderingCartItemOption>>;
};

export type MobileOrderingCartItemOption = {
  groupCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type MobileOrderingItemInput = {
  customizationDescription?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type MobileOrderingOrderChanged = {
  /** DEPRECATED: use eventVendorId */
  eventId?: InputMaybe<Scalars['ID']['input']>;
  eventVendorId?: InputMaybe<Scalars['ID']['input']>;
  /** DEPRECATED: use eventVendorId */
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

export type MobileOrderingOrderInput = {
  id: Scalars['ID']['input'];
  items: Array<MobileOrderingItemInput>;
  pickupId: Scalars['ID']['input'];
  pickupTime: Scalars['ISO8601DateTime']['input'];
  placedAt: Scalars['ISO8601DateTime']['input'];
  state: MobileOrderingOrderStatus;
};

export type MobileOrderingOrderRequestChildItem = {
  groupId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  /** OBSOLETED: not used anymore */
  otherTaxCents?: InputMaybe<Scalars['Int']['input']>;
  postTaxPriceCents: Scalars['Int']['input'];
  preTaxPriceCents: Scalars['Int']['input'];
  salesTaxCents: Scalars['Int']['input'];
  /** Subsidies applied to this menu item */
  subsidies?: InputMaybe<Array<MenuItemSubsidy>>;
};

export type MobileOrderingOrderRequestCoupon = {
  amountCents: Scalars['Int']['input'];
  redemptionCode: Scalars['String']['input'];
};

export enum MobileOrderingOrderRequestErrorCodeEnum {
  /** Error code 40305 */
  COUPON_ALREADY_REDEEMED = 'COUPON_ALREADY_REDEEMED',
  /** Error code 40309 */
  COUPON_EXPIRED = 'COUPON_EXPIRED',
  /** Error code 40313 */
  COUPON_NOT_FOUND = 'COUPON_NOT_FOUND',
  /** Error code 40317 */
  COUPON_NOT_YET_ACTIVE = 'COUPON_NOT_YET_ACTIVE',
  /** Error code 0 */
  ORDER_REQUEST = 'ORDER_REQUEST',
  /** Error code 40069 */
  ORDER_REQUEST_CANCEL = 'ORDER_REQUEST_CANCEL',
  /** Error code 40070 */
  ORDER_REQUEST_CANCEL_FOR_USER = 'ORDER_REQUEST_CANCEL_FOR_USER',
  /** Error code 40059 */
  ORDER_REQUEST_CHILD_MENU_ITEM_WITHOUT_GROUP = 'ORDER_REQUEST_CHILD_MENU_ITEM_WITHOUT_GROUP',
  /** Error code 40061 */
  ORDER_REQUEST_CUSTOM_ITEM_IN_GROUP = 'ORDER_REQUEST_CUSTOM_ITEM_IN_GROUP',
  /** Error code 40009 */
  ORDER_REQUEST_DISCOUNT_COUPON_UNUSED = 'ORDER_REQUEST_DISCOUNT_COUPON_UNUSED',
  /** Error code 400013 */
  ORDER_REQUEST_DISCOUNT_MULTIPLE_SAME_TYPE = 'ORDER_REQUEST_DISCOUNT_MULTIPLE_SAME_TYPE',
  /** Error code 40017 */
  ORDER_REQUEST_DISCOUNT_VOUCHER_AMOUNT_INVALID = 'ORDER_REQUEST_DISCOUNT_VOUCHER_AMOUNT_INVALID',
  /** Error code 40025 */
  ORDER_REQUEST_DISCOUNT_VOUCHER_UNUSED = 'ORDER_REQUEST_DISCOUNT_VOUCHER_UNUSED',
  /** Error code 40029 */
  ORDER_REQUEST_ID_DUPLICATE = 'ORDER_REQUEST_ID_DUPLICATE',
  /** Error code 40037 */
  ORDER_REQUEST_MENU_ITEM_CUSTOM_PRICE_INVALID = 'ORDER_REQUEST_MENU_ITEM_CUSTOM_PRICE_INVALID',
  /** Error code 40041 */
  ORDER_REQUEST_MENU_ITEM_NORMAL_INVALID = 'ORDER_REQUEST_MENU_ITEM_NORMAL_INVALID',
  /** Error code 40045 */
  ORDER_REQUEST_MENU_ITEM_NORMAL_PRICE_MISMATCH = 'ORDER_REQUEST_MENU_ITEM_NORMAL_PRICE_MISMATCH',
  /** Error code 40038 */
  ORDER_REQUEST_MENU_ITEM_OPEN_PRICE_INVALID = 'ORDER_REQUEST_MENU_ITEM_OPEN_PRICE_INVALID',
  /** Error code 40046 */
  ORDER_REQUEST_MENU_ITEM_SUBSIDY_AMOUNT_MISMATCH = 'ORDER_REQUEST_MENU_ITEM_SUBSIDY_AMOUNT_MISMATCH',
  /** Error code 40051 */
  ORDER_REQUEST_MORE_THAN_ONE_PARENT = 'ORDER_REQUEST_MORE_THAN_ONE_PARENT',
  /** Error code 40055 */
  ORDER_REQUEST_NOT_ENOUGH_MENU_ITEM_SELECTIONS = 'ORDER_REQUEST_NOT_ENOUGH_MENU_ITEM_SELECTIONS',
  /** Error code 40053 */
  ORDER_REQUEST_PARENT_CHILD_MENU_ITEM_MISMATCH = 'ORDER_REQUEST_PARENT_CHILD_MENU_ITEM_MISMATCH',
  /** Error code 40063 */
  ORDER_REQUEST_PARENT_MISSING_FROM_GROUP = 'ORDER_REQUEST_PARENT_MISSING_FROM_GROUP',
  /** Error code 40005 */
  ORDER_REQUEST_PAYMENT_REQUIRED = 'ORDER_REQUEST_PAYMENT_REQUIRED',
  /** Error code 40073 */
  ORDER_REQUEST_SCAN_TO_PAY_DISABLED = 'ORDER_REQUEST_SCAN_TO_PAY_DISABLED',
  /** Error code 40067 */
  ORDER_REQUEST_SYNC = 'ORDER_REQUEST_SYNC',
  /** Error code 40072 */
  ORDER_REQUEST_TENDER_METHOD_INVALID_FOR_ACCOUNT = 'ORDER_REQUEST_TENDER_METHOD_INVALID_FOR_ACCOUNT',
  /** Error code 40071 */
  ORDER_REQUEST_TENDER_METHOD_NOT_AVAILABLE = 'ORDER_REQUEST_TENDER_METHOD_NOT_AVAILABLE',
  /** Error code 40057 */
  ORDER_REQUEST_TOO_MANY_MENU_ITEM_SELECTIONS = 'ORDER_REQUEST_TOO_MANY_MENU_ITEM_SELECTIONS',
  /** Error code 40047 */
  ORDER_REQUEST_TOTAL_FOOD_SALES_NOT_POSITIVE = 'ORDER_REQUEST_TOTAL_FOOD_SALES_NOT_POSITIVE',
  /** Error code 40525 */
  SUBSIDY_FULL_COVERAGE_REQUIRED = 'SUBSIDY_FULL_COVERAGE_REQUIRED',
  /** Error code 40509 */
  SUBSIDY_INSTANCE_NOT_FOUND = 'SUBSIDY_INSTANCE_NOT_FOUND',
  /** Error code 40511 */
  SUBSIDY_INSTANCE_PREVIOUSLY_USED_TODAY = 'SUBSIDY_INSTANCE_PREVIOUSLY_USED_TODAY',
  /** Error code 40523 */
  SUBSIDY_MAX_AMOUNT_USED = 'SUBSIDY_MAX_AMOUNT_USED',
  /** Error code 40513 */
  SUBSIDY_MEMBERSHIP_NOT_PRESENT = 'SUBSIDY_MEMBERSHIP_NOT_PRESENT',
  /** Error code 40513 */
  SUBSIDY_MINIMUM_AMOUNT_NOT_MET = 'SUBSIDY_MINIMUM_AMOUNT_NOT_MET',
  /** Error code 40515 */
  SUBSIDY_NEW_QR_CODE = 'SUBSIDY_NEW_QR_CODE',
  /** Error code 40507 */
  SUBSIDY_NOT_AVAILABLE_AT_LOCATION = 'SUBSIDY_NOT_AVAILABLE_AT_LOCATION',
  /** Error code 40518 */
  SUBSIDY_NOT_AVAILABLE_FOR_USER = 'SUBSIDY_NOT_AVAILABLE_FOR_USER',
  /** Error code 40517 */
  SUBSIDY_NO_LONGER_AVAILABLE = 'SUBSIDY_NO_LONGER_AVAILABLE',
  /** Error code 40521 */
  SUBSIDY_REQUESTED_AMOUNT_MORE_THAN_AVAILABLE = 'SUBSIDY_REQUESTED_AMOUNT_MORE_THAN_AVAILABLE',
  /** Error code 40520 */
  SUBSIDY_RULE_NOT_AVAILABLE_TODAY = 'SUBSIDY_RULE_NOT_AVAILABLE_TODAY',
  /** Error code 40520 */
  SUBSIDY_RULE_NOT_VALID_ON_DATE = 'SUBSIDY_RULE_NOT_VALID_ON_DATE',
  /** Error code 40520 */
  SUBSIDY_USED = 'SUBSIDY_USED',
  /** Error code 40705 */
  VOUCHER_INSTANCE_NOT_FOUND = 'VOUCHER_INSTANCE_NOT_FOUND',
  /** Error code 40709 */
  VOUCHER_INVALID_AMOUNT = 'VOUCHER_INVALID_AMOUNT',
  /** Error code 40713 */
  VOUCHER_NOT_REDEEMABLE = 'VOUCHER_NOT_REDEEMABLE'
}

export type MobileOrderingOrderRequestItem = {
  customization?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  napkins: Scalars['Boolean']['input'];
  options?: InputMaybe<Array<MobileOrderingOrderRequestChildItem>>;
  /** OBSOLETED: not used anymore */
  otherTaxCents?: InputMaybe<Scalars['Int']['input']>;
  postTaxPriceCents: Scalars['Int']['input'];
  preTaxPriceCents: Scalars['Int']['input'];
  salesTaxCents: Scalars['Int']['input'];
  silverware: Scalars['Boolean']['input'];
  /** Subsidies applied to this menu item */
  subsidies?: InputMaybe<Array<MenuItemSubsidy>>;
};

export enum MobileOrderingOrderRequestPayment {
  BRAINTREE_CC_TOKEN = 'BRAINTREE_CC_TOKEN',
  BRAINTREE_PAYMENT_NONCE = 'BRAINTREE_PAYMENT_NONCE',
  CARDPOINTE_PAYMENT_NONCE = 'CARDPOINTE_PAYMENT_NONCE'
}

export enum MobileOrderingOrderRequestState {
  ACCEPTED = 'ACCEPTED',
  PAYMENT_REJECTED = 'PAYMENT_REJECTED',
  PENDING = 'PENDING'
}

export type MobileOrderingOrderRequestSubsidy = {
  amountCents: Scalars['Int']['input'];
  redemptionCode: Scalars['String']['input'];
};

export enum MobileOrderingOrderStatus {
  ABANDONED = 'ABANDONED',
  ACCEPTED = 'ACCEPTED',
  CANCELED = 'CANCELED',
  DECLINED = 'DECLINED',
  PENDING = 'PENDING',
  READY_FOR_PICKUP = 'READY_FOR_PICKUP'
}

export type MobileOrderingPayment = {
  cardId?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<MobileOrderingOrderRequestPayment>;
};

/**
 * Reason that `mobile_ordering_available` is false. Additional values may be added
 * over time; clients MUST treat unknown values as a generic 'unavailable' state
 * and fall back to `mobile_ordering_available == false`.
 */
export enum MobileOrderingUnavailableReason {
  /** All pickup slots for this popup event are at capacity. */
  CAPACITY_REACHED = 'CAPACITY_REACHED',
  /** The vendor is not enabled for mobile ordering on this event. */
  DISABLED = 'DISABLED',
  /** The popup event is past its final viable pickup window — no pickup slot remains within the minimum pickup lead time. */
  PAST_WINDOW = 'PAST_WINDOW'
}

export type MovePopupMenuTemplateCategoryGroup = {
  direction: MovementDirection;
  id: Scalars['ID']['input'];
};

export type MovePopupMenuTemplateInventoryItem = {
  direction: MovementDirection;
  id: Scalars['ID']['input'];
};

export type MovePopupMenuTemplateSelectionGroup = {
  direction: MovementDirection;
  id: Scalars['ID']['input'];
};

export type MovePopupMenuTemplateSelectionGroupOption = {
  direction: MovementDirection;
  id: Scalars['ID']['input'];
};

export enum MovementDirection {
  DOWN = 'DOWN',
  UP = 'UP'
}

export enum OperationsEnum {
  /** create operation */
  CREATE = 'CREATE',
  /** delete operation */
  DELETE = 'DELETE',
  /** manage operation */
  MANAGE = 'MANAGE',
  /** read operation */
  READ = 'READ',
  /** update operation */
  UPDATE = 'UPDATE'
}

/** Who asked for the order to be canceled */
export enum OrderCancelationRequestorEnum {
  /** The customer */
  CUSTOMER = 'CUSTOMER',
  /** The restaurant */
  VENDOR = 'VENDOR'
}

export type OrderChildItem = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  postTaxPriceCents: Scalars['Int']['input'];
  preTaxPriceCents: Scalars['Int']['input'];
  salesTaxCents: Scalars['Int']['input'];
  /** Subsidies applied to this menu item */
  subsidies?: InputMaybe<Array<MenuItemSubsidy>>;
};

export type OrderCustomItem = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  preTaxPriceCents: Scalars['Int']['input'];
  salesTaxCents: Scalars['Int']['input'];
  taxCategoryId?: InputMaybe<Scalars['ID']['input']>;
  taxRate?: InputMaybe<Scalars['BigDecimal']['input']>;
};

export type OrderDiscount = {
  amountCents: Scalars['Int']['input'];
  discountId?: InputMaybe<Scalars['ID']['input']>;
  redemptionCode?: InputMaybe<Scalars['String']['input']>;
  type: OrderDiscountEnum;
};

export enum OrderDiscountEnum {
  CASHIER_DISCOUNT = 'CASHIER_DISCOUNT',
  COUPON = 'COUPON',
  ITEM_SUBSIDY = 'ITEM_SUBSIDY',
  SUBSIDY = 'SUBSIDY',
  TENDER_METHOD = 'TENDER_METHOD',
  VOUCHER = 'VOUCHER'
}

export type OrderItem = {
  customItem?: InputMaybe<OrderCustomItem>;
  eventVendorId: Scalars['ID']['input'];
  menuItem?: InputMaybe<OrderMenuItem>;
  openItem?: InputMaybe<OrderOpenItem>;
};

export type OrderMenuItem = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  /** Options selected for this menu item */
  options?: InputMaybe<Array<OrderChildItem>>;
  /** OBSOLETED: not used anymore */
  otherTaxCents?: InputMaybe<Scalars['Int']['input']>;
  postTaxPriceCents: Scalars['Int']['input'];
  preTaxPriceCents: Scalars['Int']['input'];
  /** Type of pricing applied, e.g. per item, per pound, etc */
  priceType?: InputMaybe<PriceTypeEnum>;
  /** Amount of product if not priced per item, e.g. 0.35 (lb) */
  quantity?: InputMaybe<Scalars['BigDecimal']['input']>;
  salesTaxCents: Scalars['Int']['input'];
  /** Subsidies applied to this menu item */
  subsidies?: InputMaybe<Array<MenuItemSubsidy>>;
};

export type OrderOpenItem = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  preTaxPriceCents: Scalars['Int']['input'];
  salesTaxCents: Scalars['Int']['input'];
  taxCategoryId?: InputMaybe<Scalars['Int']['input']>;
  taxRate?: InputMaybe<Scalars['BigDecimal']['input']>;
};

export enum OrderPayment {
  BRAINTREE_PAYMENT_NONCE = 'BRAINTREE_PAYMENT_NONCE',
  CARD = 'CARD',
  CARDPOINTE_PAYMENT_NONCE = 'CARDPOINTE_PAYMENT_NONCE'
}

export type OrderReceiptRequest = {
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  phoneNumber?: InputMaybe<Scalars['PhoneNumberDigits']['input']>;
};

export type OrderRequestCoupon = {
  amountCents: Scalars['Int']['input'];
  redemptionCode: Scalars['String']['input'];
};

export enum OrderRequestErrorCodeEnum {
  /** Error code 40305 */
  COUPON_ALREADY_REDEEMED = 'COUPON_ALREADY_REDEEMED',
  /** Error code 40309 */
  COUPON_EXPIRED = 'COUPON_EXPIRED',
  /** Error code 40313 */
  COUPON_NOT_FOUND = 'COUPON_NOT_FOUND',
  /** Error code 40317 */
  COUPON_NOT_YET_ACTIVE = 'COUPON_NOT_YET_ACTIVE',
  /** Error code 0 */
  ORDER_REQUEST = 'ORDER_REQUEST',
  /** Error code 40069 */
  ORDER_REQUEST_CANCEL = 'ORDER_REQUEST_CANCEL',
  /** Error code 40070 */
  ORDER_REQUEST_CANCEL_FOR_USER = 'ORDER_REQUEST_CANCEL_FOR_USER',
  /** Error code 40059 */
  ORDER_REQUEST_CHILD_MENU_ITEM_WITHOUT_GROUP = 'ORDER_REQUEST_CHILD_MENU_ITEM_WITHOUT_GROUP',
  /** Error code 40061 */
  ORDER_REQUEST_CUSTOM_ITEM_IN_GROUP = 'ORDER_REQUEST_CUSTOM_ITEM_IN_GROUP',
  /** Error code 40009 */
  ORDER_REQUEST_DISCOUNT_COUPON_UNUSED = 'ORDER_REQUEST_DISCOUNT_COUPON_UNUSED',
  /** Error code 400013 */
  ORDER_REQUEST_DISCOUNT_MULTIPLE_SAME_TYPE = 'ORDER_REQUEST_DISCOUNT_MULTIPLE_SAME_TYPE',
  /** Error code 40017 */
  ORDER_REQUEST_DISCOUNT_VOUCHER_AMOUNT_INVALID = 'ORDER_REQUEST_DISCOUNT_VOUCHER_AMOUNT_INVALID',
  /** Error code 40025 */
  ORDER_REQUEST_DISCOUNT_VOUCHER_UNUSED = 'ORDER_REQUEST_DISCOUNT_VOUCHER_UNUSED',
  /** Error code 40029 */
  ORDER_REQUEST_ID_DUPLICATE = 'ORDER_REQUEST_ID_DUPLICATE',
  /** Error code 40031 */
  ORDER_REQUEST_ID_HAS_PENDING_REVERSE = 'ORDER_REQUEST_ID_HAS_PENDING_REVERSE',
  /** Error code 40037 */
  ORDER_REQUEST_MENU_ITEM_CUSTOM_PRICE_INVALID = 'ORDER_REQUEST_MENU_ITEM_CUSTOM_PRICE_INVALID',
  /** Error code 40041 */
  ORDER_REQUEST_MENU_ITEM_NORMAL_INVALID = 'ORDER_REQUEST_MENU_ITEM_NORMAL_INVALID',
  /** Error code 40045 */
  ORDER_REQUEST_MENU_ITEM_NORMAL_PRICE_MISMATCH = 'ORDER_REQUEST_MENU_ITEM_NORMAL_PRICE_MISMATCH',
  /** Error code 40038 */
  ORDER_REQUEST_MENU_ITEM_OPEN_PRICE_INVALID = 'ORDER_REQUEST_MENU_ITEM_OPEN_PRICE_INVALID',
  /** Error code 40046 */
  ORDER_REQUEST_MENU_ITEM_SUBSIDY_AMOUNT_MISMATCH = 'ORDER_REQUEST_MENU_ITEM_SUBSIDY_AMOUNT_MISMATCH',
  /** Error code 40051 */
  ORDER_REQUEST_MORE_THAN_ONE_PARENT = 'ORDER_REQUEST_MORE_THAN_ONE_PARENT',
  /** Error code 40055 */
  ORDER_REQUEST_NOT_ENOUGH_MENU_ITEM_SELECTIONS = 'ORDER_REQUEST_NOT_ENOUGH_MENU_ITEM_SELECTIONS',
  /** Error code 40053 */
  ORDER_REQUEST_PARENT_CHILD_MENU_ITEM_MISMATCH = 'ORDER_REQUEST_PARENT_CHILD_MENU_ITEM_MISMATCH',
  /** Error code 40063 */
  ORDER_REQUEST_PARENT_MISSING_FROM_GROUP = 'ORDER_REQUEST_PARENT_MISSING_FROM_GROUP',
  /** Error code 40005 */
  ORDER_REQUEST_PAYMENT_REQUIRED = 'ORDER_REQUEST_PAYMENT_REQUIRED',
  /** Error code 40074 */
  ORDER_REQUEST_PICKUP_ORDER_NOT_READY = 'ORDER_REQUEST_PICKUP_ORDER_NOT_READY',
  /** Error code 40073 */
  ORDER_REQUEST_SCAN_TO_PAY_DISABLED = 'ORDER_REQUEST_SCAN_TO_PAY_DISABLED',
  /** Error code 40067 */
  ORDER_REQUEST_SYNC = 'ORDER_REQUEST_SYNC',
  /** Error code 40072 */
  ORDER_REQUEST_TENDER_METHOD_INVALID_FOR_ACCOUNT = 'ORDER_REQUEST_TENDER_METHOD_INVALID_FOR_ACCOUNT',
  /** Error code 40071 */
  ORDER_REQUEST_TENDER_METHOD_NOT_AVAILABLE = 'ORDER_REQUEST_TENDER_METHOD_NOT_AVAILABLE',
  /** Error code 40057 */
  ORDER_REQUEST_TOO_MANY_MENU_ITEM_SELECTIONS = 'ORDER_REQUEST_TOO_MANY_MENU_ITEM_SELECTIONS',
  /** Error code 40047 */
  ORDER_REQUEST_TOTAL_FOOD_SALES_NOT_POSITIVE = 'ORDER_REQUEST_TOTAL_FOOD_SALES_NOT_POSITIVE',
  /** Error code 40408 */
  ORDER_REVERSE_IDEMPOTENT = 'ORDER_REVERSE_IDEMPOTENT',
  /** Error code 40525 */
  SUBSIDY_FULL_COVERAGE_REQUIRED = 'SUBSIDY_FULL_COVERAGE_REQUIRED',
  /** Error code 40509 */
  SUBSIDY_INSTANCE_NOT_FOUND = 'SUBSIDY_INSTANCE_NOT_FOUND',
  /** Error code 40511 */
  SUBSIDY_INSTANCE_PREVIOUSLY_USED_TODAY = 'SUBSIDY_INSTANCE_PREVIOUSLY_USED_TODAY',
  /** Error code 40523 */
  SUBSIDY_MAX_AMOUNT_USED = 'SUBSIDY_MAX_AMOUNT_USED',
  /** Error code 40513 */
  SUBSIDY_MEMBERSHIP_NOT_PRESENT = 'SUBSIDY_MEMBERSHIP_NOT_PRESENT',
  /** Error code 40513 */
  SUBSIDY_MINIMUM_AMOUNT_NOT_MET = 'SUBSIDY_MINIMUM_AMOUNT_NOT_MET',
  /** Error code 40515 */
  SUBSIDY_NEW_QR_CODE = 'SUBSIDY_NEW_QR_CODE',
  /** Error code 40507 */
  SUBSIDY_NOT_AVAILABLE_AT_LOCATION = 'SUBSIDY_NOT_AVAILABLE_AT_LOCATION',
  /** Error code 40518 */
  SUBSIDY_NOT_AVAILABLE_FOR_USER = 'SUBSIDY_NOT_AVAILABLE_FOR_USER',
  /** Error code 40517 */
  SUBSIDY_NO_LONGER_AVAILABLE = 'SUBSIDY_NO_LONGER_AVAILABLE',
  /** Error code 40521 */
  SUBSIDY_REQUESTED_AMOUNT_MORE_THAN_AVAILABLE = 'SUBSIDY_REQUESTED_AMOUNT_MORE_THAN_AVAILABLE',
  /** Error code 40520 */
  SUBSIDY_RULE_NOT_AVAILABLE_TODAY = 'SUBSIDY_RULE_NOT_AVAILABLE_TODAY',
  /** Error code 40520 */
  SUBSIDY_RULE_NOT_VALID_ON_DATE = 'SUBSIDY_RULE_NOT_VALID_ON_DATE',
  /** Error code 40520 */
  SUBSIDY_USED = 'SUBSIDY_USED',
  /** Error code 40705 */
  VOUCHER_INSTANCE_NOT_FOUND = 'VOUCHER_INSTANCE_NOT_FOUND',
  /** Error code 40709 */
  VOUCHER_INVALID_AMOUNT = 'VOUCHER_INVALID_AMOUNT',
  /** Error code 40713 */
  VOUCHER_NOT_REDEEMABLE = 'VOUCHER_NOT_REDEEMABLE'
}

export type OrderRequestPayment = {
  paymentId: Scalars['ID']['input'];
  paymentType: OrderPayment;
};

export enum OrderRequestPaymentMethod {
  CARD = 'CARD',
  CASH = 'CASH',
  NO_PAYMENT = 'NO_PAYMENT'
}

export type OrderRequestRefund = {
  customerOrderIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  requestId: Scalars['ID']['input'];
};

export enum OrderRequestStateEnum {
  ABORTED = 'ABORTED',
  AUTHORIZED = 'AUTHORIZED',
  CANCELED = 'CANCELED',
  PAID = 'PAID',
  PENDING = 'PENDING',
  REFUNDED = 'REFUNDED',
  UNPAID = 'UNPAID'
}

export type OrderRequestSubsidy = {
  amountCents: Scalars['Int']['input'];
  redemptionCode: Scalars['String']['input'];
};

export enum OwnerTypeEnum {
  /** Account Owner Type */
  Account = 'Account',
  /** Vendor Owner Type */
  Vendor = 'Vendor'
}

export enum PaymentGateway {
  BRAINTREE = 'BRAINTREE',
  CARDPOINTE = 'CARDPOINTE',
  PAYPAL = 'PAYPAL',
  WORLDNET = 'WORLDNET'
}

export type PaymentGatewayInfo = {
  paymentGateway: PaymentGateway;
  /** DEPRECATED: End of support in 2023 */
  paypalResponse?: InputMaybe<PaypalResponse>;
  worldnetResponse?: InputMaybe<WorldnetResponse>;
};

export enum PaymentLineItemTypeEnum {
  CARD_PAYMENT = 'CARD_PAYMENT',
  CASH_PAYMENT = 'CASH_PAYMENT',
  DISCOUNT_PAYMENT = 'DISCOUNT_PAYMENT',
  INVOICE_PAYMENT = 'INVOICE_PAYMENT',
  MISC_PAYMENT = 'MISC_PAYMENT'
}

export enum PaymentMethod {
  CARD = 'CARD',
  CASH = 'CASH',
  DISCOUNT = 'DISCOUNT'
}

export enum PaymentMethodEnum {
  FOODA_INITIATED_ACH_PULL = 'FOODA_INITIATED_ACH_PULL',
  FOODA_INITIATED_CREDIT_CARD = 'FOODA_INITIATED_CREDIT_CARD',
  PARTY_INITIATED_ACH_PULL = 'PARTY_INITIATED_ACH_PULL',
  PARTY_INITIATED_CHECK = 'PARTY_INITIATED_CHECK'
}

export enum PaymentRefundLineItemTypeEnum {
  CARD_PAYMENT_REFUND = 'CARD_PAYMENT_REFUND',
  CASH_PAYMENT_REFUND = 'CASH_PAYMENT_REFUND'
}

export enum PaymentTermEnum {
  NET_1 = 'NET_1',
  NET_2 = 'NET_2',
  NET_3 = 'NET_3',
  NET_4 = 'NET_4',
  NET_5 = 'NET_5',
  NET_6 = 'NET_6',
  NET_7 = 'NET_7',
  NET_8 = 'NET_8',
  NET_9 = 'NET_9',
  NET_10 = 'NET_10',
  NET_11 = 'NET_11',
  NET_12 = 'NET_12',
  NET_13 = 'NET_13',
  NET_14 = 'NET_14',
  NET_15 = 'NET_15',
  NET_16 = 'NET_16',
  NET_17 = 'NET_17',
  NET_18 = 'NET_18',
  NET_19 = 'NET_19',
  NET_20 = 'NET_20',
  NET_21 = 'NET_21',
  NET_22 = 'NET_22',
  NET_23 = 'NET_23',
  NET_24 = 'NET_24',
  NET_25 = 'NET_25',
  NET_26 = 'NET_26',
  NET_27 = 'NET_27',
  NET_28 = 'NET_28',
  NET_29 = 'NET_29',
  NET_30 = 'NET_30',
  NET_31 = 'NET_31',
  NET_32 = 'NET_32',
  NET_33 = 'NET_33',
  NET_34 = 'NET_34',
  NET_35 = 'NET_35',
  NET_36 = 'NET_36',
  NET_37 = 'NET_37',
  NET_38 = 'NET_38',
  NET_39 = 'NET_39',
  NET_40 = 'NET_40',
  NET_41 = 'NET_41',
  NET_42 = 'NET_42',
  NET_43 = 'NET_43',
  NET_44 = 'NET_44',
  NET_45 = 'NET_45',
  NET_60 = 'NET_60',
  NET_90 = 'NET_90',
  NET_120 = 'NET_120',
  NO_TERMS = 'NO_TERMS'
}

export type PaypalResponse = {
  amountCents?: InputMaybe<Scalars['Int']['input']>;
  captureId?: InputMaybe<Scalars['String']['input']>;
  cardIssuer?: InputMaybe<CardIssuer>;
  cardholderName?: InputMaybe<Scalars['String']['input']>;
  correlationId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['String']['input'];
  lastFour?: InputMaybe<Scalars['String']['input']>;
  receiptPreferenceToken?: InputMaybe<Scalars['String']['input']>;
  responseCode?: InputMaybe<Scalars['Int']['input']>;
  transactionHandle?: InputMaybe<Scalars['String']['input']>;
  transactionNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum PhoneVerificationMethod {
  SMS = 'SMS'
}

export type PhysicalSecurityResponse = {
  questionId: Scalars['ID']['input'];
  response: Scalars['String']['input'];
};

export type PickupOrderingWindowInput = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

export enum PopupEventStatusEnum {
  ACTIVE = 'ACTIVE',
  AUTO_CANCELED = 'AUTO_CANCELED',
  AUTO_GENERATED = 'AUTO_GENERATED',
  CANCELED = 'CANCELED',
  COMPLETE = 'COMPLETE',
  FINAL = 'FINAL',
  PROPOSED = 'PROPOSED',
  SCHEDULED = 'SCHEDULED',
  UNDEFINED = 'UNDEFINED'
}

export enum PopupEventVendorStatus {
  ACTIVE = 'ACTIVE',
  CANCELED_SCHEDULE_CHANGE = 'CANCELED_SCHEDULE_CHANGE',
  CANCELED_VENDOR_CANCELLATION = 'CANCELED_VENDOR_CANCELLATION'
}

export type PopupMenuTemplateAttributes = {
  allowAsapOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  asapMinutes?: InputMaybe<Scalars['Int']['input']>;
  cuisines: Array<CuisineNames>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  expectedPickupOrderPercentage?: InputMaybe<Scalars['Int']['input']>;
  hiddenFromCustomerCampaignsEmail: Scalars['Boolean']['input'];
  hiddenFromCustomerMenu: Scalars['Boolean']['input'];
  hiddenFromFfrMenu?: InputMaybe<Scalars['Boolean']['input']>;
  mealPeriods: Array<MealPeriodEnum>;
  name: Scalars['String']['input'];
  overrideSpotLocationCapacity?: InputMaybe<Scalars['Boolean']['input']>;
  residentVendorMenu?: InputMaybe<Scalars['Boolean']['input']>;
  schedulerConfig?: InputMaybe<PopupMenuTemplateSchedulerConfigInput>;
  startDate: Scalars['ISO8601DateTime']['input'];
  state: MenuTemplateStateEnum;
};

export type PopupMenuTemplateInventoryItemAttributes = {
  availableInPersonOnly?: InputMaybe<Scalars['Boolean']['input']>;
  defaultForExpressCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  nameForVendor?: InputMaybe<Scalars['String']['input']>;
  namePublic?: InputMaybe<Scalars['String']['input']>;
  preTaxPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  priceType: PriceTypeEnum;
  showOnMenu?: InputMaybe<Scalars['Boolean']['input']>;
  showOnPos?: InputMaybe<Scalars['Boolean']['input']>;
  taxCategoryId?: InputMaybe<Scalars['Int']['input']>;
};

export type PopupMenuTemplateLocationPreferenceInput = {
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PopupMenuTemplateLocationTypesInput = {
  allPopups: Scalars['Boolean']['input'];
  channelPartnership: Scalars['Boolean']['input'];
  foodHall: Scalars['Boolean']['input'];
  prePaidPopup: Scalars['Boolean']['input'];
};

export type PopupMenuTemplateSchedulerConfigInput = {
  locationPreferences: PopupMenuTemplateLocationPreferenceInput;
  locationTypes: PopupMenuTemplateLocationTypesInput;
};

export enum PopupOrderProcessState {
  PROCESSED = 'PROCESSED',
  UNPROCESSED = 'UNPROCESSED'
}

export enum PopupOrderRequestState {
  ABORTED = 'ABORTED',
  AUTHORIZATION_FAILED = 'AUTHORIZATION_FAILED',
  AUTHORIZED = 'AUTHORIZED',
  CANCELED = 'CANCELED',
  PAID = 'PAID',
  PENDING = 'PENDING',
  REFUNDED = 'REFUNDED',
  UNPAID = 'UNPAID'
}

export enum PriceTypeEnum {
  PER_ITEM = 'PER_ITEM',
  /** @deprecated Price type 'per_ounce' is deprecated. Please use 'per_pound' instead. */
  PER_OUNCE = 'PER_OUNCE',
  PER_POUND = 'PER_POUND'
}

export enum ProductEnum {
  CAFE = 'CAFE',
  CATERING = 'CATERING',
  DELIVERY = 'DELIVERY',
  FOODA_CARD = 'FOODA_CARD',
  FOODSBY = 'FOODSBY',
  PANTRY = 'PANTRY',
  POPUP = 'POPUP'
}

/** Prompt configuration input */
export type PromptConfigInput = {
  /** Master template with {{VARIABLE}} placeholders */
  masterTemplate: Scalars['String']['input'];
  /** JSON string of model-specific parameters (temperature, max_tokens, etc.) */
  modelParamsJson?: InputMaybe<Scalars['String']['input']>;
  /** JSON string of variable definitions with resolvers and params */
  variablesJson?: InputMaybe<Scalars['String']['input']>;
};

/** Context input for prompt preview and testing */
export type PromptContextInput = {
  /** Event vendor IDs to scope available menu items (defaults to all vendors) */
  eventVendorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Maximum number of feedback records to include */
  feedbackLimit?: InputMaybe<Scalars['Int']['input']>;
  /** Feedback action types to include (e.g., SHOWN, CLICKED) */
  feedbackTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Toggle to include feedback data */
  includeFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  /** Toggle to include order history data */
  includeOrderHistory?: InputMaybe<Scalars['Boolean']['input']>;
  /** Toggle to include user profile data */
  includeProfile?: InputMaybe<Scalars['Boolean']['input']>;
  /** Item ID for UpSell selected item context preview */
  itemId?: InputMaybe<Scalars['ID']['input']>;
  /** Item IDs for CrossSell cart context preview */
  itemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Recommendation model ID to infer task/adaptor */
  modelId: Scalars['ID']['input'];
  /** User profile JSON to inject into prompt context */
  profileJson?: InputMaybe<Scalars['String']['input']>;
  /** Target ID */
  targetId: Scalars['ID']['input'];
  /** Target type (Event, SelectEvent, Popup::PopupEvent) */
  targetType: Scalars['String']['input'];
  /** User ID to pull real context (feedback, orders) */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type PublishMobileOrderingUpdate = {
  eventId: Scalars['ID']['input'];
  mobileOrder: MobileOrderingOrderInput;
  vendorId: Scalars['ID']['input'];
};

export enum PushNotificationProviders {
  MOENGAGE = 'MOENGAGE'
}

export enum QAToolsRequestTypeEnum {
  /** Run the QaTools::Scripts::AnyScript QA script */
  AnyScript = 'AnyScript',
  /** Run the QaTools::Scripts::AutomationScripts QA script */
  AutomationScripts = 'AutomationScripts',
  /** Run the QaTools::Scripts::GenerateBillingSummaryDocument QA script */
  GenerateBillingSummaryDocument = 'GenerateBillingSummaryDocument',
  /** Run the QaTools::Scripts::GeneratePdfConsolidatedInvoice QA script */
  GeneratePdfConsolidatedInvoice = 'GeneratePdfConsolidatedInvoice',
  /** Run the QaTools::Scripts::LockPopupCafeConsolidatedInvoice QA script */
  LockPopupCafeConsolidatedInvoice = 'LockPopupCafeConsolidatedInvoice',
  /** Run the QaTools::Scripts::ProcessConsumerDataRequests QA script */
  ProcessConsumerDataRequests = 'ProcessConsumerDataRequests',
  /** Run the QaTools::Scripts::PushDeliveryEventsToAvalara QA script */
  PushDeliveryEventsToAvalara = 'PushDeliveryEventsToAvalara',
  /** Run the QaTools::Scripts::RunScimUserExport QA script */
  RunScimUserExport = 'RunScimUserExport',
  /** Run the QaTools::Scripts::SettingMinimalVersionOnIosAndAndroid QA script */
  SettingMinimalVersionOnIosAndAndroid = 'SettingMinimalVersionOnIosAndAndroid',
  /** Run the QaTools::Scripts::SettleCronJobForCateringEvents QA script */
  SettleCronJobForCateringEvents = 'SettleCronJobForCateringEvents',
  /** Run the QaTools::Scripts::SimpleCalc QA script */
  SimpleCalc = 'SimpleCalc',
  /** Run the QaTools::Scripts::SyncUserToMoengage QA script */
  SyncUserToMoengage = 'SyncUserToMoengage',
  /** Run the QaTools::Scripts::TriggerEventCampaign QA script */
  TriggerEventCampaign = 'TriggerEventCampaign'
}

export type QaToolsInput = {
  a?: InputMaybe<Scalars['String']['input']>;
  androidVersion?: InputMaybe<Scalars['String']['input']>;
  automationScriptParam?: InputMaybe<Scalars['String']['input']>;
  automationScriptPath?: InputMaybe<Scalars['String']['input']>;
  b?: InputMaybe<Scalars['String']['input']>;
  ciId?: InputMaybe<Scalars['String']['input']>;
  consolidatedInvoiceId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailType?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  eventsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  iosVersion?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<Scalars['String']['input']>;
  scriptPath?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

/** A menu item for recommendations */
export type RecommendationItemInput = {
  /** Event vendor ID */
  eventVendorId: Scalars['ID']['input'];
  /** Menu item ID */
  id: Scalars['ID']['input'];
  /** Array of modifier IDs */
  modifiersIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Quantity of the item */
  quantity: Scalars['Float']['input'];
  /** Array of side item IDs */
  sidesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum RecommendationRequestTypes {
  CROSS_SELL = 'CROSS_SELL',
  FLAVOUR_ME = 'FLAVOUR_ME',
  UP_SELL = 'UP_SELL'
}

export enum RecommendationStatus {
  /** Request failed - stop polling */
  ERROR = 'ERROR',
  /** User reached limit - stop polling */
  LIMIT_REACHED = 'LIMIT_REACHED',
  /** Still generating - continue polling */
  PENDING = 'PENDING',
  /** Recommendations are available */
  READY = 'READY'
}

export type RecommendationsCustomPreferenceInput = {
  tag: InventoryItemExternalTags;
  /** Like/dislike signal in [-1, 1]. Omit to record a like. */
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export enum RecommendationsFeedbackAction {
  CART_ADDED = 'CART_ADDED',
  CART_REMOVED = 'CART_REMOVED',
  CLICKED = 'CLICKED',
  DISMISSED = 'DISMISSED',
  GENERATED = 'GENERATED',
  PURCHASED = 'PURCHASED',
  SHOWN = 'SHOWN'
}

export enum RecommendationsFeedbackTarget {
  RECOMMENDATION = 'RECOMMENDATION',
  SESSION = 'SESSION'
}

export type RecommendationsTagGroupInput = {
  iconName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** Tags in display order */
  tags: Array<InventoryItemExternalTags>;
};

export type RecurrenceWeekInput = {
  days: Array<Day>;
  weekNumber: Scalars['Int']['input'];
};

export type ReferralAttributes = {
  code: Scalars['String']['input'];
};

export type RefundDeliveryOrder = {
  /** Required when refunding a whole order with DELIVERY_VENDOR at fault */
  deliveryVendorId?: InputMaybe<Scalars['ID']['input']>;
  /** Items to refund. Omit, or name every item on an order with no prior refunds, to refund the whole order */
  orderItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  partyAtFault: DeliveryRefundPartyAtFaultEnum;
  reason: DeliveryRefundReasonEnum;
  /** Delivery order uuid */
  requestId: Scalars['ID']['input'];
  /** Emails the customer an updated receipt */
  sendUpdatedReceipt?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RegisterPosPaymentAttempt = {
  eventId: Scalars['ID']['input'];
  eventVendorIds: Array<Scalars['ID']['input']>;
  gatewayResponse?: InputMaybe<Scalars['String']['input']>;
  lookup: Scalars['Boolean']['input'];
  requestId: Scalars['UUID']['input'];
  success: Scalars['Boolean']['input'];
  transactionDate: Scalars['ISO8601DateTime']['input'];
};

/** Remove a pull-funding bank account */
export type RemoveFoodaCardBankAccount = {
  bankAccountId: Scalars['ID']['input'];
  stripeAccountId: Scalars['ID']['input'];
};

export enum ReportConfigurationTypeEnum {
  FOODA_FOR_BUSINESS = 'FOODA_FOR_BUSINESS',
  FOODA_FOR_RESTAURANTS = 'FOODA_FOR_RESTAURANTS'
}

/** Re-run all cases or only failed cases in a backtest */
export type RerunBacktestCasesInput = {
  /** UUID of the backtest to re-run */
  backtestId: Scalars['String']['input'];
  /** If true, re-run only failed cases. If false, re-run all cases. */
  failedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ReviewOptionDisposition {
  NEGATIVE = 'NEGATIVE',
  POSITIVE = 'POSITIVE'
}

export enum RewardsAction {
  ADMIN_CHANGE = 'ADMIN_CHANGE',
  CARD_RECOGNIZED_CUSTOMER_ORDER_PURCHASE = 'CARD_RECOGNIZED_CUSTOMER_ORDER_PURCHASE',
  COUPON_REWARD = 'COUPON_REWARD',
  CUSTOMER_ORDER_PURCHASE = 'CUSTOMER_ORDER_PURCHASE',
  CUSTOMER_ORDER_REFUND = 'CUSTOMER_ORDER_REFUND',
  ENTERED_DIGITS_CUSTOMER_ORDER_PURCHASE = 'ENTERED_DIGITS_CUSTOMER_ORDER_PURCHASE',
  FOODA_PAYMENT_RECOGNIZED_CUSTOMER_ORDER_PURCHASE = 'FOODA_PAYMENT_RECOGNIZED_CUSTOMER_ORDER_PURCHASE',
  REWARDS_MEMBER_CUSTOMER_ORDER_PURCHASE = 'REWARDS_MEMBER_CUSTOMER_ORDER_PURCHASE'
}

export type ScanToPayCartChildMenuItemInput = {
  groupCode: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type ScanToPayCartCustomItemInput = {
  name: Scalars['String']['input'];
  preTaxPriceCents: Scalars['Int']['input'];
  salesTaxCents: Scalars['Int']['input'];
  taxCategoryId?: InputMaybe<Scalars['ID']['input']>;
  taxRate?: InputMaybe<Scalars['BigDecimal']['input']>;
};

export type ScanToPayCartMenuItemInput = {
  id: Scalars['ID']['input'];
  /** Options selected for this cart menu item */
  options?: InputMaybe<Array<ScanToPayCartChildMenuItemInput>>;
  /** Type of pricing applied, e.g. per item, per pound, etc */
  priceType: PriceTypeEnum;
  /** Amount of product if not priced per item, e.g. 0.35 (lb) */
  quantity: Scalars['BigDecimal']['input'];
};

export type ScanToPayCreateOrderRequest = {
  coupon?: InputMaybe<OrderRequestCoupon>;
  eventId: Scalars['ID']['input'];
  idempotencyKey: Scalars['UUID']['input'];
  items: Array<ScanToPayOrderItem>;
  payment?: InputMaybe<OrderRequestPayment>;
  receiptRequest?: InputMaybe<OrderReceiptRequest>;
  subsidy?: InputMaybe<OrderRequestSubsidy>;
};

export type ScanToPayInputCartItem = {
  customItem?: InputMaybe<ScanToPayCartCustomItemInput>;
  eventVendorId: Scalars['ID']['input'];
  menuItem?: InputMaybe<ScanToPayCartMenuItemInput>;
  ticketId?: InputMaybe<Scalars['ID']['input']>;
};

export type ScanToPayOrderItem = {
  customItem?: InputMaybe<OrderCustomItem>;
  eventVendorId: Scalars['ID']['input'];
  menuItem?: InputMaybe<OrderMenuItem>;
  ticketId: Scalars['ID']['input'];
};

export type ScheduleFrequencyInput = {
  interval: Scalars['Int']['input'];
  monthlyByDates?: InputMaybe<Array<Scalars['Int']['input']>>;
  monthlyByDaysOfWeek?: InputMaybe<Array<RecurrenceWeekInput>>;
  ruleType: DateRecurrence;
  weeklyDays?: InputMaybe<Array<Day>>;
};

export type ScoringEventTypeAttributes = {
  id: Scalars['ID']['input'];
  slope: Scalars['BigDecimal']['input'];
  weight: Scalars['BigDecimal']['input'];
};

export enum SearchDataSourcesEnum {
  ACCOUNTS = 'ACCOUNTS',
  CONSOLIDATED_INVOICES = 'CONSOLIDATED_INVOICES',
  EVENTS = 'EVENTS',
  INVOICES = 'INVOICES',
  PARTNERS = 'PARTNERS',
  POPUP_EVENTS = 'POPUP_EVENTS',
  SELECT_EVENTS = 'SELECT_EVENTS',
  VENDORS = 'VENDORS'
}

export type SearchEventVendorsInput = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  /** Applies to popup/cafe event vendors */
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  endTimeAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  endTimeBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  eventStatuses?: InputMaybe<Array<EventStatus>>;
  /** When true, uses food_delivered attribute to determine delivery event vendor completion status */
  includeLiveDeliveryStatus?: InputMaybe<Scalars['Boolean']['input']>;
  /** Apply different filters/sorting according to perspective */
  perspective?: InputMaybe<SearchPerspectiveEnum>;
  productTypes?: InputMaybe<Array<EventProduct>>;
  startTimeAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  startTimeBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  vendorIds: Array<Scalars['ID']['input']>;
  /** Applies to popup/cafe event vendors */
  vendorStatuses?: InputMaybe<Array<PopupEventVendorStatus>>;
};

export type SearchInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  dataSource?: InputMaybe<SearchDataSourcesEnum>;
  marketIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Number of results per data source */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  queryString: Scalars['String']['input'];
};

export enum SearchPerspectiveEnum {
  /**
   * Account/customer perspective. Uses standard event start/end times for all
   * products. Default behavior for customer-facing queries.
   */
  ACCOUNT = 'ACCOUNT',
  /**
   * Restaurant/vendor perspective. Delivery events filtered by ordering window end
   * time (when prep starts) and delivery time instead of event start/end. Sorts by
   * product-appropriate times. Use for vendor-facing interfaces.
   */
  RESTAURANT = 'RESTAURANT'
}

export type SearchPopupEventVendor = {
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  endTimeAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  endTimeBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  eventStatuses?: InputMaybe<Array<PopupEventStatusEnum>>;
  limit: Scalars['Int']['input'];
  startTimeAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  startTimeBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  statuses?: InputMaybe<Array<PopupEventVendorStatus>>;
  vendors?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SearchPopupMenuItemInput = {
  barcode: Scalars['String']['input'];
  popupEventId: Scalars['ID']['input'];
};

export type SearchPublicEvents = {
  accountId: Scalars['ID']['input'];
  buildingId?: InputMaybe<Scalars['ID']['input']>;
  endTimeAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  endTimeBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  productTypes?: InputMaybe<Array<EventProduct>>;
  startTimeAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  startTimeBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  statuses: Array<EventStatus>;
};

export type SearchUserAccountBuilding = {
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type SearchUsers = {
  legacyRole?: InputMaybe<UserLegacyRoles>;
  searchText: Scalars['String']['input'];
};

export type SearchVendorsInput = {
  /** Restrict results to the given markets */
  marketIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  /** When given, only vendors active for this product are returned */
  product?: InputMaybe<EventProduct>;
  /** Matches vendor name / internal name (or id when numeric) */
  queryString: Scalars['String']['input'];
  /** Restrict results to these vendor states. When omitted or empty, vendors in every state are returned */
  states?: InputMaybe<Array<VendorState>>;
};

export enum SelectEventStatusEnum {
  ACTIVE = 'ACTIVE',
  AUTO_CANCELED = 'AUTO_CANCELED',
  AUTO_GENERATED = 'AUTO_GENERATED',
  CANCELED = 'CANCELED',
  COMPLETE = 'COMPLETE',
  FINAL = 'FINAL',
  IN_PROGRESS = 'IN_PROGRESS',
  PROPOSED = 'PROPOSED',
  SCHEDULED = 'SCHEDULED'
}

export type SendChatMessage = {
  conversationId?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  parentMessageId?: InputMaybe<Scalars['String']['input']>;
};

export type SendResetPasswordEmail = {
  email: Scalars['String']['input'];
  template: Scalars['String']['input'];
};

export type SendSubsidyPasses = {
  accountId: Scalars['ID']['input'];
  destinations: Array<SubsidyPassDestination>;
  /** Defaults to GUEST_PASS */
  kind?: InputMaybe<SubsidyKind>;
  /** GUEST_PASS + SELECTED only */
  passIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  scope: SubsidyPassScope;
  subsidyRuleId?: InputMaybe<Scalars['ID']['input']>;
  /** MEMBER + SELECTED only */
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SetCafeStationSiteDirection = {
  cafeStationId: Scalars['ID']['input'];
  siteDirection?: InputMaybe<SetCafeStationSiteDirectionAttributes>;
};

export type SetCafeStationSiteDirectionAttributes = {
  documentContentType: Scalars['String']['input'];
  documentFileName: Scalars['String']['input'];
  documentFileSize: Scalars['Int']['input'];
  uploadedFileKey: Scalars['String']['input'];
};

export type SetNewPassword = {
  oldPassword?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};

export enum ShadowFalsePositiveModeEnum {
  NONE = 'NONE',
  PERMANENT = 'PERMANENT',
  TEMPORARY = 'TEMPORARY'
}

export enum SiteDirectionsTokenStateEnum {
  CONFIRMED_FROM_EXPIRED = 'CONFIRMED_FROM_EXPIRED',
  EXPIRED = 'EXPIRED',
  INACTIVE = 'INACTIVE',
  OPENED = 'OPENED',
  PENDING = 'PENDING',
  RETRYABLE = 'RETRYABLE',
  SCHEDULED = 'SCHEDULED',
  SENDING = 'SENDING',
  SENT = 'SENT'
}

export enum SiteManagementFee {
  FLAT_FEE = 'FLAT_FEE',
  NONE = 'NONE',
  PERCENTAGE = 'PERCENTAGE'
}

export type SiteManagementFeeConfigInput = {
  siteManagementFeeCents?: InputMaybe<Scalars['Int']['input']>;
  siteManagementFeeRate?: InputMaybe<Scalars['Float']['input']>;
  siteManagementFeeRecipientId?: InputMaybe<Scalars['ID']['input']>;
  siteManagementFeeRecipientType?: InputMaybe<SiteManagementFeeRecipientEnum>;
  siteManagementFeeType?: InputMaybe<SiteManagementFee>;
};

export enum SiteManagementFeeRecipientEnum {
  EVENT_FINANCE_AGENT = 'EVENT_FINANCE_AGENT',
  PARTNER = 'PARTNER',
  VENDOR = 'VENDOR'
}

export enum SoldOutRestaurantEnum {
  HIDE = 'HIDE',
  SHOW = 'SHOW'
}

/** Discover eligible backtest cases from user order histories */
export type StartBacktestDiscoveryInput = {
  /** Maximum number of test cases to select */
  maxTestCases: Scalars['Int']['input'];
  /** ID of the recommendations model to backtest */
  modelId: Scalars['ID']['input'];
  /** List of user IDs to scan for eligible test cases */
  userIds: Array<Scalars['ID']['input']>;
};

/** Start execution of a discovered backtest run */
export type StartBacktestRunInput = {
  /** UUID of the discovered backtest to execute */
  backtestId: Scalars['String']['input'];
  /** Evaluator strategy to use (e.g. accuracy) */
  evaluatorType: Scalars['String']['input'];
  /** Test case indices to exclude from execution */
  excludedIndices?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum StateEnum {
  /** canceled State */
  canceled = 'canceled',
  /** complete State */
  complete = 'complete',
  /** expired State */
  expired = 'expired',
  /** incomplete State */
  incomplete = 'incomplete'
}

export enum StationTypes {
  BAR = 'BAR',
  BARISTA = 'BARISTA',
  BREAKFAST = 'BREAKFAST',
  BREAKFAST_WEIGHTED_BAR = 'BREAKFAST_WEIGHTED_BAR',
  CANTINA = 'CANTINA',
  DELI = 'DELI',
  FEATURE_STATION = 'FEATURE_STATION',
  GRAB_AND_GO = 'GRAB_AND_GO',
  GRILL = 'GRILL',
  MADE_TO_ORDER_SALAD = 'MADE_TO_ORDER_SALAD',
  MICRO_MARKET = 'MICRO_MARKET',
  PIZZA = 'PIZZA',
  RETAIL = 'RETAIL',
  ROTATING_POPUP = 'ROTATING_POPUP',
  SMOOTHIE = 'SMOOTHIE',
  SOUP = 'SOUP',
  SUSHI = 'SUSHI',
  WEIGHTED_HOT_BAR = 'WEIGHTED_HOT_BAR',
  WEIGHTED_SALAD_BAR = 'WEIGHTED_SALAD_BAR'
}

/** Possible disabled_reason values for a Stripe Issuing Cardholder */
export enum StripeCardholderDisabledReasonEnum {
  LISTED = 'LISTED',
  REJECTED_LISTED = 'REJECTED_LISTED',
  REQUIREMENTS_PAST_DUE = 'REQUIREMENTS_PAST_DUE',
  UNDER_REVIEW = 'UNDER_REVIEW'
}

/** Possible past_due requirement fields for a Stripe Issuing Cardholder */
export enum StripeCardholderRequirementEnum {
  COMPANY_TAX_ID = 'COMPANY_TAX_ID',
  INDIVIDUAL_CARD_ISSUING_USER_TERMS_ACCEPTANCE_DATE = 'INDIVIDUAL_CARD_ISSUING_USER_TERMS_ACCEPTANCE_DATE',
  INDIVIDUAL_CARD_ISSUING_USER_TERMS_ACCEPTANCE_IP = 'INDIVIDUAL_CARD_ISSUING_USER_TERMS_ACCEPTANCE_IP',
  INDIVIDUAL_DOB_DAY = 'INDIVIDUAL_DOB_DAY',
  INDIVIDUAL_DOB_MONTH = 'INDIVIDUAL_DOB_MONTH',
  INDIVIDUAL_DOB_YEAR = 'INDIVIDUAL_DOB_YEAR',
  INDIVIDUAL_FIRST_NAME = 'INDIVIDUAL_FIRST_NAME',
  INDIVIDUAL_LAST_NAME = 'INDIVIDUAL_LAST_NAME',
  INDIVIDUAL_VERIFICATION_DOCUMENT = 'INDIVIDUAL_VERIFICATION_DOCUMENT'
}

export enum SubjectKind {
  POPUP_EVENT = 'POPUP_EVENT',
  POPUP_EVENT_MENU_ITEM = 'POPUP_EVENT_MENU_ITEM'
}

export enum SubmissionStatusEnum {
  /** No submission exists for this vendor+product+month */
  NOT_SUBMITTED = 'NOT_SUBMITTED',
  /** Availability has been submitted for this period */
  SUBMITTED = 'SUBMITTED'
}

export type SubmitChatFeedback = {
  comment?: InputMaybe<Scalars['String']['input']>;
  conversationId: Scalars['String']['input'];
  messageCopiedAt?: InputMaybe<Scalars['String']['input']>;
  messageId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  usefulness: Scalars['String']['input'];
};

export type SubmitPhoneVerificationCode = {
  verificationCode: Scalars['String']['input'];
};

/** Submit feedback for a recommendation or session */
export type SubmitRecommendationsFeedbackInput = {
  /** Type of feedback action */
  actionType: RecommendationsFeedbackAction;
  /** Optional notes or additional context */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Type of target */
  targetType: RecommendationsFeedbackTarget;
  /** UUID of the target (recommendation or session) */
  targetUuid: Scalars['ID']['input'];
};

export type SubmitVendorAvailabilityInput = {
  cancellationAcknowledged: Scalars['Boolean']['input'];
  dates: Array<AvailabilityDateInput>;
  mealPeriods?: InputMaybe<MealPeriodsInput>;
  month: Scalars['Int']['input'];
  productType: ProductEnum;
  submissionVersion?: InputMaybe<Scalars['Int']['input']>;
  vendorId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};

export type SubmitVerificationCode = {
  tempUserId?: InputMaybe<Scalars['ID']['input']>;
  verificationCode: Scalars['String']['input'];
  verificationMethod?: InputMaybe<UserVerificationMethod>;
};

export enum SubsidyApproval {
  AUTO_APPROVAL = 'AUTO_APPROVAL',
  DOMAIN_APPROVAL = 'DOMAIN_APPROVAL',
  MANUAL_APPROVAL = 'MANUAL_APPROVAL'
}

export enum SubsidyApprovalAction {
  ADD = 'ADD',
  SKIP = 'SKIP'
}

export enum SubsidyKind {
  GUEST_PASS = 'GUEST_PASS',
  MEMBER = 'MEMBER',
  QUICK_ADD = 'QUICK_ADD'
}

export enum SubsidyLocationRestrictionEnum {
  ACCOUNT = 'ACCOUNT',
  EVERYWHERE = 'EVERYWHERE',
  SPECIFIC = 'SPECIFIC'
}

export type SubsidyMemberAttributes = {
  ruleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export enum SubsidyMemberSortingField {
  EMAIL_ASC = 'EMAIL_ASC',
  EMAIL_DESC = 'EMAIL_DESC',
  LAST_REDEMPTION_DATE_ASC = 'LAST_REDEMPTION_DATE_ASC',
  LAST_REDEMPTION_DATE_DESC = 'LAST_REDEMPTION_DATE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

export enum SubsidyMemberState {
  ACTIVE = 'ACTIVE',
  DENIED = 'DENIED',
  INVITED = 'INVITED',
  PENDING = 'PENDING',
  RESEND = 'RESEND',
  REVOKED = 'REVOKED'
}

export enum SubsidyNotificationFrequency {
  DAILY = 'DAILY',
  PER_REQUEST = 'PER_REQUEST'
}

export enum SubsidyPassDestination {
  /** Email a passes-PDF receipt to the requester */
  COPY_TO_ME = 'COPY_TO_ME',
  /** Email each pass to its recipient's address */
  EACH_RECIPIENT_EMAIL = 'EACH_RECIPIENT_EMAIL'
}

export enum SubsidyPassScope {
  /** All non-revoked guest passes across the account, spanning every program */
  ALL_ACTIVE = 'ALL_ACTIVE',
  /** All non-revoked passes in the given program (rule) */
  ALL_IN_PROGRAM = 'ALL_IN_PROGRAM',
  /** Only the passes named in pass_ids */
  SELECTED = 'SELECTED'
}

export enum SubsidyPassStatus {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
  REVOKED = 'REVOKED',
  SCHEDULED = 'SCHEDULED'
}

export type SubsidyRuleAttributes = {
  dailyMaxCents?: InputMaybe<Scalars['Int']['input']>;
  daysAvailable: Array<Day>;
  endsAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  product: SubsidyRuleProduct;
  programMaxCents?: InputMaybe<Scalars['Int']['input']>;
  startsAt: Scalars['ISO8601DateTime']['input'];
  timeZone: SubsidyTimezone;
  weeklyRecurrence: Scalars['Int']['input'];
};

export enum SubsidyRuleProduct {
  ALL_PRODUCTS = 'ALL_PRODUCTS',
  DELIVERY = 'DELIVERY',
  POPUP = 'POPUP'
}

export enum SubsidyRuleRule {
  CALCULATED = 'CALCULATED',
  FIXED_OFF = 'FIXED_OFF',
  FIXED_VALUE = 'FIXED_VALUE',
  KEY_IN = 'KEY_IN',
  PERCENTAGE_OFF = 'PERCENTAGE_OFF'
}

export enum SubsidyRuleState {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export enum SubsidyRuleTypeEnum {
  CALCULATED = 'CALCULATED',
  KEY_IN = 'KEY_IN'
}

export enum SubsidyStateEnum {
  SUBSIDY_CHECKED = 'SUBSIDY_CHECKED',
  SUBSIDY_DENIED = 'SUBSIDY_DENIED',
  SUBSIDY_PENDING = 'SUBSIDY_PENDING'
}

export enum SubsidyTimezone {
  ALASKA_TIME_ZONE = 'ALASKA_TIME_ZONE',
  AMSTERDAM_TIME_ZONE = 'AMSTERDAM_TIME_ZONE',
  ARIZONA_TIME_ZONE = 'ARIZONA_TIME_ZONE',
  CENTRAL_TIME_ZONE = 'CENTRAL_TIME_ZONE',
  EASTERN_TIME_ZONE = 'EASTERN_TIME_ZONE',
  HAWAII_TIME_ZONE = 'HAWAII_TIME_ZONE',
  INDIANA_TIME_ZONE = 'INDIANA_TIME_ZONE',
  LONDON_TIME_ZONE = 'LONDON_TIME_ZONE',
  MOUNTAIN_TIME_ZONE = 'MOUNTAIN_TIME_ZONE',
  PACIFIC_TIME_ZONE = 'PACIFIC_TIME_ZONE'
}

export enum SubsidyTypeEnum {
  ITEM_LEVEL = 'ITEM_LEVEL',
  ORDER_LEVEL = 'ORDER_LEVEL'
}

export type SyncPaidOrderRequest = {
  paymentGatewayInfo?: InputMaybe<PaymentGatewayInfo>;
  /** DEPRECATED: End of support in 2023 */
  paypalResponse?: InputMaybe<PaypalResponse>;
  requestId: Scalars['UUID']['input'];
};

export type SyncUnpaidOrderRequest = {
  paymentGatewayInfo?: InputMaybe<UnpaidPaymentGatewayInfo>;
  /** DEPRECATED: End of support in 2023 */
  paypalResponse?: InputMaybe<UnpaidPaypalResponse>;
  requestId: Scalars['UUID']['input'];
};

export enum TableauDomainEnum {
  AccountReportFFB = 'AccountReportFFB',
  AccountReportSnapPea = 'AccountReportSnapPea',
  VendorReportFFR = 'VendorReportFFR'
}

export enum TaxCategoryTypeEnum {
  /** Client charges */
  client_charges = 'client_charges',
  /** Client Fee */
  client_fee = 'client_fee',
  /** Food */
  food = 'food',
  /** Goods */
  goods = 'goods',
  /** Misc adjustments */
  misc_adjustments = 'misc_adjustments',
  /** Payment methods */
  payment_methods = 'payment_methods',
  /** Payment processing fee */
  payment_processing_fee = 'payment_processing_fee',
  /** Restaurant Charges */
  restaurant_charges = 'restaurant_charges',
  /** Services */
  services = 'services',
  /** Tax */
  tax = 'tax',
  /** Vouchers */
  vouchers = 'vouchers'
}

export enum TaxRemitter {
  FOODA = 'FOODA',
  RESTAURANT = 'RESTAURANT'
}

export enum TaxRuleRule {
  EXEMPT = 'EXEMPT',
  FIXED = 'FIXED',
  MANUAL = 'MANUAL',
  PERCENTAGE = 'PERCENTAGE'
}

export enum TaxRuleState {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

/** States for Tender Method */
export enum TenderMethodStateEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  SCHEDULED = 'SCHEDULED'
}

/** Term and description input */
export type TermsWithDescriptionInput = {
  description: Scalars['String']['input'];
  term: Scalars['String']['input'];
};

/** Supported Timezones */
export enum Timezone {
  /** Alaska Time */
  ALASKA_TIME_ZONE = 'ALASKA_TIME_ZONE',
  /** Amsterdam Time */
  AMSTERDAM_TIME_ZONE = 'AMSTERDAM_TIME_ZONE',
  /** Arizona Time */
  ARIZONA_TIME_ZONE = 'ARIZONA_TIME_ZONE',
  /** Central Time */
  CENTRAL_TIME_ZONE = 'CENTRAL_TIME_ZONE',
  /** Eastern Time */
  EASTERN_TIME_ZONE = 'EASTERN_TIME_ZONE',
  /** Hawaii Time */
  HAWAII_TIME_ZONE = 'HAWAII_TIME_ZONE',
  /** Indiana Time */
  INDIANA_TIME_ZONE = 'INDIANA_TIME_ZONE',
  /** London Time */
  LONDON_TIME_ZONE = 'LONDON_TIME_ZONE',
  /** Mountain Time */
  MOUNTAIN_TIME_ZONE = 'MOUNTAIN_TIME_ZONE',
  /** Pacific Time */
  PACIFIC_TIME_ZONE = 'PACIFIC_TIME_ZONE'
}

/** Arguments to remove a user from a vendor */
export type UnenrollUserFromVendor = {
  vendorMembershipId: Scalars['ID']['input'];
};

export type UnpaidPaymentGatewayInfo = {
  paymentGateway: PaymentGateway;
  response: UnpaidPaymentResponse;
};

export type UnpaidPaymentResponse = {
  /** The amount authorized by the payment processor */
  authorizedAmount: Scalars['Int']['input'];
  /** Payment response code */
  responseCode: Scalars['String']['input'];
  responseMessage?: InputMaybe<Scalars['String']['input']>;
  /** Unique payment reference */
  uniqueReference?: InputMaybe<Scalars['String']['input']>;
};

export type UnpaidPaypalResponse = {
  amountCents?: InputMaybe<Scalars['Int']['input']>;
  captureId?: InputMaybe<Scalars['String']['input']>;
  cardIssuer?: InputMaybe<CardIssuer>;
  cardholderName?: InputMaybe<Scalars['String']['input']>;
  correlationId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  lastFour?: InputMaybe<Scalars['String']['input']>;
  receiptPreferenceToken?: InputMaybe<Scalars['String']['input']>;
  responseCode?: InputMaybe<Scalars['Int']['input']>;
  transactionHandle?: InputMaybe<Scalars['String']['input']>;
  transactionNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Up Sell recommendation request */
export type UpSellRequestInput = {
  /** Menu item for up-sell recommendations */
  item: RecommendationItemInput;
};

/** Arguments to update an account membership */
export type UpdateAccountMembership = {
  id: Scalars['ID']['input'];
  permissions: Array<AccountPermission>;
  role?: InputMaybe<AccountRoleEnum>;
};

/** Input for updating account subsidy settings */
export type UpdateAccountSubsidySettings = {
  accountId: Scalars['ID']['input'];
  approvalAction?: InputMaybe<SubsidyApprovalAction>;
  approvalType?: InputMaybe<SubsidyApproval>;
  defaultRuleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  notificationFrequency?: InputMaybe<SubsidyNotificationFrequency>;
  rulePrivate?: InputMaybe<Scalars['Boolean']['input']>;
  sendEmailNotification?: InputMaybe<Scalars['Boolean']['input']>;
  whiteListedDomains?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateAuthenticationDomain = {
  accountsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  authenticationProviderId: Scalars['ID']['input'];
  connectionId?: InputMaybe<Scalars['String']['input']>;
  domainName: Scalars['String']['input'];
  effectiveDate: Scalars['ISO8601DateTime']['input'];
  id: Scalars['ID']['input'];
  listOfUsers?: InputMaybe<Array<Scalars['String']['input']>>;
  mobileSessionExpiration?: InputMaybe<Scalars['Int']['input']>;
  mobileSessionTimeout?: InputMaybe<Scalars['Int']['input']>;
  organization: Scalars['String']['input'];
  organizationName: Scalars['String']['input'];
  scimEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  testMode?: InputMaybe<Scalars['Boolean']['input']>;
  useLoginHint?: InputMaybe<Scalars['Boolean']['input']>;
  webSessionExpiration?: InputMaybe<Scalars['Int']['input']>;
  webSessionTimeout?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateBanner = {
  content?: InputMaybe<Scalars['String']['input']>;
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  /** Banner id to be updated */
  id: Scalars['ID']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<BannerPlatform>;
  style?: InputMaybe<UpdateStyle>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCafeEventMenuTileConfigurationInput = {
  cafeEventId: Scalars['ID']['input'];
  /** Menu Tiles to be updated */
  menuTiles: Array<CafeEventMenuTileInput>;
};

export type UpdateCafeEventSchedule = {
  attributes: UpdateCafeEventScheduleAttributes;
  cafeEventScheduleId: Scalars['ID']['input'];
};

export type UpdateCafeEventScheduleAttributes = {
  emailListId?: InputMaybe<Scalars['String']['input']>;
  eventEndTime?: InputMaybe<Scalars['Time']['input']>;
  eventEndTimeOffsetInDays?: InputMaybe<Scalars['Int']['input']>;
  eventScheduleOwnerId?: InputMaybe<Scalars['ID']['input']>;
  eventStartTime?: InputMaybe<Scalars['Time']['input']>;
  finalEmail?: InputMaybe<EmailConfigurationInput>;
  fixedPricePerConsumerCents?: InputMaybe<Scalars['Int']['input']>;
  introductionEmail?: InputMaybe<EmailConfigurationInput>;
  minSalesGuaranteeCents?: InputMaybe<Scalars['Int']['input']>;
  pauseEndDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  pauseStartDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  scheduleEndDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  scheduleFrequency?: InputMaybe<ScheduleFrequencyInput>;
  scheduleStartDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  siteManagementFeeConfig?: InputMaybe<SiteManagementFeeConfigInput>;
};

export type UpdateCafeEventScheduleMenuTiles = {
  cafeEventScheduleId: Scalars['ID']['input'];
  menuTiles: Array<CafeScheduleMenuTile>;
};

export type UpdateCafeEventScheduleStation = {
  attributes: UpdateCafeEventScheduleStationAttributes;
  cafeEventScheduleStationId: Scalars['ID']['input'];
};

export type UpdateCafeEventScheduleStationAttributes = {
  endTime?: InputMaybe<Scalars['Time']['input']>;
  endTimeOffsetInDays?: InputMaybe<Scalars['Int']['input']>;
  mealPeriod?: InputMaybe<MealPeriodEnum>;
  menuTemplateId?: InputMaybe<Scalars['ID']['input']>;
  pickupOrderingWindows?: InputMaybe<Array<PickupOrderingWindowInput>>;
  prepFor?: InputMaybe<Scalars['Int']['input']>;
  setupTimeMinutes?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['Time']['input']>;
  stationType?: InputMaybe<StationTypes>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCafeEventStation = {
  cafeEventStationAttributes: UpdateCafeEventStationAttributes;
  id: Scalars['ID']['input'];
};

export type UpdateCafeEventStationAttributes = {
  menuTemplateId?: InputMaybe<Scalars['ID']['input']>;
  prepFor?: InputMaybe<Scalars['Int']['input']>;
  prepForCalculated?: InputMaybe<Scalars['Int']['input']>;
  siteFeeCents?: InputMaybe<Scalars['Int']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type UpdateCafeLocation = {
  cafeLocationAttributes: UpdateCafeLocationAttributes;
  id: Scalars['ID']['input'];
};

export type UpdateCafeLocationAttributes = {
  accessibleToPublic?: InputMaybe<Scalars['Boolean']['input']>;
  audienceSize?: InputMaybe<Scalars['Int']['input']>;
  buildingId?: InputMaybe<Scalars['ID']['input']>;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  hideFromScheduling?: InputMaybe<Scalars['Boolean']['input']>;
  hideFromSearch?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCafeStation = {
  attributes?: InputMaybe<UpdateCafeStationAttributes>;
  cafeStationId: Scalars['ID']['input'];
};

export type UpdateCafeStationAttributes = {
  hideFromScheduling?: InputMaybe<Scalars['Boolean']['input']>;
  hideFromSelfCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  menuType?: InputMaybe<Menu>;
  mobileOrderCapacityPercentage?: InputMaybe<Scalars['Int']['input']>;
  mobileOrderingDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  mobileOrderingExtended?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCampaign = {
  bannerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  category?: InputMaybe<CampaignCategory>;
  endsAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  id: Scalars['ID']['input'];
  startsAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  strategy?: InputMaybe<CampaignStrategy>;
};

/** Arguments to update a card */
export type UpdateCard = {
  cardId: Scalars['ID']['input'];
  makeDefaultDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  nickname?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCateringInventoryItem = {
  attributes?: InputMaybe<UpdateCateringInventoryItemAttributes>;
  id: Scalars['ID']['input'];
};

export type UpdateCateringInventoryItemAttributes = {
  cogs?: InputMaybe<Scalars['BigDecimal']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dietaryRestrictions?: InputMaybe<Array<InventoryItemDietaryRestrictions>>;
  eligibleForAddOns?: InputMaybe<Scalars['Boolean']['input']>;
  externalTags?: InputMaybe<Array<InventoryItemExternalTags>>;
  feedsMax?: InputMaybe<Scalars['Int']['input']>;
  feedsMin?: InputMaybe<Scalars['Int']['input']>;
  foodaSku?: InputMaybe<Scalars['String']['input']>;
  internalTags?: InputMaybe<Array<InventoryItemInternalTags>>;
  mealType?: InputMaybe<InventoryItemMealType>;
  minSelfServiceQuantity?: InputMaybe<Scalars['Int']['input']>;
  nameForVendor?: InputMaybe<Scalars['String']['input']>;
  namePublic?: InputMaybe<Scalars['String']['input']>;
  packagingDetails?: InputMaybe<CateringPackagingDetails>;
  premiumCogs?: InputMaybe<Scalars['BigDecimal']['input']>;
  premiumSellPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  retailPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  sellPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  taxCategoryId?: InputMaybe<Scalars['Int']['input']>;
  useAsInventoryItemOption?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Arguments to update a cross-dock */
export type UpdateCrossDock = {
  address?: InputMaybe<AddressInput>;
  crossDockId: Scalars['ID']['input'];
  dropOffInstruction?: InputMaybe<Scalars['String']['input']>;
  marketIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  merchantId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  pickupInstruction?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CrossDockStatus>;
};

export type UpdateDeliveryInventoryItem = {
  attributes?: InputMaybe<UpdateDeliveryInventoryItemAttributes>;
  id: Scalars['ID']['input'];
};

export type UpdateDeliveryInventoryItemAttributes = {
  capacityExempt?: InputMaybe<Scalars['Boolean']['input']>;
  cogs?: InputMaybe<Scalars['BigDecimal']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dietaryRestrictions?: InputMaybe<Array<InventoryItemDietaryRestrictions>>;
  disallowWriteIn?: InputMaybe<Scalars['Boolean']['input']>;
  eligibleForAddOns?: InputMaybe<Scalars['Boolean']['input']>;
  externalTags?: InputMaybe<Array<InventoryItemExternalTags>>;
  foodaSku?: InputMaybe<Scalars['String']['input']>;
  internalTags?: InputMaybe<Array<InventoryItemInternalTags>>;
  mealType?: InputMaybe<InventoryItemMealType>;
  nameForVendor?: InputMaybe<Scalars['String']['input']>;
  namePublic?: InputMaybe<Scalars['String']['input']>;
  premiumSellPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  prepLine?: InputMaybe<Scalars['Int']['input']>;
  sellPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  showOnMenu?: InputMaybe<Scalars['Boolean']['input']>;
  signatureItem?: InputMaybe<Scalars['Boolean']['input']>;
  taxCategoryId?: InputMaybe<Scalars['Int']['input']>;
  temperatureClassification?: InputMaybe<InventoryItemTemperatureClassification>;
  useAsInventoryItemOption?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateDeliverySchedulingConstraint = {
  id: Scalars['ID']['input'];
  minManifestPerMonth: Scalars['Int']['input'];
};

export type UpdateDeliveryVendorMarketCapacity = {
  capacity: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};

export type UpdateFeedbackRequest = {
  feedbackRequestId: Scalars['ID']['input'];
  viewed: Scalars['Boolean']['input'];
};

/** Create or update the auto-topup configuration for a connected account */
export type UpdateFoodaCardAutoTopupSettings = {
  bankAccountId?: InputMaybe<Scalars['ID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  stripeAccountId: Scalars['ID']['input'];
  thresholdCents?: InputMaybe<Scalars['Int']['input']>;
  topupAmountCents?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateFoodaCardMembershipBackupCard = {
  /** The backup card (from Card model) to set */
  cardId: Scalars['ID']['input'];
  /** The membership to update */
  foodaCardMembershipId: Scalars['ID']['input'];
};

export type UpdateFoodaCardMembershipRequirements = {
  /** City */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Country code */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Day of birth (1-31) */
  dobDay?: InputMaybe<Scalars['Int']['input']>;
  /** Month of birth (1-12) */
  dobMonth?: InputMaybe<Scalars['Int']['input']>;
  /** Year of birth */
  dobYear?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the Fooda Card Membership */
  foodaCardMembershipId: Scalars['ID']['input'];
  /** Street address */
  line1?: InputMaybe<Scalars['String']['input']>;
  /** Apartment/unit */
  line2?: InputMaybe<Scalars['String']['input']>;
  /** Phone number in E.164 format */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Zip/postal code */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** State/Province */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Unix timestamp when user accepted terms */
  termsAcceptedAt?: InputMaybe<Scalars['Int']['input']>;
};

/** Arguments to update a FoodaCard program */
export type UpdateFoodaCardProgram = {
  foodaCardProgramAttributes: FoodaCardProgramAttributes;
  id: Scalars['ID']['input'];
};

export type UpdateHistoricalMealsSoldFactors = {
  endedEarlyFactor?: InputMaybe<EndedEarlyInput>;
  entreeSoldOutFactor?: InputMaybe<EntreeSoldOutInput>;
  popupEventVendorId: Scalars['ID']['input'];
};

/** Update Limits Group */
export type UpdateLimitsGroup = {
  deletedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  id: Scalars['ID']['input'];
  maxDailyCostCents?: InputMaybe<Scalars['Int']['input']>;
  maxMonthlyCostCents?: InputMaybe<Scalars['Int']['input']>;
  maxSessionCostCents?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Update Line Item Type */
export type UpdateLineItem = {
  eventFinanceLineItemType?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isAvailableForUser?: InputMaybe<Scalars['Boolean']['input']>;
  lineItemSubType?: InputMaybe<Scalars['String']['input']>;
  lineItemType?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  taxCategoryId?: InputMaybe<Scalars['Int']['input']>;
  taxCategoryType?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMarket = {
  accountingMarketName?: InputMaybe<Scalars['String']['input']>;
  active: Scalars['Boolean']['input'];
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  checkAverage?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  defaultAccountantId: Scalars['ID']['input'];
  defaultCrossDockId?: InputMaybe<Scalars['ID']['input']>;
  defaultOperationEmail?: InputMaybe<Scalars['String']['input']>;
  defaultTaxRate?: InputMaybe<Scalars['Float']['input']>;
  defaultTaxRemitter?: InputMaybe<TaxRemitter>;
  deliverySupportPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  directorId?: InputMaybe<Scalars['ID']['input']>;
  displayCommission: Scalars['Boolean']['input'];
  healthDepartmentJurisdictions?: InputMaybe<Array<HealthDepartmentJurisdictionInput>>;
  id: Scalars['ID']['input'];
  marketCohortName?: InputMaybe<Scalars['String']['input']>;
  marketManifestTime?: InputMaybe<MarketManifestTimeInput>;
  name: Scalars['String']['input'];
  noDefaultCrossDock?: InputMaybe<Scalars['Boolean']['input']>;
  officeDefaultEmail?: InputMaybe<Scalars['String']['input']>;
  officeDefaultFax?: InputMaybe<Scalars['String']['input']>;
  officeDefaultPhone?: InputMaybe<Scalars['String']['input']>;
  officeDefaultSms?: InputMaybe<Scalars['String']['input']>;
  popupSupportPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
  zipCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateMenuTemplateCategoryGroupAttributes = {
  name?: InputMaybe<Scalars['String']['input']>;
  selectedInventoryItems: Array<MenuTemplateInventoryItemAttributes>;
};

/** Update Model Configuration */
export type UpdateModelConfig = {
  id: Scalars['ID']['input'];
  /** Resolver-based prompt configuration with master_template, variables, model_params */
  promptConfig?: InputMaybe<PromptConfigInput>;
};

export type UpdatePartyBillingPolicy = {
  allowBillingEmails?: InputMaybe<Scalars['Boolean']['input']>;
  billingPatternClass?: InputMaybe<Scalars['String']['input']>;
  bufferDays?: InputMaybe<Scalars['Int']['input']>;
  checkbox?: InputMaybe<Scalars['Boolean']['input']>;
  customInvoiceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  invoiceCoverOnly?: InputMaybe<Scalars['Boolean']['input']>;
  invoicingNoteContent?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<PaymentMethodEnum>;
  paymentTerms?: InputMaybe<PaymentTermEnum>;
};

export type UpdatePopupInventoryItem = {
  attributes?: InputMaybe<UpdatePopupInventoryItemAttributes>;
  id: Scalars['ID']['input'];
  taxRuleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdatePopupInventoryItemAttributes = {
  availableInPersonOnly?: InputMaybe<Scalars['Boolean']['input']>;
  barcodeIdentifier?: InputMaybe<BarcodeInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  dietaryRestrictions?: InputMaybe<Array<InventoryItemDietaryRestrictions>>;
  disallowWriteIn?: InputMaybe<Scalars['Boolean']['input']>;
  externalTags?: InputMaybe<Array<InventoryItemExternalTags>>;
  foodaSku?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  mealType?: InputMaybe<InventoryItemMealType>;
  nameForVendor?: InputMaybe<Scalars['String']['input']>;
  namePublic?: InputMaybe<Scalars['String']['input']>;
  preTaxPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  priceType: PriceTypeEnum;
  showOnMenu?: InputMaybe<Scalars['Boolean']['input']>;
  showOnPos?: InputMaybe<Scalars['Boolean']['input']>;
  taxCategoryId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePopupMenuItemsAvailablity = {
  ids: Array<Scalars['ID']['input']>;
};

export type UpdatePopupMenuTemplate = {
  id: Scalars['ID']['input'];
  popupMenuTemplateAttributes: UpdatePopupMenuTemplateAttributes;
};

export type UpdatePopupMenuTemplateAttributes = {
  allowAsapOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  asapMinutes?: InputMaybe<Scalars['Int']['input']>;
  cuisines?: InputMaybe<Array<CuisineNames>>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  expectedPickupOrderPercentage?: InputMaybe<Scalars['Int']['input']>;
  hiddenFromCustomerCampaignsEmail?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenFromCustomerMenu?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenFromFfrMenu?: InputMaybe<Scalars['Boolean']['input']>;
  mealPeriods?: InputMaybe<Array<MealPeriodEnum>>;
  name?: InputMaybe<Scalars['String']['input']>;
  overrideSpotLocationCapacity?: InputMaybe<Scalars['Boolean']['input']>;
  residentVendorMenu?: InputMaybe<Scalars['Boolean']['input']>;
  schedulerConfig?: InputMaybe<PopupMenuTemplateSchedulerConfigInput>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  state?: InputMaybe<MenuTemplateStateEnum>;
};

export type UpdatePopupMenuTemplateCategoryGroup = {
  menuTemplateCategoryGroupAttributes: UpdateMenuTemplateCategoryGroupAttributes;
  menuTemplateGroupId: Scalars['ID']['input'];
};

export type UpdatePopupMenuTemplateInventoryItem = {
  attributes?: InputMaybe<PopupMenuTemplateInventoryItemAttributes>;
  id: Scalars['ID']['input'];
  taxRuleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdatePopupMenuTemplateSelectionGroup = {
  defaultSelectionInventoryItemId?: InputMaybe<Scalars['ID']['input']>;
  maxSelections: Scalars['Int']['input'];
  minSelections: Scalars['Int']['input'];
  nameForVendor: Scalars['String']['input'];
  namePublic: Scalars['String']['input'];
  selectedInventoryItems: Array<MenuTemplateSelectionGroupItemAttributes>;
  selectionGroupId: Scalars['ID']['input'];
};

/** Update Report Configuration input */
export type UpdateReportConfigurationInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  iconName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  menuTitle?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  reportType?: InputMaybe<ReportConfigurationTypeEnum>;
  requiredRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  tableauDesktopUrl?: InputMaybe<Scalars['String']['input']>;
  tableauMobileUrl?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<Array<TermsWithDescriptionInput>>;
};

/** Update Report Configuration order input */
export type UpdateReportsConfigurationsOrderQueryInput = {
  /** Menu titles of Reports Configurations in new order */
  menuTitles: Array<Scalars['String']['input']>;
};

export type UpdateScoringEventInput = {
  id: Scalars['ID']['input'];
  ignored: Scalars['Boolean']['input'];
};

export type UpdateScoringEventTypes = {
  scoringEventTypes: Array<ScoringEventTypeAttributes>;
};

export type UpdateSelectEventStatusInput = {
  id: Scalars['ID']['input'];
  status: SelectEventStatusEnum;
};

export type UpdateSelectEventVendor = {
  selectEventVendorAttributes: UpdateSelectEventVendorAttributes;
  selectEventVendorId: Scalars['ID']['input'];
};

export type UpdateSelectEventVendorAttributes = {
  cancelationRequestor?: InputMaybe<Scalars['String']['input']>;
  crossDockId?: InputMaybe<Scalars['ID']['input']>;
  deliveryVendorId?: InputMaybe<Scalars['ID']['input']>;
  menuTemplateId?: InputMaybe<Scalars['ID']['input']>;
  prepFor?: InputMaybe<Scalars['Int']['input']>;
  sendReceiptOnCancel?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Update UpdateShipFromBuildingsPerState */
export type UpdateShipFromBuildingsPerState = {
  buildingId?: InputMaybe<Scalars['ID']['input']>;
  countryCode: Scalars['String']['input'];
  stateCode: Scalars['String']['input'];
};

/** Arguments to update vendor employee */
export type UpdateSiteDirectionsNotificationsForVendorMembership = {
  siteDirectionsNotifications: Scalars['Boolean']['input'];
  vendorMembershipId: Scalars['ID']['input'];
};

export type UpdateStyle = {
  bodyTextColor?: InputMaybe<Scalars['String']['input']>;
  borderColor?: InputMaybe<Scalars['String']['input']>;
  fillColor?: InputMaybe<Scalars['String']['input']>;
  titleTextColor?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSubsidyMember = {
  accountId: Scalars['ID']['input'];
  members: Array<SubsidyMemberAttributes>;
  state: SubsidyMemberState;
};

export type UpdateSubsidyRule = {
  autoApply?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Send null explicitly to clear the override and revert to auto-generated
   * description. Omitting this field leaves the existing value unchanged.
   */
  coverageDescriptionOverride?: InputMaybe<Scalars['String']['input']>;
  dailyMaxCents?: InputMaybe<Scalars['Int']['input']>;
  daysAvailable?: InputMaybe<Array<Day>>;
  displayPreSubsidyPrice: Scalars['Boolean']['input'];
  endsAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  eventMaxCents?: InputMaybe<Scalars['Int']['input']>;
  externalTags?: InputMaybe<Array<InventoryItemExternalTags>>;
  hasFoodaCardProgram?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  locationRestriction?: InputMaybe<SubsidyLocationRestrictionEnum>;
  mealTypes?: InputMaybe<Array<InventoryItemMealType>>;
  minOrderCents?: InputMaybe<Scalars['Int']['input']>;
  monthlyMaxCents?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  percentageCap?: InputMaybe<Scalars['BigDecimal']['input']>;
  /**
   * Item-level only: when true, min_order_cents and event_max_cents are
   * interpreted as pre-tax. Omit to leave the existing value unchanged.
   */
  preTaxEmployeeContribution?: InputMaybe<Scalars['Boolean']['input']>;
  product?: InputMaybe<SubsidyRuleProduct>;
  /**
   * Max $ per user for the whole program (declining balance). Send null explicitly
   * to remove the cap; omitting this field leaves the existing value unchanged.
   */
  programMaxCents?: InputMaybe<Scalars['Int']['input']>;
  redemptionsPerDay?: InputMaybe<Scalars['Int']['input']>;
  ruleType?: InputMaybe<SubsidyRuleTypeEnum>;
  /**
   * Order-level QR member programs only: when true, members added to or joining
   * this program get an active subsidy without confirming their email first. Omit
   * to leave the existing value unchanged.
   */
  skipEmailVerification?: InputMaybe<Scalars['Boolean']['input']>;
  specificAccountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  startsAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  subsidyType?: InputMaybe<SubsidyTypeEnum>;
  supportedMealPeriods?: InputMaybe<Array<MealPeriodEnum>>;
  timeZone?: InputMaybe<SubsidyTimezone>;
  validEverywhere?: InputMaybe<Scalars['Boolean']['input']>;
  weeklyMaxCents?: InputMaybe<Scalars['Int']['input']>;
  weeklyRecurrence?: InputMaybe<Scalars['Int']['input']>;
};

/** Update Tax Category */
export type UpdateTaxCategory = {
  categoryType?: InputMaybe<TaxCategoryTypeEnum>;
  code?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isSync?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTemperatureLog = {
  cloudinaryResponse: CloudinaryResponseAttributes;
  temperatureLogId: Scalars['ID']['input'];
};

export type UpdateTenderMethodInput = {
  /** Account IDs that can use this tender method */
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Days of the week when tender method is available */
  daysAvailable?: InputMaybe<Array<Day>>;
  /** End date for the tender method */
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** External system identifier */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the tender method to update */
  id: Scalars['ID']['input'];
  /** Name of the tender method program */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Start date for the tender method */
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Timezone for the tender method */
  timezone?: InputMaybe<Timezone>;
};

export type UpdateUser = {
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  optOutOfRewards?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserNote = {
  id: Scalars['ID']['input'];
  note: Scalars['String']['input'];
};

export type UpdateUserNotificationDetails = {
  deviceId: Scalars['ID']['input'];
  pushId: Scalars['String']['input'];
  pushProviderId?: InputMaybe<Scalars['String']['input']>;
  pushProviderName?: InputMaybe<PushNotificationProviders>;
};

export type UpdateUserPhoneNumber = {
  digits: Scalars['String']['input'];
  verificationMethod: PhoneVerificationMethod;
};

/** Arguments to update a vendor employee permissions */
export type UpdateVendorEmployeePermissions = {
  employeePermissions: Array<EmployeePermission>;
  userId: Scalars['ID']['input'];
  vendorId: Scalars['ID']['input'];
};

export type UpdateVendorPopupCapacity = {
  /** Stored on the vendor's popup scheduling constraint */
  maxEventsPerDay?: InputMaybe<Scalars['Int']['input']>;
  /** Stored on the vendor's popup scheduling constraint */
  maxEventsPerWeek?: InputMaybe<Scalars['Int']['input']>;
  /** Other vendors sharing scheduling capacity with this vendor; empty removes it from any group */
  sharedCapacityVendorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The vendor whose Popup Capacity block is being saved */
  vendorId: Scalars['ID']['input'];
};

export enum UploadLinkDocument {
  SITE_DIRECTIONS = 'SITE_DIRECTIONS'
}

/** Type of user making request to API */
export enum UserContext {
  CUSTOMER = 'CUSTOMER',
  VENDOR = 'VENDOR'
}

/** Input for identifying a rewards user */
export type UserIdentifier =
  { phoneNumber: Scalars['PhoneNumberDigits']['input']; rewardsCode?: never; }
  |  { phoneNumber?: never; rewardsCode: Scalars['RewardsCode']['input']; };

export enum UserLegacyRoles {
  ACCOUNTING = 'ACCOUNTING',
  CATERING_FOODIZEN = 'CATERING_FOODIZEN',
  FOODA_EMPLOYEE = 'FOODA_EMPLOYEE',
  FOODIZEN = 'FOODIZEN',
  RESTAURANT = 'RESTAURANT',
  ROLE_ASSIGNMENT = 'ROLE_ASSIGNMENT',
  SUPER_ADMIN = 'SUPER_ADMIN'
}

export enum UserRoleScope {
  ACCOUNTING = 'ACCOUNTING',
  ALL = 'ALL'
}

export enum UserVerificationMethod {
  EMAIL = 'EMAIL',
  NONE = 'NONE',
  PHONE = 'PHONE'
}

export enum VendorEmployeePermission {
  AVAILABILITY_SUBMISSION = 'AVAILABILITY_SUBMISSION',
  CASHIER = 'CASHIER',
  CREW_MEMBER = 'CREW_MEMBER',
  MANAGER = 'MANAGER',
  PANTRY_MANAGER = 'PANTRY_MANAGER'
}

/** A vendor's lifecycle state */
export enum VendorState {
  active = 'active',
  inactive = 'inactive',
  onboarding = 'onboarding'
}

/** Complete microdeposit verification by submitting the two deposit amounts (in cents) */
export type VerifyFoodaCardBankAccount = {
  amounts: Array<Scalars['Int']['input']>;
  bankAccountId: Scalars['ID']['input'];
  stripeAccountId: Scalars['ID']['input'];
};

export enum WindowStatusEnum {
  /** Edit window has closed */
  LOCKED = 'LOCKED',
  /** Edit window is currently open */
  OPEN = 'OPEN'
}

export type WorldnetResponse = {
  /** The amount authorized by the payment processor */
  authorizedAmount: Scalars['Int']['input'];
  cardIssuer?: InputMaybe<Scalars['String']['input']>;
  cardholderName?: InputMaybe<Scalars['String']['input']>;
  /** Worldnet payment device serial number */
  deviceSerialNumber?: InputMaybe<Scalars['String']['input']>;
  /** The card's expiration date in the format MMYY */
  expiryDate?: InputMaybe<Scalars['String']['input']>;
  /** The card number masked with the character * */
  maskedPan?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  /** Transaction date and time */
  processingDateTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Transaction input method */
  processingMethod?: InputMaybe<Scalars['String']['input']>;
  /** Transaction result code */
  resultCode: Scalars['String']['input'];
  /** Worldnet per card unique reference */
  secureCardReference?: InputMaybe<Scalars['String']['input']>;
  /** The terminal number assigned by the gateway */
  terminal: Scalars['String']['input'];
  /** Unique payment reference limited by 10 characters */
  uniqueReference: Scalars['String']['input'];
};

export type checkReloginQueryVariables = Exact<{ [key: string]: never; }>;


export type checkReloginQuery = { __typename?: 'Query', checkReloginQuery?: { __typename?: 'CheckReloginQueryPayload', needsRelogin?: boolean | null, error?: { __typename?: 'OperationError', code: number, message: string, details?: Array<
        | { __typename?: 'CreateOrderItemsUnavailableErrorDetail', codeAsString: string, message: string }
        | { __typename?: 'CreateUserAccountErrorDetail', codeAsString: string, message: string }
        | { __typename?: 'MobileOrderingOrderRequestErrorDetail', codeAsString: string, message: string }
        | { __typename?: 'OrderRequestBlobErrorDetail', codeAsString: string, message: string }
        | { __typename?: 'OrderRequestErrorDetail', codeAsString: string, message: string }
      > | null } | null } | null };

export type ConfirmSiteDirectionsTokenMutationVariables = Exact<{
  digest: Scalars['String']['input'];
}>;


export type ConfirmSiteDirectionsTokenMutation = { __typename?: 'Mutation', confirmSiteDirectionsToken?: { __typename?: 'ConfirmSiteDirectionsTokenMutationPayload', siteDirectionsToken?: { __typename?: 'SiteDirectionsToken', id: string, state: SiteDirectionsTokenStateEnum, confirmed: boolean, digest: string } | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type CreateOmniauthSessionMutationVariables = Exact<{
  nonce: Scalars['String']['input'];
}>;


export type CreateOmniauthSessionMutation = { __typename?: 'Mutation', createSession?: { __typename?: 'CreateSessionPayload', session?: { __typename?: 'Session', token: string, firstTimeUserClientLogin: boolean, user: { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, uuid: string, vendors?: Array<{ __typename?: 'Vendor', id: string, name: string }> | null, lastLogins?: Array<{ __typename?: 'UserLoginRecord', time: any, client: { __typename?: 'ApiClient', label: string, token: string } }> | null } } | null, error?: { __typename?: 'OperationError', message: string } | null } | null };

export type fetchAccountQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type fetchAccountQuery = { __typename?: 'Query', getAccount?: { __typename?: 'GetAccountQueryPayload', account?: { __typename?: 'Account', id: string, name: string } | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type GetCalendarEventsListQueryVariables = Exact<{
  startTimeAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  startTimeBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  vendorIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetCalendarEventsListQuery = { __typename?: 'Query', searchEventVendors?: { __typename?: 'SearchEventVendorsQueryPayload', error?: { __typename?: 'OperationError', code: number, message: string } | null, eventVendors?: { __typename?: 'EventVendorConnection', nodes?: Array<
        | { __typename: 'CateringEventVendor', id: string, productType: EventProduct, vendor: { __typename?: 'Vendor', id: string, internalName: string }, event: { __typename?: 'CateringEventPublic', id: string, startTime: any, endTime?: any | null, status: EventStatus, name?: string | null, mealPeriod: MealPeriodEnum, setupTime?: any | null, account: { __typename?: 'AccountPublic', id: string, name: string }, location?: { __typename?: 'LocationPublic', id: string, name: string, building: { __typename?: 'BuildingPublic', id: string, name: string, address: { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, state: string, zipCode: string, country?: string | null } } } | null } }
        | { __typename: 'PopupEventVendor', confirmed: boolean, siteDirectionsEmailSent: boolean, id: string, productType: EventProduct, vendor: { __typename?: 'Vendor', id: string, internalName: string }, popupEvent: { __typename?: 'PopupEvent', id: string, status: string, startTime: any, endTime: any, account: { __typename?: 'Account', id: string, name: string } }, eventLocation?: { __typename?: 'PopupEventLocation', id: string, setupTime?: number | null, serviceStartTime?: any | null, location: { __typename?: 'Location', id: string, name: string, building: { __typename?: 'Building', id: string, name: string, address: { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, state: string, zipCode: string, country?: string | null } }, cafeLocation?: { __typename?: 'CafeLocation', id: string, name: string } | null } } | null }
        | { __typename: 'SelectEventVendor', aggregateManifestKey: string, foodDelivered: boolean, id: string, productType: EventProduct, vendor: { __typename?: 'Vendor', id: string, internalName: string }, preManifestDocument?: { __typename?: 'VendorManifestDocument', id: string, documentUrl?: string | null, status: string, confirmationUrl?: string | null, manifestDate?: any | null } | null, finalManifestDocument?: { __typename?: 'VendorManifestDocument', id: string, documentUrl?: string | null, status: string, confirmationUrl?: string | null, manifestDate?: any | null } | null, selectEvent: { __typename?: 'DeliveryEventPublic', id: string, status: EventStatus, readyAndBaggedTime: any, mealPeriod: MealPeriodEnum, startTime: any, endTime?: any | null, account: { __typename?: 'AccountPublic', id: string, name: string }, location?: { __typename?: 'LocationPublic', id: string, name: string, building: { __typename?: 'BuildingPublic', id: string, name: string, address: { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, state: string, zipCode: string, country?: string | null } } } | null } }
       | null> | null } | null } | null };

export type GetCalendarEventsQueryVariables = Exact<{
  startTimeAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  startTimeBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  vendorIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetCalendarEventsQuery = { __typename?: 'Query', searchEventVendors?: { __typename?: 'SearchEventVendorsQueryPayload', error?: { __typename?: 'OperationError', code: number, message: string } | null, eventVendors?: { __typename?: 'EventVendorConnection', nodes?: Array<
        | { __typename: 'CateringEventVendor', id: string, productType: EventProduct, vendor: { __typename?: 'Vendor', id: string, internalName: string }, event: { __typename?: 'CateringEventPublic', id: string, startTime: any, endTime?: any | null, status: EventStatus, name?: string | null, mealPeriod: MealPeriodEnum, setupTime?: any | null, account: { __typename?: 'AccountPublic', id: string, name: string }, location?: { __typename?: 'LocationPublic', id: string, name: string, building: { __typename?: 'BuildingPublic', id: string, name: string } } | null } }
        | { __typename: 'PopupEventVendor', confirmed: boolean, siteDirectionsEmailSent: boolean, id: string, productType: EventProduct, vendor: { __typename?: 'Vendor', id: string, internalName: string }, popupEvent: { __typename?: 'PopupEvent', id: string, status: string, startTime: any, endTime: any, account: { __typename?: 'Account', id: string, name: string } }, eventLocation?: { __typename?: 'PopupEventLocation', id: string, setupTime?: number | null, serviceStartTime?: any | null, location: { __typename?: 'Location', id: string, name: string, building: { __typename?: 'Building', id: string, name: string } } } | null }
        | { __typename: 'SelectEventVendor', aggregateManifestKey: string, foodDelivered: boolean, id: string, productType: EventProduct, vendor: { __typename?: 'Vendor', id: string, internalName: string }, preManifestDocument?: { __typename?: 'VendorManifestDocument', id: string, status: string, manifestDate?: any | null } | null, finalManifestDocument?: { __typename?: 'VendorManifestDocument', id: string, status: string, manifestDate?: any | null } | null, selectEvent: { __typename?: 'DeliveryEventPublic', id: string, status: EventStatus, readyAndBaggedTime: any, mealPeriod: MealPeriodEnum, startTime: any, endTime?: any | null, account: { __typename?: 'AccountPublic', id: string, name: string }, location?: { __typename?: 'LocationPublic', id: string, name: string, building: { __typename?: 'BuildingPublic', id: string, name: string } } | null } }
       | null> | null } | null } | null };

export type GetCompletedCateringEventDetailsQueryVariables = Exact<{
  input: GetEventVendorsInput;
}>;


export type GetCompletedCateringEventDetailsQuery = { __typename?: 'Query', getEventVendors?: { __typename?: 'GetEventVendorsQueryPayload', error?: { __typename?: 'OperationError', code: number, message: string } | null, eventVendors?: Array<
      | { __typename: 'CateringEventVendor', packingSlipConfirmed: boolean, purchaseOrderConfirmed: boolean, packingSlipUrl?: string | null, purchaseOrderUrl?: string | null, totalMenuLineItems: number, id: string, productType: EventProduct, vendor: { __typename?: 'Vendor', id: string, internalName: string, address?: { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, state: string, zipCode: string, country?: string | null } | null }, event: { __typename?: 'CateringEventPublic', id: string, name?: string | null, startTime: any, endTime?: any | null, status: EventStatus, setupTime?: any | null, account: { __typename?: 'AccountPublic', id: string, name: string }, location?: { __typename?: 'LocationPublic', id: string, name: string, building: { __typename?: 'BuildingPublic', id: string, name: string, address: { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, state: string, zipCode: string, country?: string | null } } } | null }, menuLineItems?: Array<{ __typename?: 'CateringMenuLineItem', id: number, name: string, quantity: number, unitPriceCents: number, totalPriceCents: number }> | null }
      | { __typename: 'PopupEventVendor', id: string, productType: EventProduct }
      | { __typename: 'SelectEventVendor', id: string, productType: EventProduct }
    > | null } | null };

export type GetCompletedDeliveryEventDetailsQueryVariables = Exact<{
  input: GetEventVendorsInput;
}>;


export type GetCompletedDeliveryEventDetailsQuery = { __typename?: 'Query', getEventVendors?: { __typename?: 'GetEventVendorsQueryPayload', error?: { __typename?: 'OperationError', code: number, message: string } | null, eventVendors?: Array<
      | { __typename: 'CateringEventVendor', id: string, productType: EventProduct }
      | { __typename: 'PopupEventVendor', id: string, productType: EventProduct }
      | { __typename: 'SelectEventVendor', configuredCapacity?: number | null, currentOrders: number, expectedOrders: number, summaryItemCount?: number | null, summaryOrderCount?: number | null, summaryFoodSalesCents?: number | null, summaryTaxCents?: number | null, summaryTaxRemittedByFoodaCents?: number | null, summaryCommissionCents?: number | null, summaryPpFeesCents?: number | null, summaryPreliminaryEventTotalCents?: number | null, id: string, productType: EventProduct, vendor: { __typename?: 'Vendor', id: string, internalName: string, address?: { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, state: string, zipCode: string, country?: string | null } | null }, menuTemplate: { __typename?: 'MenuTemplate', id: string }, selectEvent: { __typename?: 'DeliveryEventPublic', id: string, status: EventStatus, readyAndBaggedTime: any, mealPeriod: MealPeriodEnum, startTime: any, endTime?: any | null, account: { __typename?: 'AccountPublic', id: string, name: string }, location?: { __typename?: 'LocationPublic', id: string, name: string, building: { __typename?: 'BuildingPublic', id: string, name: string, address: { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, state: string, zipCode: string, country?: string | null } } } | null }, preManifestDocument?: { __typename?: 'VendorManifestDocument', id: string, documentType: string, documentUrl?: string | null, status: string, confirmationToken?: string | null, confirmationUrl?: string | null, manifestDate?: any | null } | null, finalManifestDocument?: { __typename?: 'VendorManifestDocument', id: string, documentType: string, documentUrl?: string | null, status: string, confirmationToken?: string | null, confirmationUrl?: string | null, manifestDate?: any | null } | null }
    > | null } | null };

export type GetCompletedEventsQueryVariables = Exact<{
  startTimeAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  startTimeBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  vendorIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetCompletedEventsQuery = { __typename?: 'Query', searchEventVendors?: { __typename?: 'SearchEventVendorsQueryPayload', error?: { __typename?: 'OperationError', code: number, message: string } | null, eventVendors?: { __typename?: 'EventVendorConnection', nodes?: Array<
        | { __typename: 'CateringEventVendor', id: string, productType: EventProduct, vendor: { __typename?: 'Vendor', id: string, internalName: string }, event: { __typename?: 'CateringEventPublic', name?: string | null, id: string, startTime: any, endTime?: any | null, status: EventStatus, setupTime?: any | null, account: { __typename?: 'AccountPublic', id: string, name: string }, location?: { __typename?: 'LocationPublic', id: string, name: string, building: { __typename?: 'BuildingPublic', id: string, name: string, address: { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, state: string, zipCode: string, country?: string | null } } } | null } }
        | { __typename: 'PopupEventVendor', id: string, productType: EventProduct, vendor: { __typename?: 'Vendor', id: string, internalName: string }, popupEvent: { __typename?: 'PopupEvent', id: string, status: string, startTime: any, endTime: any, account: { __typename?: 'Account', id: string, name: string } }, eventLocation?: { __typename?: 'PopupEventLocation', id: string, setupTime?: number | null, serviceStartTime?: any | null, location: { __typename?: 'Location', id: string, name: string, building: { __typename?: 'Building', id: string, name: string, address: { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, state: string, zipCode: string, country?: string | null } }, cafeLocation?: { __typename?: 'CafeLocation', id: string, name: string } | null } } | null }
        | { __typename: 'SelectEventVendor', aggregateManifestKey: string, foodDelivered: boolean, id: string, productType: EventProduct, vendor: { __typename?: 'Vendor', id: string, internalName: string }, selectEvent: { __typename?: 'DeliveryEventPublic', id: string, status: EventStatus, readyAndBaggedTime: any, startTime: any, endTime?: any | null, account: { __typename?: 'AccountPublic', id: string, name: string }, location?: { __typename?: 'LocationPublic', id: string, name: string, building: { __typename?: 'BuildingPublic', id: string, name: string, address: { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, state: string, zipCode: string, country?: string | null } } } | null } }
       | null> | null } | null } | null };

export type GetCompletedPopupEventDetailsQueryVariables = Exact<{
  input: GetEventVendorsInput;
}>;


export type GetCompletedPopupEventDetailsQuery = { __typename?: 'Query', getEventVendors?: { __typename?: 'GetEventVendorsQueryPayload', error?: { __typename?: 'OperationError', code: number, message: string } | null, eventVendors?: Array<
      | { __typename?: 'CateringEventVendor' }
      | { __typename?: 'PopupEventVendor', id: string, confirmed: boolean, productType: EventProduct, sales?: { __typename?: 'FinancialInfo', gfsCents: number, totalCashPaymentsCents: number, avgCustomerPaidCents: number, mealsSold: number, foodTopSales: Array<{ __typename?: 'FoodItemSale', cents: number, count: number, name: string, percentGfs: number }> } | null, mealPrep?: { __typename?: 'MealPrep', prepFor?: number | null } | null, vendor: { __typename?: 'Vendor', id: string, internalName: string, address?: { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, state: string, zipCode: string, country?: string | null } | null }, popupEvent: { __typename?: 'PopupEvent', id: string, status: string, productType: EventProduct, setupTime: number, startTime: any, endTime: any, account: { __typename?: 'Account', name: string } }, eventLocation?: { __typename?: 'PopupEventLocation', id: string, stationType?: StationTypes | null, setupTime?: number | null, serviceStartTime?: any | null, location: { __typename?: 'Location', id: string, name: string, buildingAddressNotes: string, cafeLocation?: { __typename?: 'CafeLocation', id: string, name: string } | null, building: { __typename?: 'Building', id: string, name: string, address: { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, state: string, zipCode: string, country?: string | null } } } } | null }
      | { __typename?: 'SelectEventVendor' }
    > | null } | null };

export type GetConfirmedEventsQueryVariables = Exact<{
  startTimeAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  startTimeBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  vendorIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetConfirmedEventsQuery = { __typename?: 'Query', searchEventVendors?: { __typename?: 'SearchEventVendorsQueryPayload', error?: { __typename?: 'OperationError', code: number, message: string } | null, eventVendors?: { __typename?: 'EventVendorConnection', nodes?: Array<
        | { __typename: 'CateringEventVendor', productType: EventProduct, id: string, vendor: { __typename?: 'Vendor', id: string, internalName: string }, event: { __typename?: 'CateringEventPublic', id: string, name?: string | null, startTime: any, endTime?: any | null, status: EventStatus, setupTime?: any | null, account: { __typename?: 'AccountPublic', id: string, name: string }, location?: { __typename?: 'LocationPublic', id: string, name: string, building: { __typename?: 'BuildingPublic', id: string, name: string, address: { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, state: string, zipCode: string, country?: string | null } } } | null } }
        | { __typename: 'PopupEventVendor', productType: EventProduct, id: string, vendor: { __typename?: 'Vendor', id: string, internalName: string }, popupEvent: { __typename?: 'PopupEvent', id: string, status: string, startTime: any, endTime: any, account: { __typename?: 'Account', id: string, name: string } }, eventLocation?: { __typename?: 'PopupEventLocation', id: string, setupTime?: number | null, location: { __typename?: 'Location', id: string, name: string, building: { __typename?: 'Building', id: string, name: string, address: { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, state: string, zipCode: string, country?: string | null } }, cafeLocation?: { __typename?: 'CafeLocation', id: string, name: string } | null } } | null }
        | { __typename: 'SelectEventVendor', aggregateManifestKey: string, productType: EventProduct, id: string, vendor: { __typename?: 'Vendor', id: string, internalName: string }, selectEvent: { __typename?: 'DeliveryEventPublic', id: string, status: EventStatus, readyAndBaggedTime: any, startTime: any, endTime?: any | null, account: { __typename?: 'AccountPublic', id: string, name: string }, location?: { __typename?: 'LocationPublic', id: string, name: string, building: { __typename?: 'BuildingPublic', id: string, name: string, address: { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, state: string, zipCode: string, country?: string | null } } } | null } }
       | null> | null } | null } | null };

export type GetEffectiveConsentPreferenceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEffectiveConsentPreferenceQuery = { __typename?: 'Query', effectiveConsentPreference?: { __typename?: 'EffectiveConsentPreferencePayload', error?: { __typename?: 'OperationError', code: number, message: string } | null, preference?: { __typename?: 'ConsentPreferenceSnapshot', consentGivenAt: any, preferences: Array<{ __typename?: 'ConsentPurposePreference', purpose: string, value: ConsentPreferenceValue }> } | null } | null };

export type GetFeatureFlagStateQueryVariables = Exact<{
  flag: Scalars['String']['input'];
}>;


export type GetFeatureFlagStateQuery = { __typename?: 'Query', getFeatureFlag?: { __typename?: 'GetFeatureFlagPayload', featureFlag?: { __typename?: 'FeatureFlag', enabled: boolean, name: string } | null, error?: { __typename?: 'OperationError', message: string, code: number } | null } | null };

export type GetFinancialInfoForVendorAtLocationQueryVariables = Exact<{
  input: GetFinancialInfoForVendorAtLocation;
}>;


export type GetFinancialInfoForVendorAtLocationQuery = { __typename?: 'Query', getFinancialInfoForVendorAtLocation?: { __typename?: 'GetFinancialInfoForVendorAtLocationQueryPayload', error?: { __typename?: 'OperationError', code: number, message: string } | null, sales?: { __typename?: 'FinancialInfo', foodTopSales: Array<{ __typename?: 'FoodItemSale', name: string, percentGfs: number }> } | null } | null };

export type GetManifestsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetManifestsQuery = { __typename?: 'Query', getTodayDeliveryManifests?: { __typename?: 'GetTodayDeliveryManifestsQueryPayload', deliveryManifests?: Array<{ __typename?: 'FfrDeliveryManifests', confirmUrl?: string | null, downloadPdfUrl?: string | null, manifestTime?: string | null, readyAndBaggedTime?: string | null, restaurantName: string, status?: string | null, version?: string | null, confirmationToken?: string | null, confirmationPreview?: boolean | null, manifestId: string }> | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type GetReportDetailsQueryVariables = Exact<{
  reportName: Scalars['String']['input'];
}>;


export type GetReportDetailsQuery = { __typename?: 'Query', getReportsConfigurations?: { __typename?: 'GetReportsConfigurationsQueryPayload', error?: { __typename?: 'OperationError', code: number, message: string } | null, reportsConfigurations?: Array<{ __typename?: 'ReportConfigurations', headline: string, subtitle: string, tableauDesktopUrl: string, tableauMobileUrl: string, terms?: Array<{ __typename?: 'TermsWithDescription', description: string, term: string }> | null }> | null } | null };

export type GetReportsListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReportsListQuery = { __typename?: 'Query', getReportsConfigurations?: { __typename?: 'GetReportsConfigurationsQueryPayload', error?: { __typename?: 'OperationError', code: number, message: string } | null, reportsConfigurations?: Array<{ __typename?: 'ReportConfigurations', menuTitle: string, iconName: string }> | null } | null };

export type GetSiteDirectionsTokenForUserQueryVariables = Exact<{
  input: GetSiteDirectionsTokenForUser;
}>;


export type GetSiteDirectionsTokenForUserQuery = { __typename?: 'Query', getSiteDirectionsTokenForUser?: { __typename?: 'GetSiteDirectionsTokenForUserQueryPayload', error?: { __typename?: 'OperationError', code: number, message: string } | null, siteDirectionsToken?: { __typename?: 'SiteDirectionsToken', confirmed: boolean, digest: string, id: string, state: SiteDirectionsTokenStateEnum } | null } | null };

export type GetTableauTokenQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetTableauTokenQuery = { __typename?: 'Query', getTableauToken?: { __typename?: 'GetTableauTokenQueryPayload', token?: string | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null, getUser?: { __typename?: 'GetUserQueryPayload', user?: { __typename?: 'User', uuid: string } | null } | null };

export type GetTodoTasksForVendorsQueryVariables = Exact<{
  vendorIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  expiresAfter: Scalars['ISO8601DateTime']['input'];
}>;


export type GetTodoTasksForVendorsQuery = { __typename?: 'Query', getTodoTasksForVendors?: { __typename?: 'GetTodoTasksForVendorsQueryPayload', error?: { __typename?: 'OperationError', code: number, message: string, details?: Array<
        | { __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string, codeAsString: string }
        | { __typename?: 'CreateUserAccountErrorDetail', message: string, codeAsString: string }
        | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string, codeAsString: string }
        | { __typename?: 'OrderRequestBlobErrorDetail', message: string, codeAsString: string }
        | { __typename?: 'OrderRequestErrorDetail', message: string, codeAsString: string }
      > | null } | null, todoTasks?: Array<{ __typename?: 'TodoTask', id: string, action: string, dueAt: any, expiresAt: any, ownerId: string, ownerType: OwnerTypeEnum, state: StateEnum, grouping: GroupingEnum, workItems: Array<
        | { __typename: 'PopupEventVendor', id: string, vendor: { __typename?: 'Vendor', internalName: string }, popupEvent: { __typename?: 'PopupEvent', id: string, productType: EventProduct, status: string, eventStartTime: any, eventEndTime: any, account: { __typename?: 'Account', name: string } }, eventLocation?: { __typename?: 'PopupEventLocation', id: string, serviceEndTime?: any | null, serviceStartTime?: any | null, setupTime?: number | null, stationType?: StationTypes | null, location: { __typename?: 'Location', name: string } } | null, location: { __typename?: 'Location', id: string, buildingAddressNotes: string } }
        | { __typename: 'SchedulingAvailabilityRequirement', id: string, productType: ProductEnum, month: number, year: number, vendor: { __typename?: 'Vendor', id: string, internalName: string } }
      > }> | null } | null };

export type GetUpcomingCateringEventDetailsQueryVariables = Exact<{
  input: GetEventVendorsInput;
}>;


export type GetUpcomingCateringEventDetailsQuery = { __typename?: 'Query', getEventVendors?: { __typename?: 'GetEventVendorsQueryPayload', error?: { __typename?: 'OperationError', code: number, message: string } | null, eventVendors?: Array<
      | { __typename: 'CateringEventVendor', packingSlipConfirmed: boolean, purchaseOrderConfirmed: boolean, packingSlipUrl?: string | null, purchaseOrderUrl?: string | null, id: string, productType: EventProduct, vendor: { __typename?: 'Vendor', id: string, internalName: string, address?: { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, state: string, zipCode: string, country?: string | null } | null }, event: { __typename?: 'CateringEventPublic', id: string, name?: string | null, startTime: any, endTime?: any | null, status: EventStatus, setupTime?: any | null, serviceStyle?: string | null, individualLabel: boolean, servingUtensils: boolean, utensilsPlatesNapkins: boolean, chaffingFrames: boolean, sternos: boolean, account: { __typename?: 'AccountPublic', id: string, name: string }, location?: { __typename?: 'LocationPublic', id: string, name: string, building: { __typename?: 'BuildingPublic', id: string, name: string, address: { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, state: string, zipCode: string, country?: string | null } } } | null } }
      | { __typename: 'PopupEventVendor', id: string, productType: EventProduct }
      | { __typename: 'SelectEventVendor', id: string, productType: EventProduct }
    > | null } | null };

export type GetUpcomingDeliveryEventDetailsQueryVariables = Exact<{
  input: GetEventVendorsInput;
}>;


export type GetUpcomingDeliveryEventDetailsQuery = { __typename?: 'Query', getEventVendors?: { __typename?: 'GetEventVendorsQueryPayload', error?: { __typename?: 'OperationError', code: number, message: string } | null, eventVendors?: Array<
      | { __typename: 'CateringEventVendor', id: string, productType: EventProduct }
      | { __typename: 'PopupEventVendor', id: string, productType: EventProduct }
      | { __typename: 'SelectEventVendor', configuredCapacity?: number | null, currentOrders: number, expectedOrders: number, summaryItemCount?: number | null, id: string, productType: EventProduct, vendor: { __typename?: 'Vendor', id: string, internalName: string, address?: { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, state: string, zipCode: string, country?: string | null } | null }, menuTemplate: { __typename?: 'MenuTemplate', id: string }, selectEvent: { __typename?: 'DeliveryEventPublic', id: string, status: EventStatus, readyAndBaggedTime: any, mealPeriod: MealPeriodEnum, startTime: any, endTime?: any | null, account: { __typename?: 'AccountPublic', id: string, name: string }, location?: { __typename?: 'LocationPublic', id: string, name: string, building: { __typename?: 'BuildingPublic', id: string, name: string, address: { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, state: string, zipCode: string, country?: string | null } } } | null }, preManifestDocument?: { __typename?: 'VendorManifestDocument', id: string, documentType: string, documentUrl?: string | null, status: string, confirmationToken?: string | null, confirmationUrl?: string | null, manifestDate?: any | null } | null, finalManifestDocument?: { __typename?: 'VendorManifestDocument', id: string, documentType: string, documentUrl?: string | null, status: string, confirmationToken?: string | null, confirmationUrl?: string | null, manifestDate?: any | null } | null }
    > | null } | null };

export type GetUpcomingPopupEventDetailsQueryVariables = Exact<{
  input: GetEventVendorsInput;
}>;


export type GetUpcomingPopupEventDetailsQuery = { __typename?: 'Query', getEventVendors?: { __typename?: 'GetEventVendorsQueryPayload', error?: { __typename?: 'OperationError', code: number, message: string } | null, eventVendors?: Array<
      | { __typename?: 'CateringEventVendor' }
      | { __typename?: 'PopupEventVendor', id: string, confirmed: boolean, productType: EventProduct, usesFoodaPos: boolean, historical?: Array<{ __typename?: 'PopupEventVendor', id: string, sales?: { __typename?: 'FinancialInfo', mealsSold: number } | null, popupEvent: { __typename?: 'PopupEvent', eventStartTime: any } }> | null, mealPrep?: { __typename?: 'MealPrep', prepFor?: number | null, factors?: Array<{ __typename?: 'MealPrepFactor', type: string, value?: string | null }> | null } | null, menuTemplate: { __typename?: 'PopupMenuTemplate', name?: string | null }, vendor: { __typename?: 'Vendor', id: string, internalName: string, address?: { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, state: string, zipCode: string, country?: string | null } | null }, popupEvent: { __typename?: 'PopupEvent', id: string, status: string, productType: EventProduct, setupTime: number, startTime: any, endTime: any, account: { __typename?: 'Account', name: string } }, eventLocation?: { __typename?: 'PopupEventLocation', id: string, setupTime?: number | null, serviceStartTime?: any | null, stationType?: StationTypes | null, location: { __typename?: 'Location', id: string, name: string, buildingAddressNotes: string, siteDirectionsDocUrl?: string | null, cafeLocation?: { __typename?: 'CafeLocation', id: string, name: string } | null, building: { __typename?: 'Building', id: string, name: string, address: { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, state: string, zipCode: string, country?: string | null } } } } | null }
      | { __typename?: 'SelectEventVendor' }
    > | null } | null };

export type getVendorPermissionsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  domains?: InputMaybe<Array<DomainEnum> | DomainEnum>;
  entityType?: InputMaybe<Scalars['String']['input']>;
}>;


export type getVendorPermissionsQuery = { __typename?: 'Query', getUser?: { __typename?: 'GetUserQueryPayload', user?: { __typename?: 'User', id: string, permissions?: Array<{ __typename?: 'PermissionDomain', domain: DomainEnum, entityId: string, entityType: string }> | null } | null } | null };

export type GetUserQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetUserQuery = { __typename?: 'Query', getUser?: { __typename?: 'GetUserQueryPayload', error?: { __typename?: 'OperationError', code: number, message: string } | null, user?: { __typename?: 'User', id: string, createdAt: any, email?: string | null, uuid: string, vendors?: Array<{ __typename?: 'Vendor', id: string, name: string }> | null } | null } | null };

export type GetVendorAvailabilityListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVendorAvailabilityListQuery = { __typename?: 'Query', getVendorAvailabilityList?: { __typename?: 'GetVendorAvailabilityListPayload', error?: { __typename?: 'OperationError', code: number, message: string } | null, vendors: Array<{ __typename?: 'VendorAvailabilityListItem', vendorId: string, internalName: string, markets: Array<string>, productType: ProductEnum, availabilityStatus: AvailabilityStatusEnum, submissionStatus: SubmissionStatusEnum, windowStatus: WindowStatusEnum, deadlineDate?: any | null, requiresSubmission: boolean, submission?: { __typename?: 'AvailabilitySubmissionMetadata', submittedAt?: any | null, submittedByEmail?: string | null, version?: number | null } | null }> } | null };

export type GetVendorAvailabilityQueryVariables = Exact<{
  input: GetVendorAvailabilityInput;
}>;


export type GetVendorAvailabilityQuery = { __typename?: 'Query', getVendorAvailability?: { __typename?: 'GetVendorAvailabilityPayload', error?: { __typename?: 'OperationError', code: number, message: string } | null, availability?: { __typename?: 'VendorAvailabilityDetail', submissionStatus: SubmissionStatusEnum, windowStatus: WindowStatusEnum, deadlineDate?: any | null, requiresSubmission: boolean, dates: Array<{ __typename?: 'AvailabilityDate', date: any, available: boolean }>, mealPeriods?: { __typename?: 'AvailabilityMealPeriods', breakfast: boolean, lunch: boolean, dinner: boolean, appetizers: boolean } | null, eligibleMealPeriods?: { __typename?: 'AvailabilityMealPeriods', breakfast: boolean, lunch: boolean, dinner: boolean, appetizers: boolean } | null, submission?: { __typename?: 'AvailabilitySubmissionMetadata', submittedAt?: any | null, submittedByEmail?: string | null, version?: number | null } | null } | null } | null };

export type GetVendorMenuTemplateQueryVariables = Exact<{
  input: GetVendorMenuTemplate;
  first?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetVendorMenuTemplateQuery = { __typename?: 'Query', getVendorMenuTemplate?: { __typename?: 'GetVendorMenuTemplatePayload', error?: { __typename?: 'OperationError', code: number, message: string } | null, menuTemplate?:
      | { __typename?: 'CateringVendorMenuTemplate', pricingType?: string | null, menuLevelPriceCents?: number | null, id: string, name?: string | null, productType: ProductEnum, state: MenuTemplateStateEnum, mealPeriods: Array<MealPeriodEnum>, recentlyUpdated: boolean, startDate: any, endDate?: any | null, updatedAt: any, categories: Array<{ __typename?: 'VendorMenuCategory', id: string, name?: string | null, position: number }>, items: { __typename?: 'VendorMenuItemConnection', totalCount: number, currentPage: number, nodes?: Array<
            | { __typename?: 'CateringVendorMenuItem', perPersonUpchargeCents?: number | null, id: string, namePublic: string, nameForVendor: string, description?: string | null, dietaryRestrictions: Array<string>, primaryImageUrl: string, images: Array<string>, preTaxPriceCents?: any | null, category?: { __typename?: 'VendorMenuCategory', id: string, name?: string | null, position: number } | null, optionGroups: Array<{ __typename?: 'VendorMenuOptionGroup', id: string, namePublic: string, nameForVendor: string, minSelections: number, maxSelections: number, includedSelections: number, options: Array<
                  | { __typename?: 'CateringVendorMenuOption', id: string, namePublic: string, nameForVendor: string, preTaxPriceCents?: any | null }
                  | { __typename?: 'DeliveryVendorMenuOption', id: string, namePublic: string, nameForVendor: string, preTaxPriceCents?: any | null }
                  | { __typename?: 'PopupVendorMenuOption', id: string, namePublic: string, nameForVendor: string, preTaxPriceCents?: any | null }
                > }> }
            | { __typename?: 'DeliveryVendorMenuItem', id: string, namePublic: string, nameForVendor: string, description?: string | null, dietaryRestrictions: Array<string>, primaryImageUrl: string, images: Array<string>, preTaxPriceCents?: any | null, category?: { __typename?: 'VendorMenuCategory', id: string, name?: string | null, position: number } | null, optionGroups: Array<{ __typename?: 'VendorMenuOptionGroup', id: string, namePublic: string, nameForVendor: string, minSelections: number, maxSelections: number, includedSelections: number, options: Array<
                  | { __typename?: 'CateringVendorMenuOption', id: string, namePublic: string, nameForVendor: string, preTaxPriceCents?: any | null }
                  | { __typename?: 'DeliveryVendorMenuOption', id: string, namePublic: string, nameForVendor: string, preTaxPriceCents?: any | null }
                  | { __typename?: 'PopupVendorMenuOption', id: string, namePublic: string, nameForVendor: string, preTaxPriceCents?: any | null }
                > }> }
            | { __typename?: 'PopupVendorMenuItem', id: string, namePublic: string, nameForVendor: string, description?: string | null, dietaryRestrictions: Array<string>, primaryImageUrl: string, images: Array<string>, preTaxPriceCents?: any | null, category?: { __typename?: 'VendorMenuCategory', id: string, name?: string | null, position: number } | null, optionGroups: Array<{ __typename?: 'VendorMenuOptionGroup', id: string, namePublic: string, nameForVendor: string, minSelections: number, maxSelections: number, includedSelections: number, options: Array<
                  | { __typename?: 'CateringVendorMenuOption', id: string, namePublic: string, nameForVendor: string, preTaxPriceCents?: any | null }
                  | { __typename?: 'DeliveryVendorMenuOption', id: string, namePublic: string, nameForVendor: string, preTaxPriceCents?: any | null }
                  | { __typename?: 'PopupVendorMenuOption', id: string, namePublic: string, nameForVendor: string, preTaxPriceCents?: any | null }
                > }> }
           | null> | null } }
      | { __typename?: 'DeliveryVendorMenuTemplate', id: string, name?: string | null, productType: ProductEnum, state: MenuTemplateStateEnum, mealPeriods: Array<MealPeriodEnum>, recentlyUpdated: boolean, startDate: any, endDate?: any | null, updatedAt: any, categories: Array<{ __typename?: 'VendorMenuCategory', id: string, name?: string | null, position: number }>, items: { __typename?: 'VendorMenuItemConnection', totalCount: number, currentPage: number, nodes?: Array<
            | { __typename?: 'CateringVendorMenuItem', perPersonUpchargeCents?: number | null, id: string, namePublic: string, nameForVendor: string, description?: string | null, dietaryRestrictions: Array<string>, primaryImageUrl: string, images: Array<string>, preTaxPriceCents?: any | null, category?: { __typename?: 'VendorMenuCategory', id: string, name?: string | null, position: number } | null, optionGroups: Array<{ __typename?: 'VendorMenuOptionGroup', id: string, namePublic: string, nameForVendor: string, minSelections: number, maxSelections: number, includedSelections: number, options: Array<
                  | { __typename?: 'CateringVendorMenuOption', id: string, namePublic: string, nameForVendor: string, preTaxPriceCents?: any | null }
                  | { __typename?: 'DeliveryVendorMenuOption', id: string, namePublic: string, nameForVendor: string, preTaxPriceCents?: any | null }
                  | { __typename?: 'PopupVendorMenuOption', id: string, namePublic: string, nameForVendor: string, preTaxPriceCents?: any | null }
                > }> }
            | { __typename?: 'DeliveryVendorMenuItem', id: string, namePublic: string, nameForVendor: string, description?: string | null, dietaryRestrictions: Array<string>, primaryImageUrl: string, images: Array<string>, preTaxPriceCents?: any | null, category?: { __typename?: 'VendorMenuCategory', id: string, name?: string | null, position: number } | null, optionGroups: Array<{ __typename?: 'VendorMenuOptionGroup', id: string, namePublic: string, nameForVendor: string, minSelections: number, maxSelections: number, includedSelections: number, options: Array<
                  | { __typename?: 'CateringVendorMenuOption', id: string, namePublic: string, nameForVendor: string, preTaxPriceCents?: any | null }
                  | { __typename?: 'DeliveryVendorMenuOption', id: string, namePublic: string, nameForVendor: string, preTaxPriceCents?: any | null }
                  | { __typename?: 'PopupVendorMenuOption', id: string, namePublic: string, nameForVendor: string, preTaxPriceCents?: any | null }
                > }> }
            | { __typename?: 'PopupVendorMenuItem', id: string, namePublic: string, nameForVendor: string, description?: string | null, dietaryRestrictions: Array<string>, primaryImageUrl: string, images: Array<string>, preTaxPriceCents?: any | null, category?: { __typename?: 'VendorMenuCategory', id: string, name?: string | null, position: number } | null, optionGroups: Array<{ __typename?: 'VendorMenuOptionGroup', id: string, namePublic: string, nameForVendor: string, minSelections: number, maxSelections: number, includedSelections: number, options: Array<
                  | { __typename?: 'CateringVendorMenuOption', id: string, namePublic: string, nameForVendor: string, preTaxPriceCents?: any | null }
                  | { __typename?: 'DeliveryVendorMenuOption', id: string, namePublic: string, nameForVendor: string, preTaxPriceCents?: any | null }
                  | { __typename?: 'PopupVendorMenuOption', id: string, namePublic: string, nameForVendor: string, preTaxPriceCents?: any | null }
                > }> }
           | null> | null } }
      | { __typename?: 'PopupVendorMenuTemplate', id: string, name?: string | null, productType: ProductEnum, state: MenuTemplateStateEnum, mealPeriods: Array<MealPeriodEnum>, recentlyUpdated: boolean, startDate: any, endDate?: any | null, updatedAt: any, categories: Array<{ __typename?: 'VendorMenuCategory', id: string, name?: string | null, position: number }>, items: { __typename?: 'VendorMenuItemConnection', totalCount: number, currentPage: number, nodes?: Array<
            | { __typename?: 'CateringVendorMenuItem', perPersonUpchargeCents?: number | null, id: string, namePublic: string, nameForVendor: string, description?: string | null, dietaryRestrictions: Array<string>, primaryImageUrl: string, images: Array<string>, preTaxPriceCents?: any | null, category?: { __typename?: 'VendorMenuCategory', id: string, name?: string | null, position: number } | null, optionGroups: Array<{ __typename?: 'VendorMenuOptionGroup', id: string, namePublic: string, nameForVendor: string, minSelections: number, maxSelections: number, includedSelections: number, options: Array<
                  | { __typename?: 'CateringVendorMenuOption', id: string, namePublic: string, nameForVendor: string, preTaxPriceCents?: any | null }
                  | { __typename?: 'DeliveryVendorMenuOption', id: string, namePublic: string, nameForVendor: string, preTaxPriceCents?: any | null }
                  | { __typename?: 'PopupVendorMenuOption', id: string, namePublic: string, nameForVendor: string, preTaxPriceCents?: any | null }
                > }> }
            | { __typename?: 'DeliveryVendorMenuItem', id: string, namePublic: string, nameForVendor: string, description?: string | null, dietaryRestrictions: Array<string>, primaryImageUrl: string, images: Array<string>, preTaxPriceCents?: any | null, category?: { __typename?: 'VendorMenuCategory', id: string, name?: string | null, position: number } | null, optionGroups: Array<{ __typename?: 'VendorMenuOptionGroup', id: string, namePublic: string, nameForVendor: string, minSelections: number, maxSelections: number, includedSelections: number, options: Array<
                  | { __typename?: 'CateringVendorMenuOption', id: string, namePublic: string, nameForVendor: string, preTaxPriceCents?: any | null }
                  | { __typename?: 'DeliveryVendorMenuOption', id: string, namePublic: string, nameForVendor: string, preTaxPriceCents?: any | null }
                  | { __typename?: 'PopupVendorMenuOption', id: string, namePublic: string, nameForVendor: string, preTaxPriceCents?: any | null }
                > }> }
            | { __typename?: 'PopupVendorMenuItem', id: string, namePublic: string, nameForVendor: string, description?: string | null, dietaryRestrictions: Array<string>, primaryImageUrl: string, images: Array<string>, preTaxPriceCents?: any | null, category?: { __typename?: 'VendorMenuCategory', id: string, name?: string | null, position: number } | null, optionGroups: Array<{ __typename?: 'VendorMenuOptionGroup', id: string, namePublic: string, nameForVendor: string, minSelections: number, maxSelections: number, includedSelections: number, options: Array<
                  | { __typename?: 'CateringVendorMenuOption', id: string, namePublic: string, nameForVendor: string, preTaxPriceCents?: any | null }
                  | { __typename?: 'DeliveryVendorMenuOption', id: string, namePublic: string, nameForVendor: string, preTaxPriceCents?: any | null }
                  | { __typename?: 'PopupVendorMenuOption', id: string, namePublic: string, nameForVendor: string, preTaxPriceCents?: any | null }
                > }> }
           | null> | null } }
     | null } | null };

export type GetVendorMenuTemplatesQueryVariables = Exact<{
  vendorId: Scalars['ID']['input'];
}>;


export type GetVendorMenuTemplatesQuery = { __typename?: 'Query', getVendorMenuTemplates?: { __typename?: 'GetVendorMenuTemplatesPayload', error?: { __typename?: 'OperationError', code: number, message: string } | null, menuTemplates?: Array<{ __typename?: 'MenuTemplateSummary', id: string, name?: string | null, productType: ProductEnum, state: MenuTemplateStateEnum, mealPeriods: Array<MealPeriodEnum>, recentlyUpdated: boolean, startDate: any, endDate?: any | null, updatedAt: any }> | null } | null };

export type RecordConsentPreferenceEventMutationVariables = Exact<{
  input: ConsentPreferenceEventInput;
}>;


export type RecordConsentPreferenceEventMutation = { __typename?: 'Mutation', recordConsentPreferenceEvent?: { __typename?: 'RecordConsentPreferenceEventPayload', eventId?: string | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type SendResetPasswordEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
  template: Scalars['String']['input'];
}>;


export type SendResetPasswordEmailMutation = { __typename?: 'Mutation', sendResetPasswordEmail?: { __typename?: 'SendResetPasswordEmailPayload', success: boolean, error?: { __typename?: 'OperationError', message: string } | null } | null };

export type SetNewPasswordMutationVariables = Exact<{
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetNewPasswordMutation = { __typename?: 'Mutation', setNewPassword?: { __typename?: 'SetNewPasswordPayload', error?: { __typename?: 'OperationError', message: string } | null } | null };

export type SubmitVendorAvailabilityMutationVariables = Exact<{
  input: SubmitVendorAvailabilityInput;
}>;


export type SubmitVendorAvailabilityMutation = { __typename?: 'Mutation', submitVendorAvailability?: { __typename?: 'SubmitVendorAvailabilityPayload', success?: boolean | null, error?: { __typename?: 'OperationError', code: number, message: string } | null, submission?: { __typename?: 'AvailabilitySubmissionMetadata', submittedAt?: any | null, submittedByEmail?: string | null, version?: number | null } | null } | null };


export const checkReloginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"checkRelogin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkReloginQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"needsRelogin"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<checkReloginQuery, checkReloginQueryVariables>;
export const ConfirmSiteDirectionsTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConfirmSiteDirectionsToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"digest"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmSiteDirectionsToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"digest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"digest"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteDirectionsToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"confirmed"}},{"kind":"Field","name":{"kind":"Name","value":"digest"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ConfirmSiteDirectionsTokenMutation, ConfirmSiteDirectionsTokenMutationVariables>;
export const CreateOmniauthSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOmniauthSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nonce"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nonce"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nonce"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"omniauthRequest"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"firstTimeUserClientLogin"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"vendors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"internalName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastLogins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"token"}}]}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateOmniauthSessionMutation, CreateOmniauthSessionMutationVariables>;
export const fetchAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<fetchAccountQuery, fetchAccountQueryVariables>;
export const GetCalendarEventsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCalendarEventsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startTimeAfter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startTimeBefore"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"vendorIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchEventVendors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"startTimeAfter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startTimeAfter"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startTimeBefore"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startTimeBefore"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"vendorIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"vendorIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"eventStatuses"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"SCHEDULED"},{"kind":"EnumValue","value":"ACTIVE"},{"kind":"EnumValue","value":"IN_PROGRESS"},{"kind":"EnumValue","value":"COMPLETE"},{"kind":"EnumValue","value":"FINAL"}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"perspective"},"value":{"kind":"EnumValue","value":"RESTAURANT"}},{"kind":"ObjectField","name":{"kind":"Name","value":"vendorStatuses"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ACTIVE"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventVendors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"500"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PopupEventVendor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmed"}},{"kind":"Field","name":{"kind":"Name","value":"siteDirectionsEmailSent"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"popupEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"startTime"},"name":{"kind":"Name","value":"eventStartTime"}},{"kind":"Field","alias":{"kind":"Name","value":"endTime"},"name":{"kind":"Name","value":"eventEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"setupTime"}},{"kind":"Field","name":{"kind":"Name","value":"serviceStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cafeLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectEventVendor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateManifestKey"}},{"kind":"Field","name":{"kind":"Name","value":"foodDelivered"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"preManifestDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"documentUrl"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"confirmationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"manifestDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"finalManifestDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"documentUrl"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"confirmationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"manifestDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"startTime"},"name":{"kind":"Name","value":"endTime"}},{"kind":"Field","alias":{"kind":"Name","value":"endTime"},"name":{"kind":"Name","value":"deliveryTime"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"readyAndBaggedTime"}},{"kind":"Field","name":{"kind":"Name","value":"mealPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CateringEventVendor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mealPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"setupTime"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCalendarEventsListQuery, GetCalendarEventsListQueryVariables>;
export const GetCalendarEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCalendarEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startTimeAfter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startTimeBefore"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"vendorIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchEventVendors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"startTimeAfter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startTimeAfter"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startTimeBefore"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startTimeBefore"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"vendorIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"vendorIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"eventStatuses"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"SCHEDULED"},{"kind":"EnumValue","value":"ACTIVE"},{"kind":"EnumValue","value":"IN_PROGRESS"},{"kind":"EnumValue","value":"COMPLETE"},{"kind":"EnumValue","value":"FINAL"}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"perspective"},"value":{"kind":"EnumValue","value":"RESTAURANT"}},{"kind":"ObjectField","name":{"kind":"Name","value":"vendorStatuses"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ACTIVE"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventVendors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"500"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PopupEventVendor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmed"}},{"kind":"Field","name":{"kind":"Name","value":"siteDirectionsEmailSent"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"popupEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"startTime"},"name":{"kind":"Name","value":"eventStartTime"}},{"kind":"Field","alias":{"kind":"Name","value":"endTime"},"name":{"kind":"Name","value":"eventEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"setupTime"}},{"kind":"Field","name":{"kind":"Name","value":"serviceStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectEventVendor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateManifestKey"}},{"kind":"Field","name":{"kind":"Name","value":"foodDelivered"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"preManifestDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"manifestDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"finalManifestDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"manifestDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"startTime"},"name":{"kind":"Name","value":"endTime"}},{"kind":"Field","alias":{"kind":"Name","value":"endTime"},"name":{"kind":"Name","value":"deliveryTime"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"readyAndBaggedTime"}},{"kind":"Field","name":{"kind":"Name","value":"mealPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CateringEventVendor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mealPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"setupTime"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCalendarEventsQuery, GetCalendarEventsQueryVariables>;
export const GetCompletedCateringEventDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCompletedCateringEventDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetEventVendorsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getEventVendors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventVendors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CateringEventVendor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"packingSlipConfirmed"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseOrderConfirmed"}},{"kind":"Field","name":{"kind":"Name","value":"packingSlipUrl"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseOrderUrl"}},{"kind":"Field","name":{"kind":"Name","value":"totalMenuLineItems"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"setupTime"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"menuLineItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unitPriceCents"}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceCents"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCompletedCateringEventDetailsQuery, GetCompletedCateringEventDetailsQueryVariables>;
export const GetCompletedDeliveryEventDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCompletedDeliveryEventDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetEventVendorsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getEventVendors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventVendors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectEventVendor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"configuredCapacity"}},{"kind":"Field","name":{"kind":"Name","value":"currentOrders"}},{"kind":"Field","name":{"kind":"Name","value":"expectedOrders"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"menuTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"startTime"},"name":{"kind":"Name","value":"endTime"}},{"kind":"Field","alias":{"kind":"Name","value":"endTime"},"name":{"kind":"Name","value":"deliveryTime"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"readyAndBaggedTime"}},{"kind":"Field","name":{"kind":"Name","value":"mealPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preManifestDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"}},{"kind":"Field","name":{"kind":"Name","value":"documentUrl"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"confirmationToken"}},{"kind":"Field","name":{"kind":"Name","value":"confirmationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"manifestDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"finalManifestDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"}},{"kind":"Field","name":{"kind":"Name","value":"documentUrl"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"confirmationToken"}},{"kind":"Field","name":{"kind":"Name","value":"confirmationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"manifestDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"summaryItemCount"}},{"kind":"Field","name":{"kind":"Name","value":"summaryOrderCount"}},{"kind":"Field","name":{"kind":"Name","value":"summaryFoodSalesCents"}},{"kind":"Field","name":{"kind":"Name","value":"summaryTaxCents"}},{"kind":"Field","name":{"kind":"Name","value":"summaryTaxRemittedByFoodaCents"}},{"kind":"Field","name":{"kind":"Name","value":"summaryCommissionCents"}},{"kind":"Field","name":{"kind":"Name","value":"summaryPpFeesCents"}},{"kind":"Field","name":{"kind":"Name","value":"summaryPreliminaryEventTotalCents"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCompletedDeliveryEventDetailsQuery, GetCompletedDeliveryEventDetailsQueryVariables>;
export const GetCompletedEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCompletedEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startTimeAfter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startTimeBefore"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"vendorIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchEventVendors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"startTimeAfter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startTimeAfter"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startTimeBefore"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startTimeBefore"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"vendorIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"vendorIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"eventStatuses"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"COMPLETE"},{"kind":"EnumValue","value":"FINAL"}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"vendorStatuses"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ACTIVE"}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"perspective"},"value":{"kind":"EnumValue","value":"RESTAURANT"}},{"kind":"ObjectField","name":{"kind":"Name","value":"includeLiveDeliveryStatus"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventVendors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PopupEventVendor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"popupEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"startTime"},"name":{"kind":"Name","value":"eventStartTime"}},{"kind":"Field","alias":{"kind":"Name","value":"endTime"},"name":{"kind":"Name","value":"eventEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"setupTime"}},{"kind":"Field","name":{"kind":"Name","value":"serviceStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cafeLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectEventVendor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateManifestKey"}},{"kind":"Field","name":{"kind":"Name","value":"foodDelivered"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"startTime"},"name":{"kind":"Name","value":"endTime"}},{"kind":"Field","alias":{"kind":"Name","value":"endTime"},"name":{"kind":"Name","value":"deliveryTime"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"readyAndBaggedTime"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CateringEventVendor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"setupTime"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCompletedEventsQuery, GetCompletedEventsQueryVariables>;
export const GetCompletedPopupEventDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCompletedPopupEventDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetEventVendorsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getEventVendors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventVendors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PopupEventVendor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"confirmed"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"sales"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gfsCents"}},{"kind":"Field","name":{"kind":"Name","value":"totalCashPaymentsCents"}},{"kind":"Field","name":{"kind":"Name","value":"avgCustomerPaidCents"}},{"kind":"Field","name":{"kind":"Name","value":"mealsSold"}},{"kind":"Field","name":{"kind":"Name","value":"foodTopSales"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cents"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"percentGfs"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mealPrep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prepFor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"popupEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","alias":{"kind":"Name","value":"startTime"},"name":{"kind":"Name","value":"eventStartTime"}},{"kind":"Field","alias":{"kind":"Name","value":"endTime"},"name":{"kind":"Name","value":"eventEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"setupTime"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stationType"}},{"kind":"Field","name":{"kind":"Name","value":"setupTime"}},{"kind":"Field","name":{"kind":"Name","value":"serviceStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"buildingAddressNotes"}},{"kind":"Field","name":{"kind":"Name","value":"cafeLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCompletedPopupEventDetailsQuery, GetCompletedPopupEventDetailsQueryVariables>;
export const GetConfirmedEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetConfirmedEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startTimeAfter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startTimeBefore"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"vendorIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchEventVendors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"startTimeAfter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startTimeAfter"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startTimeBefore"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startTimeBefore"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"vendorIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"vendorIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"confirmed"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"eventStatuses"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"SCHEDULED"},{"kind":"EnumValue","value":"ACTIVE"},{"kind":"EnumValue","value":"IN_PROGRESS"}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"vendorStatuses"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ACTIVE"}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"perspective"},"value":{"kind":"EnumValue","value":"RESTAURANT"}},{"kind":"ObjectField","name":{"kind":"Name","value":"includeLiveDeliveryStatus"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventVendors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PopupEventVendor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"popupEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"startTime"},"name":{"kind":"Name","value":"eventStartTime"}},{"kind":"Field","alias":{"kind":"Name","value":"endTime"},"name":{"kind":"Name","value":"eventEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"setupTime"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cafeLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectEventVendor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateManifestKey"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"selectEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"startTime"},"name":{"kind":"Name","value":"endTime"}},{"kind":"Field","alias":{"kind":"Name","value":"endTime"},"name":{"kind":"Name","value":"deliveryTime"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"readyAndBaggedTime"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CateringEventVendor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"setupTime"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetConfirmedEventsQuery, GetConfirmedEventsQueryVariables>;
export const GetEffectiveConsentPreferenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEffectiveConsentPreference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"effectiveConsentPreference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"preference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consentGivenAt"}},{"kind":"Field","name":{"kind":"Name","value":"preferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purpose"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetEffectiveConsentPreferenceQuery, GetEffectiveConsentPreferenceQueryVariables>;
export const GetFeatureFlagStateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFeatureFlagState"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"flag"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getFeatureFlag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"flag"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featureFlag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<GetFeatureFlagStateQuery, GetFeatureFlagStateQueryVariables>;
export const GetFinancialInfoForVendorAtLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFinancialInfoForVendorAtLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetFinancialInfoForVendorAtLocation"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getFinancialInfoForVendorAtLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sales"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"foodTopSales"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"4"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"percentGfs"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetFinancialInfoForVendorAtLocationQuery, GetFinancialInfoForVendorAtLocationQueryVariables>;
export const GetManifestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetManifests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getTodayDeliveryManifests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryManifests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmUrl"}},{"kind":"Field","name":{"kind":"Name","value":"downloadPdfUrl"}},{"kind":"Field","name":{"kind":"Name","value":"manifestTime"}},{"kind":"Field","name":{"kind":"Name","value":"readyAndBaggedTime"}},{"kind":"Field","name":{"kind":"Name","value":"restaurantName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"confirmationToken"}},{"kind":"Field","name":{"kind":"Name","value":"confirmationPreview"}},{"kind":"Field","name":{"kind":"Name","value":"manifestId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetManifestsQuery, GetManifestsQueryVariables>;
export const GetReportDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReportDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getReportsConfigurations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"application"},"value":{"kind":"EnumValue","value":"FOODA_FOR_RESTAURANTS"}},{"kind":"ObjectField","name":{"kind":"Name","value":"menuTitles"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"reportName"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportsConfigurations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"tableauDesktopUrl"}},{"kind":"Field","name":{"kind":"Name","value":"tableauMobileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"terms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"term"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetReportDetailsQuery, GetReportDetailsQueryVariables>;
export const GetReportsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReportsList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getReportsConfigurations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"application"},"value":{"kind":"EnumValue","value":"FOODA_FOR_RESTAURANTS"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportsConfigurations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"menuTitle"}},{"kind":"Field","name":{"kind":"Name","value":"iconName"}}]}}]}}]}}]} as unknown as DocumentNode<GetReportsListQuery, GetReportsListQueryVariables>;
export const GetSiteDirectionsTokenForUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSiteDirectionsTokenForUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetSiteDirectionsTokenForUser"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSiteDirectionsTokenForUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"siteDirectionsToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmed"}},{"kind":"Field","name":{"kind":"Name","value":"digest"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]}}]} as unknown as DocumentNode<GetSiteDirectionsTokenForUserQuery, GetSiteDirectionsTokenForUserQueryVariables>;
export const GetTableauTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTableauToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getTableauToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tableauDomain"},"value":{"kind":"EnumValue","value":"VendorReportFFR"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"getUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}}]}}]}}]}}]} as unknown as DocumentNode<GetTableauTokenQuery, GetTableauTokenQueryVariables>;
export const GetTodoTasksForVendorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTodoTasksForVendors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"vendorIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expiresAfter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601DateTime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getTodoTasksForVendors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"vendorIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"vendorIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"todoTaskStates"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"incomplete"}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"expiresAfter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expiresAfter"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"todoTasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"ownerType"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"grouping"}},{"kind":"Field","name":{"kind":"Name","value":"workItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PopupEventVendor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"popupEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"eventStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"eventEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serviceEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"serviceStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"setupTime"}},{"kind":"Field","name":{"kind":"Name","value":"stationType"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"buildingAddressNotes"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SchedulingAvailabilityRequirement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTodoTasksForVendorsQuery, GetTodoTasksForVendorsQueryVariables>;
export const GetUpcomingCateringEventDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUpcomingCateringEventDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetEventVendorsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getEventVendors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventVendors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CateringEventVendor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"packingSlipConfirmed"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseOrderConfirmed"}},{"kind":"Field","name":{"kind":"Name","value":"packingSlipUrl"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseOrderUrl"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"setupTime"}},{"kind":"Field","name":{"kind":"Name","value":"serviceStyle"}},{"kind":"Field","name":{"kind":"Name","value":"individualLabel"}},{"kind":"Field","name":{"kind":"Name","value":"servingUtensils"}},{"kind":"Field","name":{"kind":"Name","value":"utensilsPlatesNapkins"}},{"kind":"Field","name":{"kind":"Name","value":"chaffingFrames"}},{"kind":"Field","name":{"kind":"Name","value":"sternos"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUpcomingCateringEventDetailsQuery, GetUpcomingCateringEventDetailsQueryVariables>;
export const GetUpcomingDeliveryEventDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUpcomingDeliveryEventDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetEventVendorsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getEventVendors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventVendors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectEventVendor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"configuredCapacity"}},{"kind":"Field","name":{"kind":"Name","value":"currentOrders"}},{"kind":"Field","name":{"kind":"Name","value":"expectedOrders"}},{"kind":"Field","name":{"kind":"Name","value":"summaryItemCount"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"menuTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"startTime"},"name":{"kind":"Name","value":"endTime"}},{"kind":"Field","alias":{"kind":"Name","value":"endTime"},"name":{"kind":"Name","value":"deliveryTime"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"readyAndBaggedTime"}},{"kind":"Field","name":{"kind":"Name","value":"mealPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preManifestDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"}},{"kind":"Field","name":{"kind":"Name","value":"documentUrl"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"confirmationToken"}},{"kind":"Field","name":{"kind":"Name","value":"confirmationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"manifestDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"finalManifestDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"}},{"kind":"Field","name":{"kind":"Name","value":"documentUrl"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"confirmationToken"}},{"kind":"Field","name":{"kind":"Name","value":"confirmationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"manifestDate"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUpcomingDeliveryEventDetailsQuery, GetUpcomingDeliveryEventDetailsQueryVariables>;
export const GetUpcomingPopupEventDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUpcomingPopupEventDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetEventVendorsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getEventVendors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventVendors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PopupEventVendor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"confirmed"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"usesFoodaPos"}},{"kind":"Field","name":{"kind":"Name","value":"historical"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"5"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sales"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mealsSold"}}]}},{"kind":"Field","name":{"kind":"Name","value":"popupEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventStartTime"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mealPrep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prepFor"}},{"kind":"Field","name":{"kind":"Name","value":"factors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"menuTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"popupEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","alias":{"kind":"Name","value":"startTime"},"name":{"kind":"Name","value":"eventStartTime"}},{"kind":"Field","alias":{"kind":"Name","value":"endTime"},"name":{"kind":"Name","value":"eventEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"setupTime"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"setupTime"}},{"kind":"Field","name":{"kind":"Name","value":"serviceStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"stationType"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"buildingAddressNotes"}},{"kind":"Field","name":{"kind":"Name","value":"cafeLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"siteDirectionsDocUrl"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUpcomingPopupEventDetailsQuery, GetUpcomingPopupEventDetailsQueryVariables>;
export const getVendorPermissionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getVendorPermissions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"domains"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DomainEnum"}}}},"defaultValue":{"kind":"ListValue","values":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"permissions"},"name":{"kind":"Name","value":"permissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"entityType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityType"}}},{"kind":"Argument","name":{"kind":"Name","value":"domains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"domains"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"domain"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}}]}}]}}]}}]}}]} as unknown as DocumentNode<getVendorPermissionsQuery, getVendorPermissionsQueryVariables>;
export const GetUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"vendors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserQuery, GetUserQueryVariables>;
export const GetVendorAvailabilityListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVendorAvailabilityList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getVendorAvailabilityList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vendorId"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"markets"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"availabilityStatus"}},{"kind":"Field","name":{"kind":"Name","value":"submissionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"windowStatus"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}},{"kind":"Field","name":{"kind":"Name","value":"requiresSubmission"}},{"kind":"Field","name":{"kind":"Name","value":"submission"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"submittedByEmail"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetVendorAvailabilityListQuery, GetVendorAvailabilityListQueryVariables>;
export const GetVendorAvailabilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVendorAvailability"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetVendorAvailabilityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getVendorAvailability"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"available"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mealPeriods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"breakfast"}},{"kind":"Field","name":{"kind":"Name","value":"lunch"}},{"kind":"Field","name":{"kind":"Name","value":"dinner"}},{"kind":"Field","name":{"kind":"Name","value":"appetizers"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eligibleMealPeriods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"breakfast"}},{"kind":"Field","name":{"kind":"Name","value":"lunch"}},{"kind":"Field","name":{"kind":"Name","value":"dinner"}},{"kind":"Field","name":{"kind":"Name","value":"appetizers"}}]}},{"kind":"Field","name":{"kind":"Name","value":"submission"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"submittedByEmail"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"submissionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"windowStatus"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}},{"kind":"Field","name":{"kind":"Name","value":"requiresSubmission"}}]}}]}}]}}]} as unknown as DocumentNode<GetVendorAvailabilityQuery, GetVendorAvailabilityQueryVariables>;
export const GetVendorMenuTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVendorMenuTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetVendorMenuTemplate"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getVendorMenuTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"menuTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"mealPeriods"}},{"kind":"Field","name":{"kind":"Name","value":"recentlyUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CateringVendorMenuTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"menuLevelPriceCents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"namePublic"}},{"kind":"Field","name":{"kind":"Name","value":"nameForVendor"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"dietaryRestrictions"}},{"kind":"Field","name":{"kind":"Name","value":"primaryImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"images"}},{"kind":"Field","name":{"kind":"Name","value":"preTaxPriceCents"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CateringVendorMenuItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"perPersonUpchargeCents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"optionGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"namePublic"}},{"kind":"Field","name":{"kind":"Name","value":"nameForVendor"}},{"kind":"Field","name":{"kind":"Name","value":"minSelections"}},{"kind":"Field","name":{"kind":"Name","value":"maxSelections"}},{"kind":"Field","name":{"kind":"Name","value":"includedSelections"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"namePublic"}},{"kind":"Field","name":{"kind":"Name","value":"nameForVendor"}},{"kind":"Field","name":{"kind":"Name","value":"preTaxPriceCents"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetVendorMenuTemplateQuery, GetVendorMenuTemplateQueryVariables>;
export const GetVendorMenuTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVendorMenuTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"vendorId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getVendorMenuTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"vendorId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"vendorId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"menuTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"mealPeriods"}},{"kind":"Field","name":{"kind":"Name","value":"recentlyUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode<GetVendorMenuTemplatesQuery, GetVendorMenuTemplatesQueryVariables>;
export const RecordConsentPreferenceEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RecordConsentPreferenceEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConsentPreferenceEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordConsentPreferenceEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<RecordConsentPreferenceEventMutation, RecordConsentPreferenceEventMutationVariables>;
export const SendResetPasswordEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendResetPasswordEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"template"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendResetPasswordEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"template"},"value":{"kind":"Variable","name":{"kind":"Name","value":"template"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<SendResetPasswordEmailMutation, SendResetPasswordEmailMutationVariables>;
export const SetNewPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetNewPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"passwordConfirmation"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setNewPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"passwordConfirmation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"passwordConfirmation"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<SetNewPasswordMutation, SetNewPasswordMutationVariables>;
export const SubmitVendorAvailabilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitVendorAvailability"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SubmitVendorAvailabilityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitVendorAvailability"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"submission"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"submittedByEmail"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]}}]} as unknown as DocumentNode<SubmitVendorAvailabilityMutation, SubmitVendorAvailabilityMutationVariables>;